/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 50);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(26)('wks');
var uid = __webpack_require__(18);
var Symbol = __webpack_require__(0).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(5);
var createDesc = __webpack_require__(17);
module.exports = __webpack_require__(7) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(3);
var IE8_DOM_DEFINE = __webpack_require__(34);
var toPrimitive = __webpack_require__(23);
var dP = Object.defineProperty;

exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(16)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(61);
var defined = __webpack_require__(21);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var ctx = __webpack_require__(14);
var hide = __webpack_require__(4);
var has = __webpack_require__(8);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(15);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(5).f;
var has = __webpack_require__(8);
var TAG = __webpack_require__(1)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(6);
var document = __webpack_require__(0).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(6);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(37);
var enumBugKeys = __webpack_require__(27);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(26)('keys');
var uid = __webpack_require__(18);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(2);
var global = __webpack_require__(0);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(10) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(1);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var LIBRARY = __webpack_require__(10);
var wksExt = __webpack_require__(28);
var defineProperty = __webpack_require__(5).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(15);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(58)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(33)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(10);
var $export = __webpack_require__(11);
var redefine = __webpack_require__(35);
var hide = __webpack_require__(4);
var Iterators = __webpack_require__(12);
var $iterCreate = __webpack_require__(59);
var setToStringTag = __webpack_require__(19);
var getPrototypeOf = __webpack_require__(64);
var ITERATOR = __webpack_require__(1)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(7) && !__webpack_require__(16)(function () {
  return Object.defineProperty(__webpack_require__(22)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(3);
var dPs = __webpack_require__(60);
var enumBugKeys = __webpack_require__(27);
var IE_PROTO = __webpack_require__(25)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(22)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(39).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(8);
var toIObject = __webpack_require__(9);
var arrayIndexOf = __webpack_require__(62)(false);
var IE_PROTO = __webpack_require__(25)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(20);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(0).document;
module.exports = document && document.documentElement;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(66);
var global = __webpack_require__(0);
var hide = __webpack_require__(4);
var Iterators = __webpack_require__(12);
var TO_STRING_TAG = __webpack_require__(1)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 41 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(37);
var hiddenKeys = __webpack_require__(27).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {



/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(79), __esModule: true };

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(13);
var TAG = __webpack_require__(1)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(3);
var aFunction = __webpack_require__(15);
var SPECIES = __webpack_require__(1)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(14);
var invoke = __webpack_require__(86);
var html = __webpack_require__(39);
var cel = __webpack_require__(22);
var global = __webpack_require__(0);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(13)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(3);
var isObject = __webpack_require__(6);
var newPromiseCapability = __webpack_require__(31);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var $ = __webpack_require__(51);
var apiUser = __webpack_require__(52);
var style = __webpack_require__(100);
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1));
    var sURLVariables = sPageURL.split("&");
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split("=");
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};
$(function () {
    $(".main_form").submit(function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var pass1 = $("#pass1").val();
        var pass2 = $("#pass2").val();
        if (pass1 !== pass2) {
            $(".repeated").addClass("invalid");
        } else {
            $(".flash").addClass("hidden");
            $(".repeated").removeClass("invalid");
            switch (getUrlParameter("type")) {
                case "user":
                default:
                    {
                        if (!getUrlParameter("isStaging")) {
                            apiUser.setUrl("https://api.meuloc.com/user");
                        } else {
                            apiUser.setUrl("https://api.meuloc.com/user-staging");
                        }
                        apiUser.resetPassword(getUrlParameter("token"), pass1).then(function () {
                            $(".main_form").addClass("hidden");
                            $(".success_form").removeClass("hidden");
                            window.location.replace("https://meuloc.com");
                        }).catch(function (err) {
                            console.error(err);
                            $(".flash").removeClass("hidden");
                            $(".main_form").addClass("shakeAnimation");
                            setTimeout(function () {
                                return $(".main_form").addClass("shakeAnimation");
                            }, 820);
                        });
                    }
            }
        }
    });
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(53);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(55);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(44);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(94);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(97);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getLocker = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ownerId, pagination, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        args = {
                            ownerId: ownerId === null || ownerId === undefined ? null : ownerId,
                            pagination: pagination === null || pagination === undefined ? null : {
                                pageNumber: pagination.pageNumber || 0
                            }
                        };
                        _context.next = 3;
                        return makeRequest({ name: "getLocker", args: args, progress: progress });

                    case 3:
                        ret = _context.sent;
                        return _context.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                department: e.department,
                                ownerId: e.ownerId,
                                likes: e.likes || 0,
                                liked: !!e.liked,
                                address: {
                                    neighborhood: e.address.neighborhood,
                                    city: e.address.city,
                                    uf: e.address.uf,
                                    country: e.address.country,
                                    location: {
                                        lat: e.address.location.lat,
                                        lon: e.address.location.lon
                                    }
                                },
                                ownerInfo: {
                                    id: e.ownerInfo.id,
                                    avatar: e.ownerInfo.avatar === null || e.ownerInfo.avatar === undefined ? null : {
                                        width: e.ownerInfo.avatar.width || 0,
                                        height: e.ownerInfo.avatar.height || 0,
                                        url: e.ownerInfo.avatar.url
                                    },
                                    name: e.ownerInfo.name,
                                    rate: e.ownerInfo.rate,
                                    height: e.ownerInfo.height === null || e.ownerInfo.height === undefined ? null : e.ownerInfo.height || 0,
                                    deleted: !!e.ownerInfo.deleted,
                                    ownerName: e.ownerInfo.ownerName === null || e.ownerInfo.ownerName === undefined ? null : e.ownerInfo.ownerName
                                },
                                calendar: e.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                adjustment: !!e.adjustment,
                                category: e.category === null || e.category === undefined ? null : e.category,
                                color: e.color === null || e.color === undefined ? null : e.color,
                                details: e.details,
                                gender: e.gender,
                                thumbImage: {
                                    width: e.thumbImage.width || 0,
                                    height: e.thumbImage.height || 0,
                                    url: e.thumbImage.url
                                },
                                images: e.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: e.brand === null || e.brand === undefined ? null : e.brand,
                                ocasions: e.ocasions.map(function (e) {
                                    return e === null || e === undefined ? null : e;
                                }),
                                rentPrice: e.rentPrice || 0,
                                originalPrice: e.originalPrice || 0,
                                size: e.size === null || e.size === undefined ? null : e.size
                            };
                        }));

                    case 5:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getLocker(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var getProfileStats = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(userId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        args = {
                            userId: userId === null || userId === undefined ? null : userId
                        };
                        _context2.next = 3;
                        return makeRequest({ name: "getProfileStats", args: args, progress: progress });

                    case 3:
                        ret = _context2.sent;
                        return _context2.abrupt("return", {
                            numberOfItems: ret.numberOfItems || 0,
                            numberOfRents: ret.numberOfRents || 0,
                            numberOfMyRents: ret.numberOfMyRents || 0,
                            rating: ret.rating
                        });

                    case 5:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function getProfileStats(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

var uploadImage = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(image, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        args = {
                            image: image.toString("base64")
                        };
                        _context3.next = 3;
                        return makeRequest({ name: "uploadImage", args: args, progress: progress });

                    case 3:
                        ret = _context3.sent;
                        return _context3.abrupt("return", {
                            width: ret.width || 0,
                            height: ret.height || 0,
                            url: ret.url
                        });

                    case 5:
                    case "end":
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function uploadImage(_x6, _x7) {
        return _ref3.apply(this, arguments);
    };
}();

var uploadThumb = function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(image, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        args = {
                            image: image.toString("base64")
                        };
                        _context4.next = 3;
                        return makeRequest({ name: "uploadThumb", args: args, progress: progress });

                    case 3:
                        ret = _context4.sent;
                        return _context4.abrupt("return", {
                            thumbImage: {
                                width: ret.thumbImage.width || 0,
                                height: ret.thumbImage.height || 0,
                                url: ret.thumbImage.url
                            },
                            image: {
                                width: ret.image.width || 0,
                                height: ret.image.height || 0,
                                url: ret.image.url
                            }
                        });

                    case 5:
                    case "end":
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function uploadThumb(_x8, _x9) {
        return _ref4.apply(this, arguments);
    };
}();

var getAddressFromCep = function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(zip, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        args = {
                            zip: zip
                        };
                        _context5.next = 3;
                        return makeRequest({ name: "getAddressFromCep", args: args, progress: progress });

                    case 3:
                        ret = _context5.sent;
                        return _context5.abrupt("return", ret === null || ret === undefined ? null : {
                            street: ret.street,
                            neighborhood: ret.neighborhood,
                            city: ret.city,
                            state: ret.state,
                            uf: ret.uf,
                            country: ret.country,
                            zip: ret.zip,
                            location: {
                                lat: ret.location.lat,
                                lon: ret.location.lon
                            }
                        });

                    case 5:
                    case "end":
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function getAddressFromCep(_x10, _x11) {
        return _ref5.apply(this, arguments);
    };
}();

var getCpfValidate = function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(cpf, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        args = {
                            cpf: cpf
                        };
                        _context6.next = 3;
                        return makeRequest({ name: "getCpfValidate", args: args, progress: progress });

                    case 3:
                        return _context6.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function getCpfValidate(_x12, _x13) {
        return _ref6.apply(this, arguments);
    };
}();

var getMyLocation = function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return makeRequest({ name: "getMyLocation", args: {}, progress: progress });

                    case 2:
                        ret = _context7.sent;
                        return _context7.abrupt("return", ret === null || ret === undefined ? null : {
                            lat: ret.lat,
                            lon: ret.lon
                        });

                    case 4:
                    case "end":
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function getMyLocation(_x14) {
        return _ref7.apply(this, arguments);
    };
}();

var registerUser = function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(user, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        args = {
                            user: {
                                nick: user.nick,
                                name: user.name,
                                providorInfo: user.providorInfo === null || user.providorInfo === undefined ? null : {
                                    providor: user.providorInfo.providor,
                                    idToken: user.providorInfo.idToken,
                                    acessToken: user.providorInfo.acessToken === null || user.providorInfo.acessToken === undefined ? null : user.providorInfo.acessToken
                                },
                                password: user.password === null || user.password === undefined ? null : user.password,
                                email: user.email,
                                birthday: user.birthday === null || user.birthday === undefined ? null : typeof user.birthday === "string" ? new Date(new Date(user.birthday).getTime() - new Date(user.birthday).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(user.birthday.getTime() - user.birthday.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                height: user.height === null || user.height === undefined ? null : user.height || 0,
                                avatar: user.avatar === null || user.avatar === undefined ? null : {
                                    width: user.avatar.width || 0,
                                    height: user.avatar.height || 0,
                                    url: user.avatar.url
                                },
                                avatarImage: user.avatarImage === null || user.avatarImage === undefined ? null : user.avatarImage.toString("base64"),
                                gender: user.gender === null || user.gender === undefined ? null : user.gender,
                                cpf: user.cpf,
                                phone: {
                                    ddd: user.phone.ddd,
                                    ddi: user.phone.ddi,
                                    number: user.phone.number
                                }
                            }
                        };
                        _context8.next = 3;
                        return makeRequest({ name: "registerUser", args: args, progress: progress });

                    case 3:
                        ret = _context8.sent;
                        return _context8.abrupt("return", {
                            id: ret.id,
                            nick: ret.nick,
                            name: ret.name,
                            birthday: ret.birthday === null || ret.birthday === undefined ? null : new Date(parseInt(ret.birthday.split("-")[0], 10), parseInt(ret.birthday.split("-")[1], 10) - 1, parseInt(ret.birthday.split("-")[2], 10)),
                            cpf: ret.cpf,
                            email: ret.email,
                            height: ret.height === null || ret.height === undefined ? null : ret.height || 0,
                            gender: ret.gender === null || ret.gender === undefined ? null : ret.gender,
                            phone: {
                                ddd: ret.phone.ddd,
                                ddi: ret.phone.ddi,
                                number: ret.phone.number
                            },
                            avatar: ret.avatar === null || ret.avatar === undefined ? null : {
                                width: ret.avatar.width || 0,
                                height: ret.avatar.height || 0,
                                url: ret.avatar.url
                            },
                            address: ret.address === null || ret.address === undefined ? null : {
                                street: ret.address.street,
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                number: ret.address.number,
                                zip: ret.address.zip,
                                adicionalInfo: ret.address.adicionalInfo,
                                reference: ret.address.reference,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            cards: ret.cards.map(function (e) {
                                return {
                                    id: e.id,
                                    lastDigits: e.lastDigits,
                                    brand: e.brand,
                                    exp: e.exp
                                };
                            }),
                            bankAccount: ret.bankAccount === null || ret.bankAccount === undefined ? null : {
                                documentNumber: ret.bankAccount.documentNumber,
                                bankName: ret.bankAccount.bankName,
                                bankCode: ret.bankAccount.bankCode,
                                agency: ret.bankAccount.agency,
                                agencyDv: ret.bankAccount.agencyDv,
                                account: ret.bankAccount.account,
                                accountDv: ret.bankAccount.accountDv,
                                type: ret.bankAccount.type,
                                legalName: ret.bankAccount.legalName
                            }
                        });

                    case 5:
                    case "end":
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function registerUser(_x15, _x16) {
        return _ref8.apply(this, arguments);
    };
}();

var login = function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(email, password, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        args = {
                            email: email,
                            password: password
                        };
                        _context9.next = 3;
                        return makeRequest({ name: "login", args: args, progress: progress });

                    case 3:
                        ret = _context9.sent;
                        return _context9.abrupt("return", {
                            id: ret.id,
                            nick: ret.nick,
                            name: ret.name,
                            birthday: ret.birthday === null || ret.birthday === undefined ? null : new Date(parseInt(ret.birthday.split("-")[0], 10), parseInt(ret.birthday.split("-")[1], 10) - 1, parseInt(ret.birthday.split("-")[2], 10)),
                            cpf: ret.cpf,
                            email: ret.email,
                            height: ret.height === null || ret.height === undefined ? null : ret.height || 0,
                            gender: ret.gender === null || ret.gender === undefined ? null : ret.gender,
                            phone: {
                                ddd: ret.phone.ddd,
                                ddi: ret.phone.ddi,
                                number: ret.phone.number
                            },
                            avatar: ret.avatar === null || ret.avatar === undefined ? null : {
                                width: ret.avatar.width || 0,
                                height: ret.avatar.height || 0,
                                url: ret.avatar.url
                            },
                            address: ret.address === null || ret.address === undefined ? null : {
                                street: ret.address.street,
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                number: ret.address.number,
                                zip: ret.address.zip,
                                adicionalInfo: ret.address.adicionalInfo,
                                reference: ret.address.reference,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            cards: ret.cards.map(function (e) {
                                return {
                                    id: e.id,
                                    lastDigits: e.lastDigits,
                                    brand: e.brand,
                                    exp: e.exp
                                };
                            }),
                            bankAccount: ret.bankAccount === null || ret.bankAccount === undefined ? null : {
                                documentNumber: ret.bankAccount.documentNumber,
                                bankName: ret.bankAccount.bankName,
                                bankCode: ret.bankAccount.bankCode,
                                agency: ret.bankAccount.agency,
                                agencyDv: ret.bankAccount.agencyDv,
                                account: ret.bankAccount.account,
                                accountDv: ret.bankAccount.accountDv,
                                type: ret.bankAccount.type,
                                legalName: ret.bankAccount.legalName
                            }
                        });

                    case 5:
                    case "end":
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function login(_x17, _x18, _x19) {
        return _ref9.apply(this, arguments);
    };
}();

var loginThirdParty = function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(providorToken, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        args = {
                            providorToken: {
                                providor: providorToken.providor,
                                idToken: providorToken.idToken,
                                acessToken: providorToken.acessToken === null || providorToken.acessToken === undefined ? null : providorToken.acessToken
                            }
                        };
                        _context10.next = 3;
                        return makeRequest({ name: "loginThirdParty", args: args, progress: progress });

                    case 3:
                        ret = _context10.sent;
                        return _context10.abrupt("return", {
                            id: ret.id,
                            nick: ret.nick,
                            name: ret.name,
                            birthday: ret.birthday === null || ret.birthday === undefined ? null : new Date(parseInt(ret.birthday.split("-")[0], 10), parseInt(ret.birthday.split("-")[1], 10) - 1, parseInt(ret.birthday.split("-")[2], 10)),
                            cpf: ret.cpf,
                            email: ret.email,
                            height: ret.height === null || ret.height === undefined ? null : ret.height || 0,
                            gender: ret.gender === null || ret.gender === undefined ? null : ret.gender,
                            phone: {
                                ddd: ret.phone.ddd,
                                ddi: ret.phone.ddi,
                                number: ret.phone.number
                            },
                            avatar: ret.avatar === null || ret.avatar === undefined ? null : {
                                width: ret.avatar.width || 0,
                                height: ret.avatar.height || 0,
                                url: ret.avatar.url
                            },
                            address: ret.address === null || ret.address === undefined ? null : {
                                street: ret.address.street,
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                number: ret.address.number,
                                zip: ret.address.zip,
                                adicionalInfo: ret.address.adicionalInfo,
                                reference: ret.address.reference,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            cards: ret.cards.map(function (e) {
                                return {
                                    id: e.id,
                                    lastDigits: e.lastDigits,
                                    brand: e.brand,
                                    exp: e.exp
                                };
                            }),
                            bankAccount: ret.bankAccount === null || ret.bankAccount === undefined ? null : {
                                documentNumber: ret.bankAccount.documentNumber,
                                bankName: ret.bankAccount.bankName,
                                bankCode: ret.bankAccount.bankCode,
                                agency: ret.bankAccount.agency,
                                agencyDv: ret.bankAccount.agencyDv,
                                account: ret.bankAccount.account,
                                accountDv: ret.bankAccount.accountDv,
                                type: ret.bankAccount.type,
                                legalName: ret.bankAccount.legalName
                            }
                        });

                    case 5:
                    case "end":
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function loginThirdParty(_x20, _x21) {
        return _ref10.apply(this, arguments);
    };
}();

var linkWith = function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(providorToken, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        args = {
                            providorToken: {
                                providor: providorToken.providor,
                                idToken: providorToken.idToken,
                                acessToken: providorToken.acessToken === null || providorToken.acessToken === undefined ? null : providorToken.acessToken
                            }
                        };
                        _context11.next = 3;
                        return makeRequest({ name: "linkWith", args: args, progress: progress });

                    case 3:
                        return _context11.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function linkWith(_x22, _x23) {
        return _ref11.apply(this, arguments);
    };
}();

var setAvatar = function () {
    var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(image, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        args = {
                            image: image === null || image === undefined ? null : image.toString("base64")
                        };
                        _context12.next = 3;
                        return makeRequest({ name: "setAvatar", args: args, progress: progress });

                    case 3:
                        ret = _context12.sent;
                        return _context12.abrupt("return", ret === null || ret === undefined ? null : {
                            width: ret.width || 0,
                            height: ret.height || 0,
                            url: ret.url
                        });

                    case 5:
                    case "end":
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function setAvatar(_x24, _x25) {
        return _ref12.apply(this, arguments);
    };
}();

var setAddress = function () {
    var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(address, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        args = {
                            address: address === null || address === undefined ? null : {
                                street: address.street,
                                neighborhood: address.neighborhood,
                                city: address.city,
                                uf: address.uf,
                                country: address.country,
                                number: address.number,
                                zip: address.zip,
                                adicionalInfo: address.adicionalInfo,
                                reference: address.reference,
                                location: {
                                    lat: address.location.lat,
                                    lon: address.location.lon
                                }
                            }
                        };
                        _context13.next = 3;
                        return makeRequest({ name: "setAddress", args: args, progress: progress });

                    case 3:
                        ret = _context13.sent;
                        return _context13.abrupt("return", ret === null || ret === undefined ? null : {
                            street: ret.street,
                            neighborhood: ret.neighborhood,
                            city: ret.city,
                            uf: ret.uf,
                            country: ret.country,
                            number: ret.number,
                            zip: ret.zip,
                            adicionalInfo: ret.adicionalInfo,
                            reference: ret.reference,
                            location: {
                                lat: ret.location.lat,
                                lon: ret.location.lon
                            }
                        });

                    case 5:
                    case "end":
                        return _context13.stop();
                }
            }
        }, _callee13, this);
    }));

    return function setAddress(_x26, _x27) {
        return _ref13.apply(this, arguments);
    };
}();

var addCard = function () {
    var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(card, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        args = {
                            card: {
                                cardNumber: card.cardNumber,
                                cvv: card.cvv,
                                expDate: card.expDate,
                                cardHolderName: card.cardHolderName
                            }
                        };
                        _context14.next = 3;
                        return makeRequest({ name: "addCard", args: args, progress: progress });

                    case 3:
                        ret = _context14.sent;
                        return _context14.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                lastDigits: e.lastDigits,
                                brand: e.brand,
                                exp: e.exp
                            };
                        }));

                    case 5:
                    case "end":
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function addCard(_x28, _x29) {
        return _ref14.apply(this, arguments);
    };
}();

var removeCard = function () {
    var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(cardId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        args = {
                            cardId: cardId
                        };
                        _context15.next = 3;
                        return makeRequest({ name: "removeCard", args: args, progress: progress });

                    case 3:
                        ret = _context15.sent;
                        return _context15.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                lastDigits: e.lastDigits,
                                brand: e.brand,
                                exp: e.exp
                            };
                        }));

                    case 5:
                    case "end":
                        return _context15.stop();
                }
            }
        }, _callee15, this);
    }));

    return function removeCard(_x30, _x31) {
        return _ref15.apply(this, arguments);
    };
}();

var setMainCard = function () {
    var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(cardId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        args = {
                            cardId: cardId
                        };
                        _context16.next = 3;
                        return makeRequest({ name: "setMainCard", args: args, progress: progress });

                    case 3:
                        return _context16.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context16.stop();
                }
            }
        }, _callee16, this);
    }));

    return function setMainCard(_x32, _x33) {
        return _ref16.apply(this, arguments);
    };
}();

var setBankAccount = function () {
    var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(bankAccount, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        args = {
                            bankAccount: {
                                bankName: bankAccount.bankName,
                                bankCode: bankAccount.bankCode,
                                agency: bankAccount.agency,
                                agencyDv: bankAccount.agencyDv,
                                account: bankAccount.account,
                                accountDv: bankAccount.accountDv,
                                type: bankAccount.type,
                                legalName: bankAccount.legalName
                            }
                        };
                        _context17.next = 3;
                        return makeRequest({ name: "setBankAccount", args: args, progress: progress });

                    case 3:
                        ret = _context17.sent;
                        return _context17.abrupt("return", {
                            documentNumber: ret.documentNumber,
                            bankName: ret.bankName,
                            bankCode: ret.bankCode,
                            agency: ret.agency,
                            agencyDv: ret.agencyDv,
                            account: ret.account,
                            accountDv: ret.accountDv,
                            type: ret.type,
                            legalName: ret.legalName
                        });

                    case 5:
                    case "end":
                        return _context17.stop();
                }
            }
        }, _callee17, this);
    }));

    return function setBankAccount(_x34, _x35) {
        return _ref17.apply(this, arguments);
    };
}();

var setPersonalInfo = function () {
    var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(personalInfo, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        args = {
                            personalInfo: {
                                nick: personalInfo.nick,
                                name: personalInfo.name,
                                email: personalInfo.email,
                                phone: {
                                    ddd: personalInfo.phone.ddd,
                                    ddi: personalInfo.phone.ddi,
                                    number: personalInfo.phone.number
                                },
                                gender: personalInfo.gender === null || personalInfo.gender === undefined ? null : personalInfo.gender,
                                birthday: personalInfo.birthday === null || personalInfo.birthday === undefined ? null : typeof personalInfo.birthday === "string" ? new Date(new Date(personalInfo.birthday).getTime() - new Date(personalInfo.birthday).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(personalInfo.birthday.getTime() - personalInfo.birthday.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                height: personalInfo.height === null || personalInfo.height === undefined ? null : personalInfo.height || 0
                            }
                        };
                        _context18.next = 3;
                        return makeRequest({ name: "setPersonalInfo", args: args, progress: progress });

                    case 3:
                        ret = _context18.sent;
                        return _context18.abrupt("return", {
                            cpf: ret.cpf,
                            nick: ret.nick,
                            name: ret.name,
                            email: ret.email,
                            phone: {
                                ddd: ret.phone.ddd,
                                ddi: ret.phone.ddi,
                                number: ret.phone.number
                            },
                            gender: ret.gender === null || ret.gender === undefined ? null : ret.gender,
                            birthday: ret.birthday === null || ret.birthday === undefined ? null : new Date(parseInt(ret.birthday.split("-")[0], 10), parseInt(ret.birthday.split("-")[1], 10) - 1, parseInt(ret.birthday.split("-")[2], 10)),
                            height: ret.height === null || ret.height === undefined ? null : ret.height || 0
                        });

                    case 5:
                    case "end":
                        return _context18.stop();
                }
            }
        }, _callee18, this);
    }));

    return function setPersonalInfo(_x36, _x37) {
        return _ref18.apply(this, arguments);
    };
}();

var changePassword = function () {
    var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(oldPassword, newPassword, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        args = {
                            oldPassword: oldPassword,
                            newPassword: newPassword
                        };
                        _context19.next = 3;
                        return makeRequest({ name: "changePassword", args: args, progress: progress });

                    case 3:
                        return _context19.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context19.stop();
                }
            }
        }, _callee19, this);
    }));

    return function changePassword(_x38, _x39, _x40) {
        return _ref19.apply(this, arguments);
    };
}();

var sendResetPasswordLink = function () {
    var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(email, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee20$(_context20) {
            while (1) {
                switch (_context20.prev = _context20.next) {
                    case 0:
                        args = {
                            email: email
                        };
                        _context20.next = 3;
                        return makeRequest({ name: "sendResetPasswordLink", args: args, progress: progress });

                    case 3:
                        return _context20.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context20.stop();
                }
            }
        }, _callee20, this);
    }));

    return function sendResetPasswordLink(_x41, _x42) {
        return _ref20.apply(this, arguments);
    };
}();

var resetPassword = function () {
    var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(token, newPassword, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee21$(_context21) {
            while (1) {
                switch (_context21.prev = _context21.next) {
                    case 0:
                        args = {
                            token: token,
                            newPassword: newPassword
                        };
                        _context21.next = 3;
                        return makeRequest({ name: "resetPassword", args: args, progress: progress });

                    case 3:
                        return _context21.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context21.stop();
                }
            }
        }, _callee21, this);
    }));

    return function resetPassword(_x43, _x44, _x45) {
        return _ref21.apply(this, arguments);
    };
}();

var logOut = function () {
    var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee22$(_context22) {
            while (1) {
                switch (_context22.prev = _context22.next) {
                    case 0:
                        _context22.next = 2;
                        return makeRequest({ name: "logOut", args: {}, progress: progress });

                    case 2:
                        ret = _context22.sent;
                        return _context22.abrupt("return", !!ret);

                    case 4:
                    case "end":
                        return _context22.stop();
                }
            }
        }, _callee22, this);
    }));

    return function logOut(_x46) {
        return _ref22.apply(this, arguments);
    };
}();

var transfer = function () {
    var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(amount, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee23$(_context23) {
            while (1) {
                switch (_context23.prev = _context23.next) {
                    case 0:
                        args = {
                            amount: amount || 0
                        };
                        _context23.next = 3;
                        return makeRequest({ name: "transfer", args: args, progress: progress });

                    case 3:
                        ret = _context23.sent;
                        return _context23.abrupt("return", {
                            waitingFunds: {
                                amount: ret.waitingFunds.amount || 0
                            },
                            avaiable: {
                                amount: ret.avaiable.amount || 0
                            },
                            transfered: {
                                amount: ret.transfered.amount || 0
                            }
                        });

                    case 5:
                    case "end":
                        return _context23.stop();
                }
            }
        }, _callee23, this);
    }));

    return function transfer(_x47, _x48) {
        return _ref23.apply(this, arguments);
    };
}();

var getEmailAvaiable = function () {
    var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(email, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee24$(_context24) {
            while (1) {
                switch (_context24.prev = _context24.next) {
                    case 0:
                        args = {
                            email: email
                        };
                        _context24.next = 3;
                        return makeRequest({ name: "getEmailAvaiable", args: args, progress: progress });

                    case 3:
                        return _context24.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context24.stop();
                }
            }
        }, _callee24, this);
    }));

    return function getEmailAvaiable(_x49, _x50) {
        return _ref24.apply(this, arguments);
    };
}();

var getNickAvaiable = function () {
    var _ref25 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(nick, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee25$(_context25) {
            while (1) {
                switch (_context25.prev = _context25.next) {
                    case 0:
                        args = {
                            nick: nick
                        };
                        _context25.next = 3;
                        return makeRequest({ name: "getNickAvaiable", args: args, progress: progress });

                    case 3:
                        ret = _context25.sent;
                        return _context25.abrupt("return", ret);

                    case 5:
                    case "end":
                        return _context25.stop();
                }
            }
        }, _callee25, this);
    }));

    return function getNickAvaiable(_x51, _x52) {
        return _ref25.apply(this, arguments);
    };
}();

var getCards = function () {
    var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee26$(_context26) {
            while (1) {
                switch (_context26.prev = _context26.next) {
                    case 0:
                        _context26.next = 2;
                        return makeRequest({ name: "getCards", args: {}, progress: progress });

                    case 2:
                        ret = _context26.sent;
                        return _context26.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                lastDigits: e.lastDigits,
                                brand: e.brand,
                                exp: e.exp
                            };
                        }));

                    case 4:
                    case "end":
                        return _context26.stop();
                }
            }
        }, _callee26, this);
    }));

    return function getCards(_x53) {
        return _ref26.apply(this, arguments);
    };
}();

var getBalance = function () {
    var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee27$(_context27) {
            while (1) {
                switch (_context27.prev = _context27.next) {
                    case 0:
                        _context27.next = 2;
                        return makeRequest({ name: "getBalance", args: {}, progress: progress });

                    case 2:
                        ret = _context27.sent;
                        return _context27.abrupt("return", {
                            waitingFunds: {
                                amount: ret.waitingFunds.amount || 0
                            },
                            avaiable: {
                                amount: ret.avaiable.amount || 0
                            },
                            transfered: {
                                amount: ret.transfered.amount || 0
                            }
                        });

                    case 4:
                    case "end":
                        return _context27.stop();
                }
            }
        }, _callee27, this);
    }));

    return function getBalance(_x54) {
        return _ref27.apply(this, arguments);
    };
}();

var getUserInfo = function () {
    var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(userId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee28$(_context28) {
            while (1) {
                switch (_context28.prev = _context28.next) {
                    case 0:
                        args = {
                            userId: userId
                        };
                        _context28.next = 3;
                        return makeRequest({ name: "getUserInfo", args: args, progress: progress });

                    case 3:
                        ret = _context28.sent;
                        return _context28.abrupt("return", {
                            id: ret.id,
                            avatar: ret.avatar === null || ret.avatar === undefined ? null : {
                                width: ret.avatar.width || 0,
                                height: ret.avatar.height || 0,
                                url: ret.avatar.url
                            },
                            name: ret.name,
                            rate: ret.rate,
                            height: ret.height === null || ret.height === undefined ? null : ret.height || 0,
                            deleted: !!ret.deleted,
                            ownerName: ret.ownerName === null || ret.ownerName === undefined ? null : ret.ownerName
                        });

                    case 5:
                    case "end":
                        return _context28.stop();
                }
            }
        }, _callee28, this);
    }));

    return function getUserInfo(_x55, _x56) {
        return _ref28.apply(this, arguments);
    };
}();

var getItems = function () {
    var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29(location, filter, page, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee29$(_context29) {
            while (1) {
                switch (_context29.prev = _context29.next) {
                    case 0:
                        args = {
                            location: {
                                lat: location.lat,
                                lon: location.lon
                            },
                            filter: {
                                distance: filter.distance,
                                sizes: filter.sizes.map(function (e) {
                                    return e;
                                }),
                                gender: filter.gender.map(function (e) {
                                    return e;
                                }),
                                categories: filter.categories.map(function (e) {
                                    return e;
                                })
                            },
                            page: page === null || page === undefined ? null : page || 0
                        };
                        _context29.next = 3;
                        return makeRequest({ name: "getItems", args: args, progress: progress });

                    case 3:
                        ret = _context29.sent;
                        return _context29.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                department: e.department,
                                ownerId: e.ownerId,
                                likes: e.likes || 0,
                                liked: !!e.liked,
                                address: {
                                    neighborhood: e.address.neighborhood,
                                    city: e.address.city,
                                    uf: e.address.uf,
                                    country: e.address.country,
                                    location: {
                                        lat: e.address.location.lat,
                                        lon: e.address.location.lon
                                    }
                                },
                                ownerInfo: {
                                    id: e.ownerInfo.id,
                                    avatar: e.ownerInfo.avatar === null || e.ownerInfo.avatar === undefined ? null : {
                                        width: e.ownerInfo.avatar.width || 0,
                                        height: e.ownerInfo.avatar.height || 0,
                                        url: e.ownerInfo.avatar.url
                                    },
                                    name: e.ownerInfo.name,
                                    rate: e.ownerInfo.rate,
                                    height: e.ownerInfo.height === null || e.ownerInfo.height === undefined ? null : e.ownerInfo.height || 0,
                                    deleted: !!e.ownerInfo.deleted,
                                    ownerName: e.ownerInfo.ownerName === null || e.ownerInfo.ownerName === undefined ? null : e.ownerInfo.ownerName
                                },
                                calendar: e.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                adjustment: !!e.adjustment,
                                category: e.category === null || e.category === undefined ? null : e.category,
                                color: e.color === null || e.color === undefined ? null : e.color,
                                details: e.details,
                                gender: e.gender,
                                thumbImage: {
                                    width: e.thumbImage.width || 0,
                                    height: e.thumbImage.height || 0,
                                    url: e.thumbImage.url
                                },
                                images: e.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: e.brand === null || e.brand === undefined ? null : e.brand,
                                ocasions: e.ocasions.map(function (e) {
                                    return e === null || e === undefined ? null : e;
                                }),
                                rentPrice: e.rentPrice || 0,
                                originalPrice: e.originalPrice || 0,
                                size: e.size === null || e.size === undefined ? null : e.size
                            };
                        }));

                    case 5:
                    case "end":
                        return _context29.stop();
                }
            }
        }, _callee29, this);
    }));

    return function getItems(_x57, _x58, _x59, _x60) {
        return _ref29.apply(this, arguments);
    };
}();

var getLiked = function () {
    var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30(page, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee30$(_context30) {
            while (1) {
                switch (_context30.prev = _context30.next) {
                    case 0:
                        args = {
                            page: page === null || page === undefined ? null : page || 0
                        };
                        _context30.next = 3;
                        return makeRequest({ name: "getLiked", args: args, progress: progress });

                    case 3:
                        ret = _context30.sent;
                        return _context30.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                department: e.department,
                                ownerId: e.ownerId,
                                likes: e.likes || 0,
                                liked: !!e.liked,
                                address: {
                                    neighborhood: e.address.neighborhood,
                                    city: e.address.city,
                                    uf: e.address.uf,
                                    country: e.address.country,
                                    location: {
                                        lat: e.address.location.lat,
                                        lon: e.address.location.lon
                                    }
                                },
                                ownerInfo: {
                                    id: e.ownerInfo.id,
                                    avatar: e.ownerInfo.avatar === null || e.ownerInfo.avatar === undefined ? null : {
                                        width: e.ownerInfo.avatar.width || 0,
                                        height: e.ownerInfo.avatar.height || 0,
                                        url: e.ownerInfo.avatar.url
                                    },
                                    name: e.ownerInfo.name,
                                    rate: e.ownerInfo.rate,
                                    height: e.ownerInfo.height === null || e.ownerInfo.height === undefined ? null : e.ownerInfo.height || 0,
                                    deleted: !!e.ownerInfo.deleted,
                                    ownerName: e.ownerInfo.ownerName === null || e.ownerInfo.ownerName === undefined ? null : e.ownerInfo.ownerName
                                },
                                calendar: e.calendar.map(function (e) {
                                    return {
                                        start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                        end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                    };
                                }),
                                adjustment: !!e.adjustment,
                                category: e.category === null || e.category === undefined ? null : e.category,
                                color: e.color === null || e.color === undefined ? null : e.color,
                                details: e.details,
                                gender: e.gender,
                                thumbImage: {
                                    width: e.thumbImage.width || 0,
                                    height: e.thumbImage.height || 0,
                                    url: e.thumbImage.url
                                },
                                images: e.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: e.brand === null || e.brand === undefined ? null : e.brand,
                                ocasions: e.ocasions.map(function (e) {
                                    return e === null || e === undefined ? null : e;
                                }),
                                rentPrice: e.rentPrice || 0,
                                originalPrice: e.originalPrice || 0,
                                size: e.size === null || e.size === undefined ? null : e.size
                            };
                        }));

                    case 5:
                    case "end":
                        return _context30.stop();
                }
            }
        }, _callee30, this);
    }));

    return function getLiked(_x61, _x62) {
        return _ref30.apply(this, arguments);
    };
}();

var getItem = function () {
    var _ref31 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(itemId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee31$(_context31) {
            while (1) {
                switch (_context31.prev = _context31.next) {
                    case 0:
                        args = {
                            itemId: itemId
                        };
                        _context31.next = 3;
                        return makeRequest({ name: "getItem", args: args, progress: progress });

                    case 3:
                        ret = _context31.sent;
                        return _context31.abrupt("return", ret === null || ret === undefined ? null : {
                            id: ret.id,
                            department: ret.department,
                            ownerId: ret.ownerId,
                            likes: ret.likes || 0,
                            liked: !!ret.liked,
                            address: {
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            ownerInfo: {
                                id: ret.ownerInfo.id,
                                avatar: ret.ownerInfo.avatar === null || ret.ownerInfo.avatar === undefined ? null : {
                                    width: ret.ownerInfo.avatar.width || 0,
                                    height: ret.ownerInfo.avatar.height || 0,
                                    url: ret.ownerInfo.avatar.url
                                },
                                name: ret.ownerInfo.name,
                                rate: ret.ownerInfo.rate,
                                height: ret.ownerInfo.height === null || ret.ownerInfo.height === undefined ? null : ret.ownerInfo.height || 0,
                                deleted: !!ret.ownerInfo.deleted,
                                ownerName: ret.ownerInfo.ownerName === null || ret.ownerInfo.ownerName === undefined ? null : ret.ownerInfo.ownerName
                            },
                            calendar: ret.calendar.map(function (e) {
                                return {
                                    start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                };
                            }),
                            adjustment: !!ret.adjustment,
                            category: ret.category === null || ret.category === undefined ? null : ret.category,
                            color: ret.color === null || ret.color === undefined ? null : ret.color,
                            details: ret.details,
                            gender: ret.gender,
                            thumbImage: {
                                width: ret.thumbImage.width || 0,
                                height: ret.thumbImage.height || 0,
                                url: ret.thumbImage.url
                            },
                            images: ret.images.map(function (e) {
                                return {
                                    width: e.width || 0,
                                    height: e.height || 0,
                                    url: e.url
                                };
                            }),
                            brand: ret.brand === null || ret.brand === undefined ? null : ret.brand,
                            ocasions: ret.ocasions.map(function (e) {
                                return e === null || e === undefined ? null : e;
                            }),
                            rentPrice: ret.rentPrice || 0,
                            originalPrice: ret.originalPrice || 0,
                            size: ret.size === null || ret.size === undefined ? null : ret.size
                        });

                    case 5:
                    case "end":
                        return _context31.stop();
                }
            }
        }, _callee31, this);
    }));

    return function getItem(_x63, _x64) {
        return _ref31.apply(this, arguments);
    };
}();

var addNewItem = function () {
    var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(item, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee32$(_context32) {
            while (1) {
                switch (_context32.prev = _context32.next) {
                    case 0:
                        args = {
                            item: {
                                adjustment: !!item.adjustment,
                                category: item.category,
                                color: item.color,
                                details: item.details,
                                gender: item.gender,
                                images: item.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: item.brand === null || item.brand === undefined ? null : item.brand,
                                ocasions: item.ocasions.map(function (e) {
                                    return e;
                                }),
                                rentPrice: item.rentPrice || 0,
                                originalPrice: item.originalPrice || 0,
                                size: item.size
                            }
                        };
                        _context32.next = 3;
                        return makeRequest({ name: "addNewItem", args: args, progress: progress });

                    case 3:
                        ret = _context32.sent;
                        return _context32.abrupt("return", {
                            id: ret.id,
                            department: ret.department,
                            ownerId: ret.ownerId,
                            likes: ret.likes || 0,
                            liked: !!ret.liked,
                            address: {
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            ownerInfo: {
                                id: ret.ownerInfo.id,
                                avatar: ret.ownerInfo.avatar === null || ret.ownerInfo.avatar === undefined ? null : {
                                    width: ret.ownerInfo.avatar.width || 0,
                                    height: ret.ownerInfo.avatar.height || 0,
                                    url: ret.ownerInfo.avatar.url
                                },
                                name: ret.ownerInfo.name,
                                rate: ret.ownerInfo.rate,
                                height: ret.ownerInfo.height === null || ret.ownerInfo.height === undefined ? null : ret.ownerInfo.height || 0,
                                deleted: !!ret.ownerInfo.deleted,
                                ownerName: ret.ownerInfo.ownerName === null || ret.ownerInfo.ownerName === undefined ? null : ret.ownerInfo.ownerName
                            },
                            calendar: ret.calendar.map(function (e) {
                                return {
                                    start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                };
                            }),
                            adjustment: !!ret.adjustment,
                            category: ret.category === null || ret.category === undefined ? null : ret.category,
                            color: ret.color === null || ret.color === undefined ? null : ret.color,
                            details: ret.details,
                            gender: ret.gender,
                            thumbImage: {
                                width: ret.thumbImage.width || 0,
                                height: ret.thumbImage.height || 0,
                                url: ret.thumbImage.url
                            },
                            images: ret.images.map(function (e) {
                                return {
                                    width: e.width || 0,
                                    height: e.height || 0,
                                    url: e.url
                                };
                            }),
                            brand: ret.brand === null || ret.brand === undefined ? null : ret.brand,
                            ocasions: ret.ocasions.map(function (e) {
                                return e === null || e === undefined ? null : e;
                            }),
                            rentPrice: ret.rentPrice || 0,
                            originalPrice: ret.originalPrice || 0,
                            size: ret.size === null || ret.size === undefined ? null : ret.size
                        });

                    case 5:
                    case "end":
                        return _context32.stop();
                }
            }
        }, _callee32, this);
    }));

    return function addNewItem(_x65, _x66) {
        return _ref32.apply(this, arguments);
    };
}();

var editItem = function () {
    var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(item, itemId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee33$(_context33) {
            while (1) {
                switch (_context33.prev = _context33.next) {
                    case 0:
                        args = {
                            item: {
                                adjustment: !!item.adjustment,
                                category: item.category,
                                color: item.color,
                                details: item.details,
                                gender: item.gender,
                                images: item.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: item.brand === null || item.brand === undefined ? null : item.brand,
                                ocasions: item.ocasions.map(function (e) {
                                    return e;
                                }),
                                rentPrice: item.rentPrice || 0,
                                originalPrice: item.originalPrice || 0,
                                size: item.size
                            },
                            itemId: itemId
                        };
                        _context33.next = 3;
                        return makeRequest({ name: "editItem", args: args, progress: progress });

                    case 3:
                        ret = _context33.sent;
                        return _context33.abrupt("return", {
                            id: ret.id,
                            department: ret.department,
                            ownerId: ret.ownerId,
                            likes: ret.likes || 0,
                            liked: !!ret.liked,
                            address: {
                                neighborhood: ret.address.neighborhood,
                                city: ret.address.city,
                                uf: ret.address.uf,
                                country: ret.address.country,
                                location: {
                                    lat: ret.address.location.lat,
                                    lon: ret.address.location.lon
                                }
                            },
                            ownerInfo: {
                                id: ret.ownerInfo.id,
                                avatar: ret.ownerInfo.avatar === null || ret.ownerInfo.avatar === undefined ? null : {
                                    width: ret.ownerInfo.avatar.width || 0,
                                    height: ret.ownerInfo.avatar.height || 0,
                                    url: ret.ownerInfo.avatar.url
                                },
                                name: ret.ownerInfo.name,
                                rate: ret.ownerInfo.rate,
                                height: ret.ownerInfo.height === null || ret.ownerInfo.height === undefined ? null : ret.ownerInfo.height || 0,
                                deleted: !!ret.ownerInfo.deleted,
                                ownerName: ret.ownerInfo.ownerName === null || ret.ownerInfo.ownerName === undefined ? null : ret.ownerInfo.ownerName
                            },
                            calendar: ret.calendar.map(function (e) {
                                return {
                                    start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                };
                            }),
                            adjustment: !!ret.adjustment,
                            category: ret.category === null || ret.category === undefined ? null : ret.category,
                            color: ret.color === null || ret.color === undefined ? null : ret.color,
                            details: ret.details,
                            gender: ret.gender,
                            thumbImage: {
                                width: ret.thumbImage.width || 0,
                                height: ret.thumbImage.height || 0,
                                url: ret.thumbImage.url
                            },
                            images: ret.images.map(function (e) {
                                return {
                                    width: e.width || 0,
                                    height: e.height || 0,
                                    url: e.url
                                };
                            }),
                            brand: ret.brand === null || ret.brand === undefined ? null : ret.brand,
                            ocasions: ret.ocasions.map(function (e) {
                                return e === null || e === undefined ? null : e;
                            }),
                            rentPrice: ret.rentPrice || 0,
                            originalPrice: ret.originalPrice || 0,
                            size: ret.size === null || ret.size === undefined ? null : ret.size
                        });

                    case 5:
                    case "end":
                        return _context33.stop();
                }
            }
        }, _callee33, this);
    }));

    return function editItem(_x67, _x68, _x69) {
        return _ref33.apply(this, arguments);
    };
}();

var deleteItem = function () {
    var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee34(itemId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee34$(_context34) {
            while (1) {
                switch (_context34.prev = _context34.next) {
                    case 0:
                        args = {
                            itemId: itemId
                        };
                        _context34.next = 3;
                        return makeRequest({ name: "deleteItem", args: args, progress: progress });

                    case 3:
                        return _context34.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context34.stop();
                }
            }
        }, _callee34, this);
    }));

    return function deleteItem(_x70, _x71) {
        return _ref34.apply(this, arguments);
    };
}();

var setLike = function () {
    var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee35(itemId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee35$(_context35) {
            while (1) {
                switch (_context35.prev = _context35.next) {
                    case 0:
                        args = {
                            itemId: itemId
                        };
                        _context35.next = 3;
                        return makeRequest({ name: "setLike", args: args, progress: progress });

                    case 3:
                        ret = _context35.sent;
                        return _context35.abrupt("return", !!ret);

                    case 5:
                    case "end":
                        return _context35.stop();
                }
            }
        }, _callee35, this);
    }));

    return function setLike(_x72, _x73) {
        return _ref35.apply(this, arguments);
    };
}();

var requestItem = function () {
    var _ref36 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee36(itemId, promotionId, transport, period, cardId, address, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee36$(_context36) {
            while (1) {
                switch (_context36.prev = _context36.next) {
                    case 0:
                        args = {
                            itemId: itemId,
                            promotionId: promotionId === null || promotionId === undefined ? null : promotionId,
                            transport: !!transport,
                            period: {
                                start: typeof period.start === "string" ? new Date(new Date(period.start).getTime() - new Date(period.start).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(period.start.getTime() - period.start.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                end: typeof period.end === "string" ? new Date(new Date(period.end).getTime() - new Date(period.end).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(period.end.getTime() - period.end.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                            },
                            cardId: cardId,
                            address: address === null || address === undefined ? null : {
                                street: address.street,
                                neighborhood: address.neighborhood,
                                city: address.city,
                                uf: address.uf,
                                country: address.country,
                                number: address.number,
                                zip: address.zip,
                                adicionalInfo: address.adicionalInfo,
                                reference: address.reference,
                                location: {
                                    lat: address.location.lat,
                                    lon: address.location.lon
                                }
                            }
                        };
                        _context36.next = 3;
                        return makeRequest({ name: "requestItem", args: args, progress: progress });

                    case 3:
                        ret = _context36.sent;
                        return _context36.abrupt("return", {
                            locRequest: {
                                id: ret.locRequest.id,
                                item: {
                                    id: ret.locRequest.item.id,
                                    adjustment: !!ret.locRequest.item.adjustment,
                                    category: ret.locRequest.item.category,
                                    department: ret.locRequest.item.department,
                                    color: ret.locRequest.item.color,
                                    details: ret.locRequest.item.details,
                                    gender: ret.locRequest.item.gender,
                                    thumbImage: {
                                        width: ret.locRequest.item.thumbImage.width || 0,
                                        height: ret.locRequest.item.thumbImage.height || 0,
                                        url: ret.locRequest.item.thumbImage.url
                                    },
                                    images: ret.locRequest.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: ret.locRequest.item.brand === null || ret.locRequest.item.brand === undefined ? null : ret.locRequest.item.brand,
                                    ocasions: ret.locRequest.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    ownerId: ret.locRequest.item.ownerId,
                                    ownerInfo: {
                                        id: ret.locRequest.item.ownerInfo.id,
                                        avatar: ret.locRequest.item.ownerInfo.avatar === null || ret.locRequest.item.ownerInfo.avatar === undefined ? null : {
                                            width: ret.locRequest.item.ownerInfo.avatar.width || 0,
                                            height: ret.locRequest.item.ownerInfo.avatar.height || 0,
                                            url: ret.locRequest.item.ownerInfo.avatar.url
                                        },
                                        name: ret.locRequest.item.ownerInfo.name,
                                        rate: ret.locRequest.item.ownerInfo.rate,
                                        height: ret.locRequest.item.ownerInfo.height === null || ret.locRequest.item.ownerInfo.height === undefined ? null : ret.locRequest.item.ownerInfo.height || 0,
                                        deleted: !!ret.locRequest.item.ownerInfo.deleted,
                                        ownerName: ret.locRequest.item.ownerInfo.ownerName === null || ret.locRequest.item.ownerInfo.ownerName === undefined ? null : ret.locRequest.item.ownerInfo.ownerName
                                    },
                                    address: {
                                        neighborhood: ret.locRequest.item.address.neighborhood,
                                        city: ret.locRequest.item.address.city,
                                        uf: ret.locRequest.item.address.uf,
                                        country: ret.locRequest.item.address.country,
                                        location: {
                                            lat: ret.locRequest.item.address.location.lat,
                                            lon: ret.locRequest.item.address.location.lon
                                        }
                                    },
                                    rentPrice: ret.locRequest.item.rentPrice || 0,
                                    originalPrice: ret.locRequest.item.originalPrice || 0,
                                    size: ret.locRequest.item.size
                                },
                                period: {
                                    start: new Date(parseInt(ret.locRequest.period.start.split("-")[0], 10), parseInt(ret.locRequest.period.start.split("-")[1], 10) - 1, parseInt(ret.locRequest.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(ret.locRequest.period.end.split("-")[0], 10), parseInt(ret.locRequest.period.end.split("-")[1], 10) - 1, parseInt(ret.locRequest.period.end.split("-")[2], 10))
                                },
                                isOwner: !!ret.locRequest.isOwner,
                                otherUserInfo: {
                                    id: ret.locRequest.otherUserInfo.id,
                                    avatar: ret.locRequest.otherUserInfo.avatar === null || ret.locRequest.otherUserInfo.avatar === undefined ? null : {
                                        width: ret.locRequest.otherUserInfo.avatar.width || 0,
                                        height: ret.locRequest.otherUserInfo.avatar.height || 0,
                                        url: ret.locRequest.otherUserInfo.avatar.url
                                    },
                                    name: ret.locRequest.otherUserInfo.name,
                                    rate: ret.locRequest.otherUserInfo.rate,
                                    height: ret.locRequest.otherUserInfo.height === null || ret.locRequest.otherUserInfo.height === undefined ? null : ret.locRequest.otherUserInfo.height || 0,
                                    deleted: !!ret.locRequest.otherUserInfo.deleted,
                                    ownerName: ret.locRequest.otherUserInfo.ownerName === null || ret.locRequest.otherUserInfo.ownerName === undefined ? null : ret.locRequest.otherUserInfo.ownerName
                                },
                                actionToPerform: !!ret.locRequest.actionToPerform,
                                actions: ret.locRequest.actions.map(function (e) {
                                    return e;
                                }),
                                transport: !!ret.locRequest.transport,
                                rentPrice: ret.locRequest.rentPrice || 0,
                                originalPrice: ret.locRequest.originalPrice || 0,
                                statusList: ret.locRequest.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: ret.locRequest.currentStatus.status,
                                    changeDate: new Date(parseInt(ret.locRequest.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.locRequest.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.locRequest.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: ret.locRequest.currentStatus.actionBy === null || ret.locRequest.currentStatus.actionBy === undefined ? null : ret.locRequest.currentStatus.actionBy,
                                    pending: !!ret.locRequest.currentStatus.pending
                                },
                                payment: {
                                    card: ret.locRequest.payment.card === null || ret.locRequest.payment.card === undefined ? null : {
                                        lastDigits: ret.locRequest.payment.card.lastDigits,
                                        brand: ret.locRequest.payment.card.brand,
                                        paidAmount: ret.locRequest.payment.card.paidAmount || 0
                                    },
                                    total: ret.locRequest.payment.total || 0
                                },
                                promotion: {
                                    type: ret.locRequest.promotion.type === null || ret.locRequest.promotion.type === undefined ? null : ret.locRequest.promotion.type,
                                    total: ret.locRequest.promotion.total || 0
                                },
                                nfe: ret.locRequest.nfe === null || ret.locRequest.nfe === undefined ? null : {
                                    id: ret.locRequest.nfe.id === null || ret.locRequest.nfe.id === undefined ? null : ret.locRequest.nfe.id,
                                    number: ret.locRequest.nfe.number === null || ret.locRequest.nfe.number === undefined ? null : ret.locRequest.nfe.number || 0,
                                    emitedAt: ret.locRequest.nfe.emitedAt === null || ret.locRequest.nfe.emitedAt === undefined ? null : new Date(ret.locRequest.nfe.emitedAt + "Z"),
                                    canceledAt: ret.locRequest.nfe.canceledAt === null || ret.locRequest.nfe.canceledAt === undefined ? null : new Date(ret.locRequest.nfe.canceledAt + "Z"),
                                    status: ret.locRequest.nfe.status === null || ret.locRequest.nfe.status === undefined ? null : ret.locRequest.nfe.status
                                }
                            },
                            messageRoom: {
                                id: ret.messageRoom.id.map(function (e) {
                                    return e;
                                }),
                                lastMessage: ret.messageRoom.lastMessage === null || ret.messageRoom.lastMessage === undefined ? null : {
                                    id: ret.messageRoom.lastMessage.id,
                                    messageRoomId: ret.messageRoom.lastMessage.messageRoomId.map(function (e) {
                                        return e;
                                    }),
                                    localMessageId: ret.messageRoom.lastMessage.localMessageId === null || ret.messageRoom.lastMessage.localMessageId === undefined ? null : ret.messageRoom.lastMessage.localMessageId,
                                    type: ret.messageRoom.lastMessage.type,
                                    content: {
                                        text: ret.messageRoom.lastMessage.content.text === null || ret.messageRoom.lastMessage.content.text === undefined ? null : ret.messageRoom.lastMessage.content.text,
                                        image: ret.messageRoom.lastMessage.content.image === null || ret.messageRoom.lastMessage.content.image === undefined ? null : {
                                            width: ret.messageRoom.lastMessage.content.image.width || 0,
                                            height: ret.messageRoom.lastMessage.content.image.height || 0,
                                            url: ret.messageRoom.lastMessage.content.image.url
                                        },
                                        statusChanged: ret.messageRoom.lastMessage.content.statusChanged === null || ret.messageRoom.lastMessage.content.statusChanged === undefined ? null : {
                                            requestId: ret.messageRoom.lastMessage.content.statusChanged.requestId,
                                            itemId: ret.messageRoom.lastMessage.content.statusChanged.itemId,
                                            isOwner: !!ret.messageRoom.lastMessage.content.statusChanged.isOwner,
                                            oldStatus: ret.messageRoom.lastMessage.content.statusChanged.oldStatus === null || ret.messageRoom.lastMessage.content.statusChanged.oldStatus === undefined ? null : ret.messageRoom.lastMessage.content.statusChanged.oldStatus,
                                            newStatus: ret.messageRoom.lastMessage.content.statusChanged.newStatus,
                                            thumbImage: {
                                                width: ret.messageRoom.lastMessage.content.statusChanged.thumbImage.width || 0,
                                                height: ret.messageRoom.lastMessage.content.statusChanged.thumbImage.height || 0,
                                                url: ret.messageRoom.lastMessage.content.statusChanged.thumbImage.url
                                            },
                                            message: ret.messageRoom.lastMessage.content.statusChanged.message
                                        },
                                        itemSelected: ret.messageRoom.lastMessage.content.itemSelected === null || ret.messageRoom.lastMessage.content.itemSelected === undefined ? null : {
                                            id: ret.messageRoom.lastMessage.content.itemSelected.id,
                                            adjustment: !!ret.messageRoom.lastMessage.content.itemSelected.adjustment,
                                            category: ret.messageRoom.lastMessage.content.itemSelected.category,
                                            department: ret.messageRoom.lastMessage.content.itemSelected.department,
                                            color: ret.messageRoom.lastMessage.content.itemSelected.color,
                                            details: ret.messageRoom.lastMessage.content.itemSelected.details,
                                            gender: ret.messageRoom.lastMessage.content.itemSelected.gender,
                                            thumbImage: {
                                                width: ret.messageRoom.lastMessage.content.itemSelected.thumbImage.width || 0,
                                                height: ret.messageRoom.lastMessage.content.itemSelected.thumbImage.height || 0,
                                                url: ret.messageRoom.lastMessage.content.itemSelected.thumbImage.url
                                            },
                                            images: ret.messageRoom.lastMessage.content.itemSelected.images.map(function (e) {
                                                return {
                                                    width: e.width || 0,
                                                    height: e.height || 0,
                                                    url: e.url
                                                };
                                            }),
                                            brand: ret.messageRoom.lastMessage.content.itemSelected.brand === null || ret.messageRoom.lastMessage.content.itemSelected.brand === undefined ? null : ret.messageRoom.lastMessage.content.itemSelected.brand,
                                            ocasions: ret.messageRoom.lastMessage.content.itemSelected.ocasions.map(function (e) {
                                                return e;
                                            }),
                                            ownerId: ret.messageRoom.lastMessage.content.itemSelected.ownerId,
                                            ownerInfo: {
                                                id: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.id,
                                                avatar: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.avatar === null || ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.avatar === undefined ? null : {
                                                    width: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.avatar.width || 0,
                                                    height: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.avatar.height || 0,
                                                    url: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.avatar.url
                                                },
                                                name: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.name,
                                                rate: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.rate,
                                                height: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.height === null || ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.height === undefined ? null : ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.height || 0,
                                                deleted: !!ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.deleted,
                                                ownerName: ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.ownerName === null || ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.ownerName === undefined ? null : ret.messageRoom.lastMessage.content.itemSelected.ownerInfo.ownerName
                                            },
                                            address: {
                                                neighborhood: ret.messageRoom.lastMessage.content.itemSelected.address.neighborhood,
                                                city: ret.messageRoom.lastMessage.content.itemSelected.address.city,
                                                uf: ret.messageRoom.lastMessage.content.itemSelected.address.uf,
                                                country: ret.messageRoom.lastMessage.content.itemSelected.address.country,
                                                location: {
                                                    lat: ret.messageRoom.lastMessage.content.itemSelected.address.location.lat,
                                                    lon: ret.messageRoom.lastMessage.content.itemSelected.address.location.lon
                                                }
                                            },
                                            rentPrice: ret.messageRoom.lastMessage.content.itemSelected.rentPrice || 0,
                                            originalPrice: ret.messageRoom.lastMessage.content.itemSelected.originalPrice || 0,
                                            size: ret.messageRoom.lastMessage.content.itemSelected.size
                                        }
                                    },
                                    date: new Date(ret.messageRoom.lastMessage.date + "Z"),
                                    senderId: ret.messageRoom.lastMessage.senderId === null || ret.messageRoom.lastMessage.senderId === undefined ? null : ret.messageRoom.lastMessage.senderId
                                },
                                otherUserInfo: {
                                    id: ret.messageRoom.otherUserInfo.id,
                                    avatar: ret.messageRoom.otherUserInfo.avatar === null || ret.messageRoom.otherUserInfo.avatar === undefined ? null : {
                                        width: ret.messageRoom.otherUserInfo.avatar.width || 0,
                                        height: ret.messageRoom.otherUserInfo.avatar.height || 0,
                                        url: ret.messageRoom.otherUserInfo.avatar.url
                                    },
                                    name: ret.messageRoom.otherUserInfo.name,
                                    rate: ret.messageRoom.otherUserInfo.rate,
                                    height: ret.messageRoom.otherUserInfo.height === null || ret.messageRoom.otherUserInfo.height === undefined ? null : ret.messageRoom.otherUserInfo.height || 0,
                                    deleted: !!ret.messageRoom.otherUserInfo.deleted,
                                    ownerName: ret.messageRoom.otherUserInfo.ownerName === null || ret.messageRoom.otherUserInfo.ownerName === undefined ? null : ret.messageRoom.otherUserInfo.ownerName
                                },
                                unseenMessages: ret.messageRoom.unseenMessages || 0
                            }
                        });

                    case 5:
                    case "end":
                        return _context36.stop();
                }
            }
        }, _callee36, this);
    }));

    return function requestItem(_x74, _x75, _x76, _x77, _x78, _x79, _x80) {
        return _ref36.apply(this, arguments);
    };
}();

var performAction = function () {
    var _ref37 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee37(requestId, action, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee37$(_context37) {
            while (1) {
                switch (_context37.prev = _context37.next) {
                    case 0:
                        args = {
                            requestId: requestId,
                            action: action
                        };
                        _context37.next = 3;
                        return makeRequest({ name: "performAction", args: args, progress: progress });

                    case 3:
                        ret = _context37.sent;
                        return _context37.abrupt("return", {
                            id: ret.id,
                            item: {
                                id: ret.item.id,
                                adjustment: !!ret.item.adjustment,
                                category: ret.item.category,
                                department: ret.item.department,
                                color: ret.item.color,
                                details: ret.item.details,
                                gender: ret.item.gender,
                                thumbImage: {
                                    width: ret.item.thumbImage.width || 0,
                                    height: ret.item.thumbImage.height || 0,
                                    url: ret.item.thumbImage.url
                                },
                                images: ret.item.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: ret.item.brand === null || ret.item.brand === undefined ? null : ret.item.brand,
                                ocasions: ret.item.ocasions.map(function (e) {
                                    return e;
                                }),
                                ownerId: ret.item.ownerId,
                                ownerInfo: {
                                    id: ret.item.ownerInfo.id,
                                    avatar: ret.item.ownerInfo.avatar === null || ret.item.ownerInfo.avatar === undefined ? null : {
                                        width: ret.item.ownerInfo.avatar.width || 0,
                                        height: ret.item.ownerInfo.avatar.height || 0,
                                        url: ret.item.ownerInfo.avatar.url
                                    },
                                    name: ret.item.ownerInfo.name,
                                    rate: ret.item.ownerInfo.rate,
                                    height: ret.item.ownerInfo.height === null || ret.item.ownerInfo.height === undefined ? null : ret.item.ownerInfo.height || 0,
                                    deleted: !!ret.item.ownerInfo.deleted,
                                    ownerName: ret.item.ownerInfo.ownerName === null || ret.item.ownerInfo.ownerName === undefined ? null : ret.item.ownerInfo.ownerName
                                },
                                address: {
                                    neighborhood: ret.item.address.neighborhood,
                                    city: ret.item.address.city,
                                    uf: ret.item.address.uf,
                                    country: ret.item.address.country,
                                    location: {
                                        lat: ret.item.address.location.lat,
                                        lon: ret.item.address.location.lon
                                    }
                                },
                                rentPrice: ret.item.rentPrice || 0,
                                originalPrice: ret.item.originalPrice || 0,
                                size: ret.item.size
                            },
                            period: {
                                start: new Date(parseInt(ret.period.start.split("-")[0], 10), parseInt(ret.period.start.split("-")[1], 10) - 1, parseInt(ret.period.start.split("-")[2], 10)),
                                end: new Date(parseInt(ret.period.end.split("-")[0], 10), parseInt(ret.period.end.split("-")[1], 10) - 1, parseInt(ret.period.end.split("-")[2], 10))
                            },
                            isOwner: !!ret.isOwner,
                            otherUserInfo: {
                                id: ret.otherUserInfo.id,
                                avatar: ret.otherUserInfo.avatar === null || ret.otherUserInfo.avatar === undefined ? null : {
                                    width: ret.otherUserInfo.avatar.width || 0,
                                    height: ret.otherUserInfo.avatar.height || 0,
                                    url: ret.otherUserInfo.avatar.url
                                },
                                name: ret.otherUserInfo.name,
                                rate: ret.otherUserInfo.rate,
                                height: ret.otherUserInfo.height === null || ret.otherUserInfo.height === undefined ? null : ret.otherUserInfo.height || 0,
                                deleted: !!ret.otherUserInfo.deleted,
                                ownerName: ret.otherUserInfo.ownerName === null || ret.otherUserInfo.ownerName === undefined ? null : ret.otherUserInfo.ownerName
                            },
                            actionToPerform: !!ret.actionToPerform,
                            actions: ret.actions.map(function (e) {
                                return e;
                            }),
                            transport: !!ret.transport,
                            rentPrice: ret.rentPrice || 0,
                            originalPrice: ret.originalPrice || 0,
                            statusList: ret.statusList.map(function (e) {
                                return {
                                    status: e.status,
                                    changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                    actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                    pending: !!e.pending
                                };
                            }),
                            currentStatus: {
                                status: ret.currentStatus.status,
                                changeDate: new Date(parseInt(ret.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.currentStatus.changeDate.split("-")[2], 10)),
                                actionBy: ret.currentStatus.actionBy === null || ret.currentStatus.actionBy === undefined ? null : ret.currentStatus.actionBy,
                                pending: !!ret.currentStatus.pending
                            },
                            payment: {
                                card: ret.payment.card === null || ret.payment.card === undefined ? null : {
                                    lastDigits: ret.payment.card.lastDigits,
                                    brand: ret.payment.card.brand,
                                    paidAmount: ret.payment.card.paidAmount || 0
                                },
                                total: ret.payment.total || 0
                            },
                            promotion: {
                                type: ret.promotion.type === null || ret.promotion.type === undefined ? null : ret.promotion.type,
                                total: ret.promotion.total || 0
                            },
                            nfe: ret.nfe === null || ret.nfe === undefined ? null : {
                                id: ret.nfe.id === null || ret.nfe.id === undefined ? null : ret.nfe.id,
                                number: ret.nfe.number === null || ret.nfe.number === undefined ? null : ret.nfe.number || 0,
                                emitedAt: ret.nfe.emitedAt === null || ret.nfe.emitedAt === undefined ? null : new Date(ret.nfe.emitedAt + "Z"),
                                canceledAt: ret.nfe.canceledAt === null || ret.nfe.canceledAt === undefined ? null : new Date(ret.nfe.canceledAt + "Z"),
                                status: ret.nfe.status === null || ret.nfe.status === undefined ? null : ret.nfe.status
                            }
                        });

                    case 5:
                    case "end":
                        return _context37.stop();
                }
            }
        }, _callee37, this);
    }));

    return function performAction(_x81, _x82, _x83) {
        return _ref37.apply(this, arguments);
    };
}();

var getLocRequests = function () {
    var _ref38 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee38(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee38$(_context38) {
            while (1) {
                switch (_context38.prev = _context38.next) {
                    case 0:
                        _context38.next = 2;
                        return makeRequest({ name: "getLocRequests", args: {}, progress: progress });

                    case 2:
                        ret = _context38.sent;
                        return _context38.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                item: {
                                    id: e.item.id,
                                    adjustment: !!e.item.adjustment,
                                    category: e.item.category,
                                    department: e.item.department,
                                    color: e.item.color,
                                    details: e.item.details,
                                    gender: e.item.gender,
                                    thumbImage: {
                                        width: e.item.thumbImage.width || 0,
                                        height: e.item.thumbImage.height || 0,
                                        url: e.item.thumbImage.url
                                    },
                                    images: e.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: e.item.brand === null || e.item.brand === undefined ? null : e.item.brand,
                                    ocasions: e.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    ownerId: e.item.ownerId,
                                    ownerInfo: {
                                        id: e.item.ownerInfo.id,
                                        avatar: e.item.ownerInfo.avatar === null || e.item.ownerInfo.avatar === undefined ? null : {
                                            width: e.item.ownerInfo.avatar.width || 0,
                                            height: e.item.ownerInfo.avatar.height || 0,
                                            url: e.item.ownerInfo.avatar.url
                                        },
                                        name: e.item.ownerInfo.name,
                                        rate: e.item.ownerInfo.rate,
                                        height: e.item.ownerInfo.height === null || e.item.ownerInfo.height === undefined ? null : e.item.ownerInfo.height || 0,
                                        deleted: !!e.item.ownerInfo.deleted,
                                        ownerName: e.item.ownerInfo.ownerName === null || e.item.ownerInfo.ownerName === undefined ? null : e.item.ownerInfo.ownerName
                                    },
                                    address: {
                                        neighborhood: e.item.address.neighborhood,
                                        city: e.item.address.city,
                                        uf: e.item.address.uf,
                                        country: e.item.address.country,
                                        location: {
                                            lat: e.item.address.location.lat,
                                            lon: e.item.address.location.lon
                                        }
                                    },
                                    rentPrice: e.item.rentPrice || 0,
                                    originalPrice: e.item.originalPrice || 0,
                                    size: e.item.size
                                },
                                period: {
                                    start: new Date(parseInt(e.period.start.split("-")[0], 10), parseInt(e.period.start.split("-")[1], 10) - 1, parseInt(e.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.period.end.split("-")[0], 10), parseInt(e.period.end.split("-")[1], 10) - 1, parseInt(e.period.end.split("-")[2], 10))
                                },
                                isOwner: !!e.isOwner,
                                otherUserInfo: {
                                    id: e.otherUserInfo.id,
                                    avatar: e.otherUserInfo.avatar === null || e.otherUserInfo.avatar === undefined ? null : {
                                        width: e.otherUserInfo.avatar.width || 0,
                                        height: e.otherUserInfo.avatar.height || 0,
                                        url: e.otherUserInfo.avatar.url
                                    },
                                    name: e.otherUserInfo.name,
                                    rate: e.otherUserInfo.rate,
                                    height: e.otherUserInfo.height === null || e.otherUserInfo.height === undefined ? null : e.otherUserInfo.height || 0,
                                    deleted: !!e.otherUserInfo.deleted,
                                    ownerName: e.otherUserInfo.ownerName === null || e.otherUserInfo.ownerName === undefined ? null : e.otherUserInfo.ownerName
                                },
                                actionToPerform: !!e.actionToPerform,
                                actions: e.actions.map(function (e) {
                                    return e;
                                }),
                                transport: !!e.transport,
                                rentPrice: e.rentPrice || 0,
                                originalPrice: e.originalPrice || 0,
                                statusList: e.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: e.currentStatus.status,
                                    changeDate: new Date(parseInt(e.currentStatus.changeDate.split("-")[0], 10), parseInt(e.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(e.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: e.currentStatus.actionBy === null || e.currentStatus.actionBy === undefined ? null : e.currentStatus.actionBy,
                                    pending: !!e.currentStatus.pending
                                },
                                payment: {
                                    card: e.payment.card === null || e.payment.card === undefined ? null : {
                                        lastDigits: e.payment.card.lastDigits,
                                        brand: e.payment.card.brand,
                                        paidAmount: e.payment.card.paidAmount || 0
                                    },
                                    total: e.payment.total || 0
                                },
                                promotion: {
                                    type: e.promotion.type === null || e.promotion.type === undefined ? null : e.promotion.type,
                                    total: e.promotion.total || 0
                                },
                                nfe: e.nfe === null || e.nfe === undefined ? null : {
                                    id: e.nfe.id === null || e.nfe.id === undefined ? null : e.nfe.id,
                                    number: e.nfe.number === null || e.nfe.number === undefined ? null : e.nfe.number || 0,
                                    emitedAt: e.nfe.emitedAt === null || e.nfe.emitedAt === undefined ? null : new Date(e.nfe.emitedAt + "Z"),
                                    canceledAt: e.nfe.canceledAt === null || e.nfe.canceledAt === undefined ? null : new Date(e.nfe.canceledAt + "Z"),
                                    status: e.nfe.status === null || e.nfe.status === undefined ? null : e.nfe.status
                                }
                            };
                        }));

                    case 4:
                    case "end":
                        return _context38.stop();
                }
            }
        }, _callee38, this);
    }));

    return function getLocRequests(_x84) {
        return _ref38.apply(this, arguments);
    };
}();

var getLocRequest = function () {
    var _ref39 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee39(requestId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee39$(_context39) {
            while (1) {
                switch (_context39.prev = _context39.next) {
                    case 0:
                        args = {
                            requestId: requestId
                        };
                        _context39.next = 3;
                        return makeRequest({ name: "getLocRequest", args: args, progress: progress });

                    case 3:
                        ret = _context39.sent;
                        return _context39.abrupt("return", {
                            id: ret.id,
                            item: {
                                id: ret.item.id,
                                adjustment: !!ret.item.adjustment,
                                category: ret.item.category,
                                department: ret.item.department,
                                color: ret.item.color,
                                details: ret.item.details,
                                gender: ret.item.gender,
                                thumbImage: {
                                    width: ret.item.thumbImage.width || 0,
                                    height: ret.item.thumbImage.height || 0,
                                    url: ret.item.thumbImage.url
                                },
                                images: ret.item.images.map(function (e) {
                                    return {
                                        width: e.width || 0,
                                        height: e.height || 0,
                                        url: e.url
                                    };
                                }),
                                brand: ret.item.brand === null || ret.item.brand === undefined ? null : ret.item.brand,
                                ocasions: ret.item.ocasions.map(function (e) {
                                    return e;
                                }),
                                ownerId: ret.item.ownerId,
                                ownerInfo: {
                                    id: ret.item.ownerInfo.id,
                                    avatar: ret.item.ownerInfo.avatar === null || ret.item.ownerInfo.avatar === undefined ? null : {
                                        width: ret.item.ownerInfo.avatar.width || 0,
                                        height: ret.item.ownerInfo.avatar.height || 0,
                                        url: ret.item.ownerInfo.avatar.url
                                    },
                                    name: ret.item.ownerInfo.name,
                                    rate: ret.item.ownerInfo.rate,
                                    height: ret.item.ownerInfo.height === null || ret.item.ownerInfo.height === undefined ? null : ret.item.ownerInfo.height || 0,
                                    deleted: !!ret.item.ownerInfo.deleted,
                                    ownerName: ret.item.ownerInfo.ownerName === null || ret.item.ownerInfo.ownerName === undefined ? null : ret.item.ownerInfo.ownerName
                                },
                                address: {
                                    neighborhood: ret.item.address.neighborhood,
                                    city: ret.item.address.city,
                                    uf: ret.item.address.uf,
                                    country: ret.item.address.country,
                                    location: {
                                        lat: ret.item.address.location.lat,
                                        lon: ret.item.address.location.lon
                                    }
                                },
                                rentPrice: ret.item.rentPrice || 0,
                                originalPrice: ret.item.originalPrice || 0,
                                size: ret.item.size
                            },
                            period: {
                                start: new Date(parseInt(ret.period.start.split("-")[0], 10), parseInt(ret.period.start.split("-")[1], 10) - 1, parseInt(ret.period.start.split("-")[2], 10)),
                                end: new Date(parseInt(ret.period.end.split("-")[0], 10), parseInt(ret.period.end.split("-")[1], 10) - 1, parseInt(ret.period.end.split("-")[2], 10))
                            },
                            isOwner: !!ret.isOwner,
                            otherUserInfo: {
                                id: ret.otherUserInfo.id,
                                avatar: ret.otherUserInfo.avatar === null || ret.otherUserInfo.avatar === undefined ? null : {
                                    width: ret.otherUserInfo.avatar.width || 0,
                                    height: ret.otherUserInfo.avatar.height || 0,
                                    url: ret.otherUserInfo.avatar.url
                                },
                                name: ret.otherUserInfo.name,
                                rate: ret.otherUserInfo.rate,
                                height: ret.otherUserInfo.height === null || ret.otherUserInfo.height === undefined ? null : ret.otherUserInfo.height || 0,
                                deleted: !!ret.otherUserInfo.deleted,
                                ownerName: ret.otherUserInfo.ownerName === null || ret.otherUserInfo.ownerName === undefined ? null : ret.otherUserInfo.ownerName
                            },
                            actionToPerform: !!ret.actionToPerform,
                            actions: ret.actions.map(function (e) {
                                return e;
                            }),
                            transport: !!ret.transport,
                            rentPrice: ret.rentPrice || 0,
                            originalPrice: ret.originalPrice || 0,
                            statusList: ret.statusList.map(function (e) {
                                return {
                                    status: e.status,
                                    changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                    actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                    pending: !!e.pending
                                };
                            }),
                            currentStatus: {
                                status: ret.currentStatus.status,
                                changeDate: new Date(parseInt(ret.currentStatus.changeDate.split("-")[0], 10), parseInt(ret.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(ret.currentStatus.changeDate.split("-")[2], 10)),
                                actionBy: ret.currentStatus.actionBy === null || ret.currentStatus.actionBy === undefined ? null : ret.currentStatus.actionBy,
                                pending: !!ret.currentStatus.pending
                            },
                            payment: {
                                card: ret.payment.card === null || ret.payment.card === undefined ? null : {
                                    lastDigits: ret.payment.card.lastDigits,
                                    brand: ret.payment.card.brand,
                                    paidAmount: ret.payment.card.paidAmount || 0
                                },
                                total: ret.payment.total || 0
                            },
                            promotion: {
                                type: ret.promotion.type === null || ret.promotion.type === undefined ? null : ret.promotion.type,
                                total: ret.promotion.total || 0
                            },
                            nfe: ret.nfe === null || ret.nfe === undefined ? null : {
                                id: ret.nfe.id === null || ret.nfe.id === undefined ? null : ret.nfe.id,
                                number: ret.nfe.number === null || ret.nfe.number === undefined ? null : ret.nfe.number || 0,
                                emitedAt: ret.nfe.emitedAt === null || ret.nfe.emitedAt === undefined ? null : new Date(ret.nfe.emitedAt + "Z"),
                                canceledAt: ret.nfe.canceledAt === null || ret.nfe.canceledAt === undefined ? null : new Date(ret.nfe.canceledAt + "Z"),
                                status: ret.nfe.status === null || ret.nfe.status === undefined ? null : ret.nfe.status
                            }
                        });

                    case 5:
                    case "end":
                        return _context39.stop();
                }
            }
        }, _callee39, this);
    }));

    return function getLocRequest(_x85, _x86) {
        return _ref39.apply(this, arguments);
    };
}();

var getHistory = function () {
    var _ref40 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee40(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee40$(_context40) {
            while (1) {
                switch (_context40.prev = _context40.next) {
                    case 0:
                        _context40.next = 2;
                        return makeRequest({ name: "getHistory", args: {}, progress: progress });

                    case 2:
                        ret = _context40.sent;
                        return _context40.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                item: {
                                    id: e.item.id,
                                    adjustment: !!e.item.adjustment,
                                    category: e.item.category,
                                    department: e.item.department,
                                    color: e.item.color,
                                    details: e.item.details,
                                    gender: e.item.gender,
                                    thumbImage: {
                                        width: e.item.thumbImage.width || 0,
                                        height: e.item.thumbImage.height || 0,
                                        url: e.item.thumbImage.url
                                    },
                                    images: e.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: e.item.brand === null || e.item.brand === undefined ? null : e.item.brand,
                                    ocasions: e.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    ownerId: e.item.ownerId,
                                    ownerInfo: {
                                        id: e.item.ownerInfo.id,
                                        avatar: e.item.ownerInfo.avatar === null || e.item.ownerInfo.avatar === undefined ? null : {
                                            width: e.item.ownerInfo.avatar.width || 0,
                                            height: e.item.ownerInfo.avatar.height || 0,
                                            url: e.item.ownerInfo.avatar.url
                                        },
                                        name: e.item.ownerInfo.name,
                                        rate: e.item.ownerInfo.rate,
                                        height: e.item.ownerInfo.height === null || e.item.ownerInfo.height === undefined ? null : e.item.ownerInfo.height || 0,
                                        deleted: !!e.item.ownerInfo.deleted,
                                        ownerName: e.item.ownerInfo.ownerName === null || e.item.ownerInfo.ownerName === undefined ? null : e.item.ownerInfo.ownerName
                                    },
                                    address: {
                                        neighborhood: e.item.address.neighborhood,
                                        city: e.item.address.city,
                                        uf: e.item.address.uf,
                                        country: e.item.address.country,
                                        location: {
                                            lat: e.item.address.location.lat,
                                            lon: e.item.address.location.lon
                                        }
                                    },
                                    rentPrice: e.item.rentPrice || 0,
                                    originalPrice: e.item.originalPrice || 0,
                                    size: e.item.size
                                },
                                period: {
                                    start: new Date(parseInt(e.period.start.split("-")[0], 10), parseInt(e.period.start.split("-")[1], 10) - 1, parseInt(e.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.period.end.split("-")[0], 10), parseInt(e.period.end.split("-")[1], 10) - 1, parseInt(e.period.end.split("-")[2], 10))
                                },
                                isOwner: !!e.isOwner,
                                otherUserInfo: {
                                    id: e.otherUserInfo.id,
                                    avatar: e.otherUserInfo.avatar === null || e.otherUserInfo.avatar === undefined ? null : {
                                        width: e.otherUserInfo.avatar.width || 0,
                                        height: e.otherUserInfo.avatar.height || 0,
                                        url: e.otherUserInfo.avatar.url
                                    },
                                    name: e.otherUserInfo.name,
                                    rate: e.otherUserInfo.rate,
                                    height: e.otherUserInfo.height === null || e.otherUserInfo.height === undefined ? null : e.otherUserInfo.height || 0,
                                    deleted: !!e.otherUserInfo.deleted,
                                    ownerName: e.otherUserInfo.ownerName === null || e.otherUserInfo.ownerName === undefined ? null : e.otherUserInfo.ownerName
                                },
                                actionToPerform: !!e.actionToPerform,
                                actions: e.actions.map(function (e) {
                                    return e;
                                }),
                                transport: !!e.transport,
                                rentPrice: e.rentPrice || 0,
                                originalPrice: e.originalPrice || 0,
                                statusList: e.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: e.currentStatus.status,
                                    changeDate: new Date(parseInt(e.currentStatus.changeDate.split("-")[0], 10), parseInt(e.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(e.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: e.currentStatus.actionBy === null || e.currentStatus.actionBy === undefined ? null : e.currentStatus.actionBy,
                                    pending: !!e.currentStatus.pending
                                },
                                payment: {
                                    card: e.payment.card === null || e.payment.card === undefined ? null : {
                                        lastDigits: e.payment.card.lastDigits,
                                        brand: e.payment.card.brand,
                                        paidAmount: e.payment.card.paidAmount || 0
                                    },
                                    total: e.payment.total || 0
                                },
                                promotion: {
                                    type: e.promotion.type === null || e.promotion.type === undefined ? null : e.promotion.type,
                                    total: e.promotion.total || 0
                                },
                                nfe: e.nfe === null || e.nfe === undefined ? null : {
                                    id: e.nfe.id === null || e.nfe.id === undefined ? null : e.nfe.id,
                                    number: e.nfe.number === null || e.nfe.number === undefined ? null : e.nfe.number || 0,
                                    emitedAt: e.nfe.emitedAt === null || e.nfe.emitedAt === undefined ? null : new Date(e.nfe.emitedAt + "Z"),
                                    canceledAt: e.nfe.canceledAt === null || e.nfe.canceledAt === undefined ? null : new Date(e.nfe.canceledAt + "Z"),
                                    status: e.nfe.status === null || e.nfe.status === undefined ? null : e.nfe.status
                                }
                            };
                        }));

                    case 4:
                    case "end":
                        return _context40.stop();
                }
            }
        }, _callee40, this);
    }));

    return function getHistory(_x87) {
        return _ref40.apply(this, arguments);
    };
}();

var getShippingPrice = function () {
    var _ref41 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee41(itemId, period, address, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee41$(_context41) {
            while (1) {
                switch (_context41.prev = _context41.next) {
                    case 0:
                        args = {
                            itemId: itemId,
                            period: {
                                start: typeof period.start === "string" ? new Date(new Date(period.start).getTime() - new Date(period.start).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(period.start.getTime() - period.start.getTimezoneOffset() * 60000).toISOString().split("T")[0],
                                end: typeof period.end === "string" ? new Date(new Date(period.end).getTime() - new Date(period.end).getTimezoneOffset() * 60000).toISOString().split("T")[0] : new Date(period.end.getTime() - period.end.getTimezoneOffset() * 60000).toISOString().split("T")[0]
                            },
                            address: address === null || address === undefined ? null : {
                                street: address.street,
                                neighborhood: address.neighborhood,
                                city: address.city,
                                uf: address.uf,
                                country: address.country,
                                number: address.number,
                                zip: address.zip,
                                adicionalInfo: address.adicionalInfo,
                                reference: address.reference,
                                location: {
                                    lat: address.location.lat,
                                    lon: address.location.lon
                                }
                            }
                        };
                        _context41.next = 3;
                        return makeRequest({ name: "getShippingPrice", args: args, progress: progress });

                    case 3:
                        ret = _context41.sent;
                        return _context41.abrupt("return", ret || 0);

                    case 5:
                    case "end":
                        return _context41.stop();
                }
            }
        }, _callee41, this);
    }));

    return function getShippingPrice(_x88, _x89, _x90, _x91) {
        return _ref41.apply(this, arguments);
    };
}();

var getPendingLocRequests = function () {
    var _ref42 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee42(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee42$(_context42) {
            while (1) {
                switch (_context42.prev = _context42.next) {
                    case 0:
                        _context42.next = 2;
                        return makeRequest({ name: "getPendingLocRequests", args: {}, progress: progress });

                    case 2:
                        ret = _context42.sent;
                        return _context42.abrupt("return", ret || 0);

                    case 4:
                    case "end":
                        return _context42.stop();
                }
            }
        }, _callee42, this);
    }));

    return function getPendingLocRequests(_x92) {
        return _ref42.apply(this, arguments);
    };
}();

var getPromotion = function () {
    var _ref43 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee43(promotionId, itemId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee43$(_context43) {
            while (1) {
                switch (_context43.prev = _context43.next) {
                    case 0:
                        args = {
                            promotionId: promotionId,
                            itemId: itemId === null || itemId === undefined ? null : itemId
                        };
                        _context43.next = 3;
                        return makeRequest({ name: "getPromotion", args: args, progress: progress });

                    case 3:
                        ret = _context43.sent;
                        return _context43.abrupt("return", {
                            id: ret.id,
                            value: ret.value === null || ret.value === undefined ? null : ret.value || 0,
                            percentage: ret.percentage === null || ret.percentage === undefined ? null : ret.percentage || 0,
                            type: ret.type
                        });

                    case 5:
                    case "end":
                        return _context43.stop();
                }
            }
        }, _callee43, this);
    }));

    return function getPromotion(_x93, _x94, _x95) {
        return _ref43.apply(this, arguments);
    };
}();

var sendMessage = function () {
    var _ref44 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee44(message, localMessageId, toUser, itemId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee44$(_context44) {
            while (1) {
                switch (_context44.prev = _context44.next) {
                    case 0:
                        args = {
                            message: message,
                            localMessageId: localMessageId,
                            toUser: toUser,
                            itemId: itemId === null || itemId === undefined ? null : itemId
                        };
                        _context44.next = 3;
                        return makeRequest({ name: "sendMessage", args: args, progress: progress });

                    case 3:
                        ret = _context44.sent;
                        return _context44.abrupt("return", {
                            id: ret.id,
                            messageRoomId: ret.messageRoomId.map(function (e) {
                                return e;
                            }),
                            localMessageId: ret.localMessageId === null || ret.localMessageId === undefined ? null : ret.localMessageId,
                            type: ret.type,
                            content: {
                                text: ret.content.text === null || ret.content.text === undefined ? null : ret.content.text,
                                image: ret.content.image === null || ret.content.image === undefined ? null : {
                                    width: ret.content.image.width || 0,
                                    height: ret.content.image.height || 0,
                                    url: ret.content.image.url
                                },
                                statusChanged: ret.content.statusChanged === null || ret.content.statusChanged === undefined ? null : {
                                    requestId: ret.content.statusChanged.requestId,
                                    itemId: ret.content.statusChanged.itemId,
                                    isOwner: !!ret.content.statusChanged.isOwner,
                                    oldStatus: ret.content.statusChanged.oldStatus === null || ret.content.statusChanged.oldStatus === undefined ? null : ret.content.statusChanged.oldStatus,
                                    newStatus: ret.content.statusChanged.newStatus,
                                    thumbImage: {
                                        width: ret.content.statusChanged.thumbImage.width || 0,
                                        height: ret.content.statusChanged.thumbImage.height || 0,
                                        url: ret.content.statusChanged.thumbImage.url
                                    },
                                    message: ret.content.statusChanged.message
                                },
                                itemSelected: ret.content.itemSelected === null || ret.content.itemSelected === undefined ? null : {
                                    id: ret.content.itemSelected.id,
                                    adjustment: !!ret.content.itemSelected.adjustment,
                                    category: ret.content.itemSelected.category,
                                    department: ret.content.itemSelected.department,
                                    color: ret.content.itemSelected.color,
                                    details: ret.content.itemSelected.details,
                                    gender: ret.content.itemSelected.gender,
                                    thumbImage: {
                                        width: ret.content.itemSelected.thumbImage.width || 0,
                                        height: ret.content.itemSelected.thumbImage.height || 0,
                                        url: ret.content.itemSelected.thumbImage.url
                                    },
                                    images: ret.content.itemSelected.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: ret.content.itemSelected.brand === null || ret.content.itemSelected.brand === undefined ? null : ret.content.itemSelected.brand,
                                    ocasions: ret.content.itemSelected.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    ownerId: ret.content.itemSelected.ownerId,
                                    ownerInfo: {
                                        id: ret.content.itemSelected.ownerInfo.id,
                                        avatar: ret.content.itemSelected.ownerInfo.avatar === null || ret.content.itemSelected.ownerInfo.avatar === undefined ? null : {
                                            width: ret.content.itemSelected.ownerInfo.avatar.width || 0,
                                            height: ret.content.itemSelected.ownerInfo.avatar.height || 0,
                                            url: ret.content.itemSelected.ownerInfo.avatar.url
                                        },
                                        name: ret.content.itemSelected.ownerInfo.name,
                                        rate: ret.content.itemSelected.ownerInfo.rate,
                                        height: ret.content.itemSelected.ownerInfo.height === null || ret.content.itemSelected.ownerInfo.height === undefined ? null : ret.content.itemSelected.ownerInfo.height || 0,
                                        deleted: !!ret.content.itemSelected.ownerInfo.deleted,
                                        ownerName: ret.content.itemSelected.ownerInfo.ownerName === null || ret.content.itemSelected.ownerInfo.ownerName === undefined ? null : ret.content.itemSelected.ownerInfo.ownerName
                                    },
                                    address: {
                                        neighborhood: ret.content.itemSelected.address.neighborhood,
                                        city: ret.content.itemSelected.address.city,
                                        uf: ret.content.itemSelected.address.uf,
                                        country: ret.content.itemSelected.address.country,
                                        location: {
                                            lat: ret.content.itemSelected.address.location.lat,
                                            lon: ret.content.itemSelected.address.location.lon
                                        }
                                    },
                                    rentPrice: ret.content.itemSelected.rentPrice || 0,
                                    originalPrice: ret.content.itemSelected.originalPrice || 0,
                                    size: ret.content.itemSelected.size
                                }
                            },
                            date: new Date(ret.date + "Z"),
                            senderId: ret.senderId === null || ret.senderId === undefined ? null : ret.senderId
                        });

                    case 5:
                    case "end":
                        return _context44.stop();
                }
            }
        }, _callee44, this);
    }));

    return function sendMessage(_x96, _x97, _x98, _x99, _x100) {
        return _ref44.apply(this, arguments);
    };
}();

var sendImage = function () {
    var _ref45 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee45(image, localMessageId, toUser, itemId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee45$(_context45) {
            while (1) {
                switch (_context45.prev = _context45.next) {
                    case 0:
                        args = {
                            image: image.toString("base64"),
                            localMessageId: localMessageId,
                            toUser: toUser,
                            itemId: itemId === null || itemId === undefined ? null : itemId
                        };
                        _context45.next = 3;
                        return makeRequest({ name: "sendImage", args: args, progress: progress });

                    case 3:
                        ret = _context45.sent;
                        return _context45.abrupt("return", {
                            id: ret.id,
                            messageRoomId: ret.messageRoomId.map(function (e) {
                                return e;
                            }),
                            localMessageId: ret.localMessageId === null || ret.localMessageId === undefined ? null : ret.localMessageId,
                            type: ret.type,
                            content: {
                                text: ret.content.text === null || ret.content.text === undefined ? null : ret.content.text,
                                image: ret.content.image === null || ret.content.image === undefined ? null : {
                                    width: ret.content.image.width || 0,
                                    height: ret.content.image.height || 0,
                                    url: ret.content.image.url
                                },
                                statusChanged: ret.content.statusChanged === null || ret.content.statusChanged === undefined ? null : {
                                    requestId: ret.content.statusChanged.requestId,
                                    itemId: ret.content.statusChanged.itemId,
                                    isOwner: !!ret.content.statusChanged.isOwner,
                                    oldStatus: ret.content.statusChanged.oldStatus === null || ret.content.statusChanged.oldStatus === undefined ? null : ret.content.statusChanged.oldStatus,
                                    newStatus: ret.content.statusChanged.newStatus,
                                    thumbImage: {
                                        width: ret.content.statusChanged.thumbImage.width || 0,
                                        height: ret.content.statusChanged.thumbImage.height || 0,
                                        url: ret.content.statusChanged.thumbImage.url
                                    },
                                    message: ret.content.statusChanged.message
                                },
                                itemSelected: ret.content.itemSelected === null || ret.content.itemSelected === undefined ? null : {
                                    id: ret.content.itemSelected.id,
                                    adjustment: !!ret.content.itemSelected.adjustment,
                                    category: ret.content.itemSelected.category,
                                    department: ret.content.itemSelected.department,
                                    color: ret.content.itemSelected.color,
                                    details: ret.content.itemSelected.details,
                                    gender: ret.content.itemSelected.gender,
                                    thumbImage: {
                                        width: ret.content.itemSelected.thumbImage.width || 0,
                                        height: ret.content.itemSelected.thumbImage.height || 0,
                                        url: ret.content.itemSelected.thumbImage.url
                                    },
                                    images: ret.content.itemSelected.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: ret.content.itemSelected.brand === null || ret.content.itemSelected.brand === undefined ? null : ret.content.itemSelected.brand,
                                    ocasions: ret.content.itemSelected.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    ownerId: ret.content.itemSelected.ownerId,
                                    ownerInfo: {
                                        id: ret.content.itemSelected.ownerInfo.id,
                                        avatar: ret.content.itemSelected.ownerInfo.avatar === null || ret.content.itemSelected.ownerInfo.avatar === undefined ? null : {
                                            width: ret.content.itemSelected.ownerInfo.avatar.width || 0,
                                            height: ret.content.itemSelected.ownerInfo.avatar.height || 0,
                                            url: ret.content.itemSelected.ownerInfo.avatar.url
                                        },
                                        name: ret.content.itemSelected.ownerInfo.name,
                                        rate: ret.content.itemSelected.ownerInfo.rate,
                                        height: ret.content.itemSelected.ownerInfo.height === null || ret.content.itemSelected.ownerInfo.height === undefined ? null : ret.content.itemSelected.ownerInfo.height || 0,
                                        deleted: !!ret.content.itemSelected.ownerInfo.deleted,
                                        ownerName: ret.content.itemSelected.ownerInfo.ownerName === null || ret.content.itemSelected.ownerInfo.ownerName === undefined ? null : ret.content.itemSelected.ownerInfo.ownerName
                                    },
                                    address: {
                                        neighborhood: ret.content.itemSelected.address.neighborhood,
                                        city: ret.content.itemSelected.address.city,
                                        uf: ret.content.itemSelected.address.uf,
                                        country: ret.content.itemSelected.address.country,
                                        location: {
                                            lat: ret.content.itemSelected.address.location.lat,
                                            lon: ret.content.itemSelected.address.location.lon
                                        }
                                    },
                                    rentPrice: ret.content.itemSelected.rentPrice || 0,
                                    originalPrice: ret.content.itemSelected.originalPrice || 0,
                                    size: ret.content.itemSelected.size
                                }
                            },
                            date: new Date(ret.date + "Z"),
                            senderId: ret.senderId === null || ret.senderId === undefined ? null : ret.senderId
                        });

                    case 5:
                    case "end":
                        return _context45.stop();
                }
            }
        }, _callee45, this);
    }));

    return function sendImage(_x101, _x102, _x103, _x104, _x105) {
        return _ref45.apply(this, arguments);
    };
}();

var setLastSeenMessage = function () {
    var _ref46 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee46(messageId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee46$(_context46) {
            while (1) {
                switch (_context46.prev = _context46.next) {
                    case 0:
                        args = {
                            messageId: messageId
                        };
                        _context46.next = 3;
                        return makeRequest({ name: "setLastSeenMessage", args: args, progress: progress });

                    case 3:
                        return _context46.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context46.stop();
                }
            }
        }, _callee46, this);
    }));

    return function setLastSeenMessage(_x106, _x107) {
        return _ref46.apply(this, arguments);
    };
}();

var getMessagesRooms = function () {
    var _ref47 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee47(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee47$(_context47) {
            while (1) {
                switch (_context47.prev = _context47.next) {
                    case 0:
                        _context47.next = 2;
                        return makeRequest({ name: "getMessagesRooms", args: {}, progress: progress });

                    case 2:
                        ret = _context47.sent;
                        return _context47.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id.map(function (e) {
                                    return e;
                                }),
                                lastMessage: e.lastMessage === null || e.lastMessage === undefined ? null : {
                                    id: e.lastMessage.id,
                                    messageRoomId: e.lastMessage.messageRoomId.map(function (e) {
                                        return e;
                                    }),
                                    localMessageId: e.lastMessage.localMessageId === null || e.lastMessage.localMessageId === undefined ? null : e.lastMessage.localMessageId,
                                    type: e.lastMessage.type,
                                    content: {
                                        text: e.lastMessage.content.text === null || e.lastMessage.content.text === undefined ? null : e.lastMessage.content.text,
                                        image: e.lastMessage.content.image === null || e.lastMessage.content.image === undefined ? null : {
                                            width: e.lastMessage.content.image.width || 0,
                                            height: e.lastMessage.content.image.height || 0,
                                            url: e.lastMessage.content.image.url
                                        },
                                        statusChanged: e.lastMessage.content.statusChanged === null || e.lastMessage.content.statusChanged === undefined ? null : {
                                            requestId: e.lastMessage.content.statusChanged.requestId,
                                            itemId: e.lastMessage.content.statusChanged.itemId,
                                            isOwner: !!e.lastMessage.content.statusChanged.isOwner,
                                            oldStatus: e.lastMessage.content.statusChanged.oldStatus === null || e.lastMessage.content.statusChanged.oldStatus === undefined ? null : e.lastMessage.content.statusChanged.oldStatus,
                                            newStatus: e.lastMessage.content.statusChanged.newStatus,
                                            thumbImage: {
                                                width: e.lastMessage.content.statusChanged.thumbImage.width || 0,
                                                height: e.lastMessage.content.statusChanged.thumbImage.height || 0,
                                                url: e.lastMessage.content.statusChanged.thumbImage.url
                                            },
                                            message: e.lastMessage.content.statusChanged.message
                                        },
                                        itemSelected: e.lastMessage.content.itemSelected === null || e.lastMessage.content.itemSelected === undefined ? null : {
                                            id: e.lastMessage.content.itemSelected.id,
                                            adjustment: !!e.lastMessage.content.itemSelected.adjustment,
                                            category: e.lastMessage.content.itemSelected.category,
                                            department: e.lastMessage.content.itemSelected.department,
                                            color: e.lastMessage.content.itemSelected.color,
                                            details: e.lastMessage.content.itemSelected.details,
                                            gender: e.lastMessage.content.itemSelected.gender,
                                            thumbImage: {
                                                width: e.lastMessage.content.itemSelected.thumbImage.width || 0,
                                                height: e.lastMessage.content.itemSelected.thumbImage.height || 0,
                                                url: e.lastMessage.content.itemSelected.thumbImage.url
                                            },
                                            images: e.lastMessage.content.itemSelected.images.map(function (e) {
                                                return {
                                                    width: e.width || 0,
                                                    height: e.height || 0,
                                                    url: e.url
                                                };
                                            }),
                                            brand: e.lastMessage.content.itemSelected.brand === null || e.lastMessage.content.itemSelected.brand === undefined ? null : e.lastMessage.content.itemSelected.brand,
                                            ocasions: e.lastMessage.content.itemSelected.ocasions.map(function (e) {
                                                return e;
                                            }),
                                            ownerId: e.lastMessage.content.itemSelected.ownerId,
                                            ownerInfo: {
                                                id: e.lastMessage.content.itemSelected.ownerInfo.id,
                                                avatar: e.lastMessage.content.itemSelected.ownerInfo.avatar === null || e.lastMessage.content.itemSelected.ownerInfo.avatar === undefined ? null : {
                                                    width: e.lastMessage.content.itemSelected.ownerInfo.avatar.width || 0,
                                                    height: e.lastMessage.content.itemSelected.ownerInfo.avatar.height || 0,
                                                    url: e.lastMessage.content.itemSelected.ownerInfo.avatar.url
                                                },
                                                name: e.lastMessage.content.itemSelected.ownerInfo.name,
                                                rate: e.lastMessage.content.itemSelected.ownerInfo.rate,
                                                height: e.lastMessage.content.itemSelected.ownerInfo.height === null || e.lastMessage.content.itemSelected.ownerInfo.height === undefined ? null : e.lastMessage.content.itemSelected.ownerInfo.height || 0,
                                                deleted: !!e.lastMessage.content.itemSelected.ownerInfo.deleted,
                                                ownerName: e.lastMessage.content.itemSelected.ownerInfo.ownerName === null || e.lastMessage.content.itemSelected.ownerInfo.ownerName === undefined ? null : e.lastMessage.content.itemSelected.ownerInfo.ownerName
                                            },
                                            address: {
                                                neighborhood: e.lastMessage.content.itemSelected.address.neighborhood,
                                                city: e.lastMessage.content.itemSelected.address.city,
                                                uf: e.lastMessage.content.itemSelected.address.uf,
                                                country: e.lastMessage.content.itemSelected.address.country,
                                                location: {
                                                    lat: e.lastMessage.content.itemSelected.address.location.lat,
                                                    lon: e.lastMessage.content.itemSelected.address.location.lon
                                                }
                                            },
                                            rentPrice: e.lastMessage.content.itemSelected.rentPrice || 0,
                                            originalPrice: e.lastMessage.content.itemSelected.originalPrice || 0,
                                            size: e.lastMessage.content.itemSelected.size
                                        }
                                    },
                                    date: new Date(e.lastMessage.date + "Z"),
                                    senderId: e.lastMessage.senderId === null || e.lastMessage.senderId === undefined ? null : e.lastMessage.senderId
                                },
                                otherUserInfo: {
                                    id: e.otherUserInfo.id,
                                    avatar: e.otherUserInfo.avatar === null || e.otherUserInfo.avatar === undefined ? null : {
                                        width: e.otherUserInfo.avatar.width || 0,
                                        height: e.otherUserInfo.avatar.height || 0,
                                        url: e.otherUserInfo.avatar.url
                                    },
                                    name: e.otherUserInfo.name,
                                    rate: e.otherUserInfo.rate,
                                    height: e.otherUserInfo.height === null || e.otherUserInfo.height === undefined ? null : e.otherUserInfo.height || 0,
                                    deleted: !!e.otherUserInfo.deleted,
                                    ownerName: e.otherUserInfo.ownerName === null || e.otherUserInfo.ownerName === undefined ? null : e.otherUserInfo.ownerName
                                },
                                unseenMessages: e.unseenMessages || 0
                            };
                        }));

                    case 4:
                    case "end":
                        return _context47.stop();
                }
            }
        }, _callee47, this);
    }));

    return function getMessagesRooms(_x108) {
        return _ref47.apply(this, arguments);
    };
}();

var getMessageRoom = function () {
    var _ref48 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee48(id, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee48$(_context48) {
            while (1) {
                switch (_context48.prev = _context48.next) {
                    case 0:
                        args = {
                            id: id.map(function (e) {
                                return e;
                            })
                        };
                        _context48.next = 3;
                        return makeRequest({ name: "getMessageRoom", args: args, progress: progress });

                    case 3:
                        ret = _context48.sent;
                        return _context48.abrupt("return", {
                            id: ret.id.map(function (e) {
                                return e;
                            }),
                            lastMessage: ret.lastMessage === null || ret.lastMessage === undefined ? null : {
                                id: ret.lastMessage.id,
                                messageRoomId: ret.lastMessage.messageRoomId.map(function (e) {
                                    return e;
                                }),
                                localMessageId: ret.lastMessage.localMessageId === null || ret.lastMessage.localMessageId === undefined ? null : ret.lastMessage.localMessageId,
                                type: ret.lastMessage.type,
                                content: {
                                    text: ret.lastMessage.content.text === null || ret.lastMessage.content.text === undefined ? null : ret.lastMessage.content.text,
                                    image: ret.lastMessage.content.image === null || ret.lastMessage.content.image === undefined ? null : {
                                        width: ret.lastMessage.content.image.width || 0,
                                        height: ret.lastMessage.content.image.height || 0,
                                        url: ret.lastMessage.content.image.url
                                    },
                                    statusChanged: ret.lastMessage.content.statusChanged === null || ret.lastMessage.content.statusChanged === undefined ? null : {
                                        requestId: ret.lastMessage.content.statusChanged.requestId,
                                        itemId: ret.lastMessage.content.statusChanged.itemId,
                                        isOwner: !!ret.lastMessage.content.statusChanged.isOwner,
                                        oldStatus: ret.lastMessage.content.statusChanged.oldStatus === null || ret.lastMessage.content.statusChanged.oldStatus === undefined ? null : ret.lastMessage.content.statusChanged.oldStatus,
                                        newStatus: ret.lastMessage.content.statusChanged.newStatus,
                                        thumbImage: {
                                            width: ret.lastMessage.content.statusChanged.thumbImage.width || 0,
                                            height: ret.lastMessage.content.statusChanged.thumbImage.height || 0,
                                            url: ret.lastMessage.content.statusChanged.thumbImage.url
                                        },
                                        message: ret.lastMessage.content.statusChanged.message
                                    },
                                    itemSelected: ret.lastMessage.content.itemSelected === null || ret.lastMessage.content.itemSelected === undefined ? null : {
                                        id: ret.lastMessage.content.itemSelected.id,
                                        adjustment: !!ret.lastMessage.content.itemSelected.adjustment,
                                        category: ret.lastMessage.content.itemSelected.category,
                                        department: ret.lastMessage.content.itemSelected.department,
                                        color: ret.lastMessage.content.itemSelected.color,
                                        details: ret.lastMessage.content.itemSelected.details,
                                        gender: ret.lastMessage.content.itemSelected.gender,
                                        thumbImage: {
                                            width: ret.lastMessage.content.itemSelected.thumbImage.width || 0,
                                            height: ret.lastMessage.content.itemSelected.thumbImage.height || 0,
                                            url: ret.lastMessage.content.itemSelected.thumbImage.url
                                        },
                                        images: ret.lastMessage.content.itemSelected.images.map(function (e) {
                                            return {
                                                width: e.width || 0,
                                                height: e.height || 0,
                                                url: e.url
                                            };
                                        }),
                                        brand: ret.lastMessage.content.itemSelected.brand === null || ret.lastMessage.content.itemSelected.brand === undefined ? null : ret.lastMessage.content.itemSelected.brand,
                                        ocasions: ret.lastMessage.content.itemSelected.ocasions.map(function (e) {
                                            return e;
                                        }),
                                        ownerId: ret.lastMessage.content.itemSelected.ownerId,
                                        ownerInfo: {
                                            id: ret.lastMessage.content.itemSelected.ownerInfo.id,
                                            avatar: ret.lastMessage.content.itemSelected.ownerInfo.avatar === null || ret.lastMessage.content.itemSelected.ownerInfo.avatar === undefined ? null : {
                                                width: ret.lastMessage.content.itemSelected.ownerInfo.avatar.width || 0,
                                                height: ret.lastMessage.content.itemSelected.ownerInfo.avatar.height || 0,
                                                url: ret.lastMessage.content.itemSelected.ownerInfo.avatar.url
                                            },
                                            name: ret.lastMessage.content.itemSelected.ownerInfo.name,
                                            rate: ret.lastMessage.content.itemSelected.ownerInfo.rate,
                                            height: ret.lastMessage.content.itemSelected.ownerInfo.height === null || ret.lastMessage.content.itemSelected.ownerInfo.height === undefined ? null : ret.lastMessage.content.itemSelected.ownerInfo.height || 0,
                                            deleted: !!ret.lastMessage.content.itemSelected.ownerInfo.deleted,
                                            ownerName: ret.lastMessage.content.itemSelected.ownerInfo.ownerName === null || ret.lastMessage.content.itemSelected.ownerInfo.ownerName === undefined ? null : ret.lastMessage.content.itemSelected.ownerInfo.ownerName
                                        },
                                        address: {
                                            neighborhood: ret.lastMessage.content.itemSelected.address.neighborhood,
                                            city: ret.lastMessage.content.itemSelected.address.city,
                                            uf: ret.lastMessage.content.itemSelected.address.uf,
                                            country: ret.lastMessage.content.itemSelected.address.country,
                                            location: {
                                                lat: ret.lastMessage.content.itemSelected.address.location.lat,
                                                lon: ret.lastMessage.content.itemSelected.address.location.lon
                                            }
                                        },
                                        rentPrice: ret.lastMessage.content.itemSelected.rentPrice || 0,
                                        originalPrice: ret.lastMessage.content.itemSelected.originalPrice || 0,
                                        size: ret.lastMessage.content.itemSelected.size
                                    }
                                },
                                date: new Date(ret.lastMessage.date + "Z"),
                                senderId: ret.lastMessage.senderId === null || ret.lastMessage.senderId === undefined ? null : ret.lastMessage.senderId
                            },
                            otherUserInfo: {
                                id: ret.otherUserInfo.id,
                                avatar: ret.otherUserInfo.avatar === null || ret.otherUserInfo.avatar === undefined ? null : {
                                    width: ret.otherUserInfo.avatar.width || 0,
                                    height: ret.otherUserInfo.avatar.height || 0,
                                    url: ret.otherUserInfo.avatar.url
                                },
                                name: ret.otherUserInfo.name,
                                rate: ret.otherUserInfo.rate,
                                height: ret.otherUserInfo.height === null || ret.otherUserInfo.height === undefined ? null : ret.otherUserInfo.height || 0,
                                deleted: !!ret.otherUserInfo.deleted,
                                ownerName: ret.otherUserInfo.ownerName === null || ret.otherUserInfo.ownerName === undefined ? null : ret.otherUserInfo.ownerName
                            },
                            unseenMessages: ret.unseenMessages || 0
                        });

                    case 5:
                    case "end":
                        return _context48.stop();
                }
            }
        }, _callee48, this);
    }));

    return function getMessageRoom(_x109, _x110) {
        return _ref48.apply(this, arguments);
    };
}();

var getMessages = function () {
    var _ref49 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee49(messageRoomId, currentOffset, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee49$(_context49) {
            while (1) {
                switch (_context49.prev = _context49.next) {
                    case 0:
                        args = {
                            messageRoomId: messageRoomId.map(function (e) {
                                return e;
                            }),
                            currentOffset: currentOffset === null || currentOffset === undefined ? null : currentOffset || 0
                        };
                        _context49.next = 3;
                        return makeRequest({ name: "getMessages", args: args, progress: progress });

                    case 3:
                        ret = _context49.sent;
                        return _context49.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                messageRoomId: e.messageRoomId.map(function (e) {
                                    return e;
                                }),
                                localMessageId: e.localMessageId === null || e.localMessageId === undefined ? null : e.localMessageId,
                                type: e.type,
                                content: {
                                    text: e.content.text === null || e.content.text === undefined ? null : e.content.text,
                                    image: e.content.image === null || e.content.image === undefined ? null : {
                                        width: e.content.image.width || 0,
                                        height: e.content.image.height || 0,
                                        url: e.content.image.url
                                    },
                                    statusChanged: e.content.statusChanged === null || e.content.statusChanged === undefined ? null : {
                                        requestId: e.content.statusChanged.requestId,
                                        itemId: e.content.statusChanged.itemId,
                                        isOwner: !!e.content.statusChanged.isOwner,
                                        oldStatus: e.content.statusChanged.oldStatus === null || e.content.statusChanged.oldStatus === undefined ? null : e.content.statusChanged.oldStatus,
                                        newStatus: e.content.statusChanged.newStatus,
                                        thumbImage: {
                                            width: e.content.statusChanged.thumbImage.width || 0,
                                            height: e.content.statusChanged.thumbImage.height || 0,
                                            url: e.content.statusChanged.thumbImage.url
                                        },
                                        message: e.content.statusChanged.message
                                    },
                                    itemSelected: e.content.itemSelected === null || e.content.itemSelected === undefined ? null : {
                                        id: e.content.itemSelected.id,
                                        adjustment: !!e.content.itemSelected.adjustment,
                                        category: e.content.itemSelected.category,
                                        department: e.content.itemSelected.department,
                                        color: e.content.itemSelected.color,
                                        details: e.content.itemSelected.details,
                                        gender: e.content.itemSelected.gender,
                                        thumbImage: {
                                            width: e.content.itemSelected.thumbImage.width || 0,
                                            height: e.content.itemSelected.thumbImage.height || 0,
                                            url: e.content.itemSelected.thumbImage.url
                                        },
                                        images: e.content.itemSelected.images.map(function (e) {
                                            return {
                                                width: e.width || 0,
                                                height: e.height || 0,
                                                url: e.url
                                            };
                                        }),
                                        brand: e.content.itemSelected.brand === null || e.content.itemSelected.brand === undefined ? null : e.content.itemSelected.brand,
                                        ocasions: e.content.itemSelected.ocasions.map(function (e) {
                                            return e;
                                        }),
                                        ownerId: e.content.itemSelected.ownerId,
                                        ownerInfo: {
                                            id: e.content.itemSelected.ownerInfo.id,
                                            avatar: e.content.itemSelected.ownerInfo.avatar === null || e.content.itemSelected.ownerInfo.avatar === undefined ? null : {
                                                width: e.content.itemSelected.ownerInfo.avatar.width || 0,
                                                height: e.content.itemSelected.ownerInfo.avatar.height || 0,
                                                url: e.content.itemSelected.ownerInfo.avatar.url
                                            },
                                            name: e.content.itemSelected.ownerInfo.name,
                                            rate: e.content.itemSelected.ownerInfo.rate,
                                            height: e.content.itemSelected.ownerInfo.height === null || e.content.itemSelected.ownerInfo.height === undefined ? null : e.content.itemSelected.ownerInfo.height || 0,
                                            deleted: !!e.content.itemSelected.ownerInfo.deleted,
                                            ownerName: e.content.itemSelected.ownerInfo.ownerName === null || e.content.itemSelected.ownerInfo.ownerName === undefined ? null : e.content.itemSelected.ownerInfo.ownerName
                                        },
                                        address: {
                                            neighborhood: e.content.itemSelected.address.neighborhood,
                                            city: e.content.itemSelected.address.city,
                                            uf: e.content.itemSelected.address.uf,
                                            country: e.content.itemSelected.address.country,
                                            location: {
                                                lat: e.content.itemSelected.address.location.lat,
                                                lon: e.content.itemSelected.address.location.lon
                                            }
                                        },
                                        rentPrice: e.content.itemSelected.rentPrice || 0,
                                        originalPrice: e.content.itemSelected.originalPrice || 0,
                                        size: e.content.itemSelected.size
                                    }
                                },
                                date: new Date(e.date + "Z"),
                                senderId: e.senderId === null || e.senderId === undefined ? null : e.senderId
                            };
                        }));

                    case 5:
                    case "end":
                        return _context49.stop();
                }
            }
        }, _callee49, this);
    }));

    return function getMessages(_x111, _x112, _x113) {
        return _ref49.apply(this, arguments);
    };
}();

var rate = function () {
    var _ref50 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee50(rating, requestId, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee50$(_context50) {
            while (1) {
                switch (_context50.prev = _context50.next) {
                    case 0:
                        args = {
                            rating: rating || 0,
                            requestId: requestId
                        };
                        _context50.next = 3;
                        return makeRequest({ name: "rate", args: args, progress: progress });

                    case 3:
                        return _context50.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context50.stop();
                }
            }
        }, _callee50, this);
    }));

    return function rate(_x114, _x115, _x116) {
        return _ref50.apply(this, arguments);
    };
}();

var getPendingRates = function () {
    var _ref51 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee51(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee51$(_context51) {
            while (1) {
                switch (_context51.prev = _context51.next) {
                    case 0:
                        _context51.next = 2;
                        return makeRequest({ name: "getPendingRates", args: {}, progress: progress });

                    case 2:
                        ret = _context51.sent;
                        return _context51.abrupt("return", ret.map(function (e) {
                            return {
                                id: e.id,
                                item: {
                                    id: e.item.id,
                                    adjustment: !!e.item.adjustment,
                                    category: e.item.category,
                                    department: e.item.department,
                                    color: e.item.color,
                                    details: e.item.details,
                                    gender: e.item.gender,
                                    thumbImage: {
                                        width: e.item.thumbImage.width || 0,
                                        height: e.item.thumbImage.height || 0,
                                        url: e.item.thumbImage.url
                                    },
                                    images: e.item.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: e.item.brand === null || e.item.brand === undefined ? null : e.item.brand,
                                    ocasions: e.item.ocasions.map(function (e) {
                                        return e;
                                    }),
                                    ownerId: e.item.ownerId,
                                    ownerInfo: {
                                        id: e.item.ownerInfo.id,
                                        avatar: e.item.ownerInfo.avatar === null || e.item.ownerInfo.avatar === undefined ? null : {
                                            width: e.item.ownerInfo.avatar.width || 0,
                                            height: e.item.ownerInfo.avatar.height || 0,
                                            url: e.item.ownerInfo.avatar.url
                                        },
                                        name: e.item.ownerInfo.name,
                                        rate: e.item.ownerInfo.rate,
                                        height: e.item.ownerInfo.height === null || e.item.ownerInfo.height === undefined ? null : e.item.ownerInfo.height || 0,
                                        deleted: !!e.item.ownerInfo.deleted,
                                        ownerName: e.item.ownerInfo.ownerName === null || e.item.ownerInfo.ownerName === undefined ? null : e.item.ownerInfo.ownerName
                                    },
                                    address: {
                                        neighborhood: e.item.address.neighborhood,
                                        city: e.item.address.city,
                                        uf: e.item.address.uf,
                                        country: e.item.address.country,
                                        location: {
                                            lat: e.item.address.location.lat,
                                            lon: e.item.address.location.lon
                                        }
                                    },
                                    rentPrice: e.item.rentPrice || 0,
                                    originalPrice: e.item.originalPrice || 0,
                                    size: e.item.size
                                },
                                period: {
                                    start: new Date(parseInt(e.period.start.split("-")[0], 10), parseInt(e.period.start.split("-")[1], 10) - 1, parseInt(e.period.start.split("-")[2], 10)),
                                    end: new Date(parseInt(e.period.end.split("-")[0], 10), parseInt(e.period.end.split("-")[1], 10) - 1, parseInt(e.period.end.split("-")[2], 10))
                                },
                                isOwner: !!e.isOwner,
                                otherUserInfo: {
                                    id: e.otherUserInfo.id,
                                    avatar: e.otherUserInfo.avatar === null || e.otherUserInfo.avatar === undefined ? null : {
                                        width: e.otherUserInfo.avatar.width || 0,
                                        height: e.otherUserInfo.avatar.height || 0,
                                        url: e.otherUserInfo.avatar.url
                                    },
                                    name: e.otherUserInfo.name,
                                    rate: e.otherUserInfo.rate,
                                    height: e.otherUserInfo.height === null || e.otherUserInfo.height === undefined ? null : e.otherUserInfo.height || 0,
                                    deleted: !!e.otherUserInfo.deleted,
                                    ownerName: e.otherUserInfo.ownerName === null || e.otherUserInfo.ownerName === undefined ? null : e.otherUserInfo.ownerName
                                },
                                actionToPerform: !!e.actionToPerform,
                                actions: e.actions.map(function (e) {
                                    return e;
                                }),
                                transport: !!e.transport,
                                rentPrice: e.rentPrice || 0,
                                originalPrice: e.originalPrice || 0,
                                statusList: e.statusList.map(function (e) {
                                    return {
                                        status: e.status,
                                        changeDate: new Date(parseInt(e.changeDate.split("-")[0], 10), parseInt(e.changeDate.split("-")[1], 10) - 1, parseInt(e.changeDate.split("-")[2], 10)),
                                        actionBy: e.actionBy === null || e.actionBy === undefined ? null : e.actionBy,
                                        pending: !!e.pending
                                    };
                                }),
                                currentStatus: {
                                    status: e.currentStatus.status,
                                    changeDate: new Date(parseInt(e.currentStatus.changeDate.split("-")[0], 10), parseInt(e.currentStatus.changeDate.split("-")[1], 10) - 1, parseInt(e.currentStatus.changeDate.split("-")[2], 10)),
                                    actionBy: e.currentStatus.actionBy === null || e.currentStatus.actionBy === undefined ? null : e.currentStatus.actionBy,
                                    pending: !!e.currentStatus.pending
                                },
                                payment: {
                                    card: e.payment.card === null || e.payment.card === undefined ? null : {
                                        lastDigits: e.payment.card.lastDigits,
                                        brand: e.payment.card.brand,
                                        paidAmount: e.payment.card.paidAmount || 0
                                    },
                                    total: e.payment.total || 0
                                },
                                promotion: {
                                    type: e.promotion.type === null || e.promotion.type === undefined ? null : e.promotion.type,
                                    total: e.promotion.total || 0
                                },
                                nfe: e.nfe === null || e.nfe === undefined ? null : {
                                    id: e.nfe.id === null || e.nfe.id === undefined ? null : e.nfe.id,
                                    number: e.nfe.number === null || e.nfe.number === undefined ? null : e.nfe.number || 0,
                                    emitedAt: e.nfe.emitedAt === null || e.nfe.emitedAt === undefined ? null : new Date(e.nfe.emitedAt + "Z"),
                                    canceledAt: e.nfe.canceledAt === null || e.nfe.canceledAt === undefined ? null : new Date(e.nfe.canceledAt + "Z"),
                                    status: e.nfe.status === null || e.nfe.status === undefined ? null : e.nfe.status
                                }
                            };
                        }));

                    case 4:
                    case "end":
                        return _context51.stop();
                }
            }
        }, _callee51, this);
    }));

    return function getPendingRates(_x117) {
        return _ref51.apply(this, arguments);
    };
}();

var getRating = function () {
    var _ref52 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee52(uId, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee52$(_context52) {
            while (1) {
                switch (_context52.prev = _context52.next) {
                    case 0:
                        args = {
                            uId: uId
                        };
                        _context52.next = 3;
                        return makeRequest({ name: "getRating", args: args, progress: progress });

                    case 3:
                        ret = _context52.sent;
                        return _context52.abrupt("return", ret || 0);

                    case 5:
                    case "end":
                        return _context52.stop();
                }
            }
        }, _callee52, this);
    }));

    return function getRating(_x118, _x119) {
        return _ref52.apply(this, arguments);
    };
}();

var getMyRating = function () {
    var _ref53 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee53(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee53$(_context53) {
            while (1) {
                switch (_context53.prev = _context53.next) {
                    case 0:
                        _context53.next = 2;
                        return makeRequest({ name: "getMyRating", args: {}, progress: progress });

                    case 2:
                        ret = _context53.sent;
                        return _context53.abrupt("return", ret || 0);

                    case 4:
                    case "end":
                        return _context53.stop();
                }
            }
        }, _callee53, this);
    }));

    return function getMyRating(_x120) {
        return _ref53.apply(this, arguments);
    };
}();

var shouldRequestNotificationPermission = function () {
    var _ref54 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee54(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee54$(_context54) {
            while (1) {
                switch (_context54.prev = _context54.next) {
                    case 0:
                        _context54.next = 2;
                        return makeRequest({ name: "shouldRequestNotificationPermission", args: {}, progress: progress });

                    case 2:
                        ret = _context54.sent;
                        return _context54.abrupt("return", !!ret);

                    case 4:
                    case "end":
                        return _context54.stop();
                }
            }
        }, _callee54, this);
    }));

    return function shouldRequestNotificationPermission(_x121) {
        return _ref54.apply(this, arguments);
    };
}();

var getNotificationBadges = function () {
    var _ref55 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee55(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee55$(_context55) {
            while (1) {
                switch (_context55.prev = _context55.next) {
                    case 0:
                        _context55.next = 2;
                        return makeRequest({ name: "getNotificationBadges", args: {}, progress: progress });

                    case 2:
                        ret = _context55.sent;
                        return _context55.abrupt("return", {
                            others: ret.others || 0,
                            chat: ret.chat || 0,
                            locRequest: ret.locRequest || 0,
                            card: ret.card || 0,
                            bank: ret.bank || 0
                        });

                    case 4:
                    case "end":
                        return _context55.stop();
                }
            }
        }, _callee55, this);
    }));

    return function getNotificationBadges(_x122) {
        return _ref55.apply(this, arguments);
    };
}();

var taltToUs = function () {
    var _ref56 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee56(category, message, requestId, images, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee56$(_context56) {
            while (1) {
                switch (_context56.prev = _context56.next) {
                    case 0:
                        args = {
                            category: category,
                            message: message,
                            requestId: requestId === null || requestId === undefined ? null : requestId,
                            images: images.map(function (e) {
                                return e.toString("base64");
                            })
                        };
                        _context56.next = 3;
                        return makeRequest({ name: "taltToUs", args: args, progress: progress });

                    case 3:
                        ret = _context56.sent;
                        return _context56.abrupt("return", ret);

                    case 5:
                    case "end":
                        return _context56.stop();
                }
            }
        }, _callee56, this);
    }));

    return function taltToUs(_x123, _x124, _x125, _x126, _x127) {
        return _ref56.apply(this, arguments);
    };
}();

var getAutocomplete = function () {
    var _ref57 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee57(search, location, filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee57$(_context57) {
            while (1) {
                switch (_context57.prev = _context57.next) {
                    case 0:
                        args = {
                            search: search,
                            location: {
                                lat: location.lat,
                                lon: location.lon
                            },
                            filter: {
                                distance: filter.distance,
                                sizes: filter.sizes.map(function (e) {
                                    return e;
                                }),
                                gender: filter.gender.map(function (e) {
                                    return e;
                                }),
                                categories: filter.categories.map(function (e) {
                                    return e;
                                }),
                                ocasions: filter.ocasions.map(function (e) {
                                    return e;
                                }),
                                colors: filter.colors.map(function (e) {
                                    return e;
                                }),
                                orderBy: filter.orderBy
                            }
                        };
                        _context57.next = 3;
                        return makeRequest({ name: "getAutocomplete", args: args, progress: progress });

                    case 3:
                        ret = _context57.sent;
                        return _context57.abrupt("return", ret.map(function (e) {
                            return e;
                        }));

                    case 5:
                    case "end":
                        return _context57.stop();
                }
            }
        }, _callee57, this);
    }));

    return function getAutocomplete(_x128, _x129, _x130, _x131) {
        return _ref57.apply(this, arguments);
    };
}();

var getSearch = function () {
    var _ref58 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee58(search, location, filter, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee58$(_context58) {
            while (1) {
                switch (_context58.prev = _context58.next) {
                    case 0:
                        args = {
                            search: search,
                            location: {
                                lat: location.lat,
                                lon: location.lon
                            },
                            filter: {
                                distance: filter.distance,
                                sizes: filter.sizes.map(function (e) {
                                    return e;
                                }),
                                gender: filter.gender.map(function (e) {
                                    return e;
                                }),
                                categories: filter.categories.map(function (e) {
                                    return e;
                                }),
                                ocasions: filter.ocasions.map(function (e) {
                                    return e;
                                }),
                                colors: filter.colors.map(function (e) {
                                    return e;
                                }),
                                orderBy: filter.orderBy
                            }
                        };
                        _context58.next = 3;
                        return makeRequest({ name: "getSearch", args: args, progress: progress });

                    case 3:
                        ret = _context58.sent;
                        return _context58.abrupt("return", {
                            tags: ret.tags.map(function (e) {
                                return e;
                            }),
                            usersResult: {
                                user: ret.usersResult.user.map(function (e) {
                                    return {
                                        id: e.id,
                                        avatar: e.avatar === null || e.avatar === undefined ? null : {
                                            width: e.avatar.width || 0,
                                            height: e.avatar.height || 0,
                                            url: e.avatar.url
                                        },
                                        name: e.name,
                                        rate: e.rate,
                                        height: e.height === null || e.height === undefined ? null : e.height || 0,
                                        deleted: !!e.deleted,
                                        ownerName: e.ownerName === null || e.ownerName === undefined ? null : e.ownerName
                                    };
                                }),
                                moreResults: !!ret.usersResult.moreResults
                            },
                            itemsResult: {
                                items: ret.itemsResult.items.map(function (e) {
                                    return {
                                        id: e.id,
                                        department: e.department,
                                        ownerId: e.ownerId,
                                        likes: e.likes || 0,
                                        liked: !!e.liked,
                                        address: {
                                            neighborhood: e.address.neighborhood,
                                            city: e.address.city,
                                            uf: e.address.uf,
                                            country: e.address.country,
                                            location: {
                                                lat: e.address.location.lat,
                                                lon: e.address.location.lon
                                            }
                                        },
                                        ownerInfo: {
                                            id: e.ownerInfo.id,
                                            avatar: e.ownerInfo.avatar === null || e.ownerInfo.avatar === undefined ? null : {
                                                width: e.ownerInfo.avatar.width || 0,
                                                height: e.ownerInfo.avatar.height || 0,
                                                url: e.ownerInfo.avatar.url
                                            },
                                            name: e.ownerInfo.name,
                                            rate: e.ownerInfo.rate,
                                            height: e.ownerInfo.height === null || e.ownerInfo.height === undefined ? null : e.ownerInfo.height || 0,
                                            deleted: !!e.ownerInfo.deleted,
                                            ownerName: e.ownerInfo.ownerName === null || e.ownerInfo.ownerName === undefined ? null : e.ownerInfo.ownerName
                                        },
                                        calendar: e.calendar.map(function (e) {
                                            return {
                                                start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                                end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                            };
                                        }),
                                        adjustment: !!e.adjustment,
                                        category: e.category === null || e.category === undefined ? null : e.category,
                                        color: e.color === null || e.color === undefined ? null : e.color,
                                        details: e.details,
                                        gender: e.gender,
                                        thumbImage: {
                                            width: e.thumbImage.width || 0,
                                            height: e.thumbImage.height || 0,
                                            url: e.thumbImage.url
                                        },
                                        images: e.images.map(function (e) {
                                            return {
                                                width: e.width || 0,
                                                height: e.height || 0,
                                                url: e.url
                                            };
                                        }),
                                        brand: e.brand === null || e.brand === undefined ? null : e.brand,
                                        ocasions: e.ocasions.map(function (e) {
                                            return e === null || e === undefined ? null : e;
                                        }),
                                        rentPrice: e.rentPrice || 0,
                                        originalPrice: e.originalPrice || 0,
                                        size: e.size === null || e.size === undefined ? null : e.size
                                    };
                                }),
                                moreResults: !!ret.itemsResult.moreResults
                            }
                        });

                    case 5:
                    case "end":
                        return _context58.stop();
                }
            }
        }, _callee58, this);
    }));

    return function getSearch(_x132, _x133, _x134, _x135) {
        return _ref58.apply(this, arguments);
    };
}();

var getSearchUsers = function () {
    var _ref59 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee59(search, distance, location, page, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee59$(_context59) {
            while (1) {
                switch (_context59.prev = _context59.next) {
                    case 0:
                        args = {
                            search: search,
                            distance: distance,
                            location: {
                                lat: location.lat,
                                lon: location.lon
                            },
                            page: page === null || page === undefined ? null : page || 0
                        };
                        _context59.next = 3;
                        return makeRequest({ name: "getSearchUsers", args: args, progress: progress });

                    case 3:
                        ret = _context59.sent;
                        return _context59.abrupt("return", {
                            user: ret.user.map(function (e) {
                                return {
                                    id: e.id,
                                    avatar: e.avatar === null || e.avatar === undefined ? null : {
                                        width: e.avatar.width || 0,
                                        height: e.avatar.height || 0,
                                        url: e.avatar.url
                                    },
                                    name: e.name,
                                    rate: e.rate,
                                    height: e.height === null || e.height === undefined ? null : e.height || 0,
                                    deleted: !!e.deleted,
                                    ownerName: e.ownerName === null || e.ownerName === undefined ? null : e.ownerName
                                };
                            }),
                            moreResults: !!ret.moreResults
                        });

                    case 5:
                    case "end":
                        return _context59.stop();
                }
            }
        }, _callee59, this);
    }));

    return function getSearchUsers(_x136, _x137, _x138, _x139, _x140) {
        return _ref59.apply(this, arguments);
    };
}();

var getSearchItems = function () {
    var _ref60 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee60(search, location, filter, page, progress) {
        var args, ret;
        return _regenerator2.default.wrap(function _callee60$(_context60) {
            while (1) {
                switch (_context60.prev = _context60.next) {
                    case 0:
                        args = {
                            search: search === null || search === undefined ? null : search,
                            location: {
                                lat: location.lat,
                                lon: location.lon
                            },
                            filter: {
                                distance: filter.distance,
                                sizes: filter.sizes.map(function (e) {
                                    return e;
                                }),
                                gender: filter.gender.map(function (e) {
                                    return e;
                                }),
                                categories: filter.categories.map(function (e) {
                                    return e;
                                }),
                                ocasions: filter.ocasions.map(function (e) {
                                    return e;
                                }),
                                colors: filter.colors.map(function (e) {
                                    return e;
                                }),
                                orderBy: filter.orderBy
                            },
                            page: page === null || page === undefined ? null : page || 0
                        };
                        _context60.next = 3;
                        return makeRequest({ name: "getSearchItems", args: args, progress: progress });

                    case 3:
                        ret = _context60.sent;
                        return _context60.abrupt("return", {
                            items: ret.items.map(function (e) {
                                return {
                                    id: e.id,
                                    department: e.department,
                                    ownerId: e.ownerId,
                                    likes: e.likes || 0,
                                    liked: !!e.liked,
                                    address: {
                                        neighborhood: e.address.neighborhood,
                                        city: e.address.city,
                                        uf: e.address.uf,
                                        country: e.address.country,
                                        location: {
                                            lat: e.address.location.lat,
                                            lon: e.address.location.lon
                                        }
                                    },
                                    ownerInfo: {
                                        id: e.ownerInfo.id,
                                        avatar: e.ownerInfo.avatar === null || e.ownerInfo.avatar === undefined ? null : {
                                            width: e.ownerInfo.avatar.width || 0,
                                            height: e.ownerInfo.avatar.height || 0,
                                            url: e.ownerInfo.avatar.url
                                        },
                                        name: e.ownerInfo.name,
                                        rate: e.ownerInfo.rate,
                                        height: e.ownerInfo.height === null || e.ownerInfo.height === undefined ? null : e.ownerInfo.height || 0,
                                        deleted: !!e.ownerInfo.deleted,
                                        ownerName: e.ownerInfo.ownerName === null || e.ownerInfo.ownerName === undefined ? null : e.ownerInfo.ownerName
                                    },
                                    calendar: e.calendar.map(function (e) {
                                        return {
                                            start: new Date(parseInt(e.start.split("-")[0], 10), parseInt(e.start.split("-")[1], 10) - 1, parseInt(e.start.split("-")[2], 10)),
                                            end: new Date(parseInt(e.end.split("-")[0], 10), parseInt(e.end.split("-")[1], 10) - 1, parseInt(e.end.split("-")[2], 10))
                                        };
                                    }),
                                    adjustment: !!e.adjustment,
                                    category: e.category === null || e.category === undefined ? null : e.category,
                                    color: e.color === null || e.color === undefined ? null : e.color,
                                    details: e.details,
                                    gender: e.gender,
                                    thumbImage: {
                                        width: e.thumbImage.width || 0,
                                        height: e.thumbImage.height || 0,
                                        url: e.thumbImage.url
                                    },
                                    images: e.images.map(function (e) {
                                        return {
                                            width: e.width || 0,
                                            height: e.height || 0,
                                            url: e.url
                                        };
                                    }),
                                    brand: e.brand === null || e.brand === undefined ? null : e.brand,
                                    ocasions: e.ocasions.map(function (e) {
                                        return e === null || e === undefined ? null : e;
                                    }),
                                    rentPrice: e.rentPrice || 0,
                                    originalPrice: e.originalPrice || 0,
                                    size: e.size === null || e.size === undefined ? null : e.size
                                };
                            }),
                            moreResults: !!ret.moreResults
                        });

                    case 5:
                    case "end":
                        return _context60.stop();
                }
            }
        }, _callee60, this);
    }));

    return function getSearchItems(_x141, _x142, _x143, _x144, _x145) {
        return _ref60.apply(this, arguments);
    };
}();

var ping = function () {
    var _ref61 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee61(progress) {
        var ret;
        return _regenerator2.default.wrap(function _callee61$(_context61) {
            while (1) {
                switch (_context61.prev = _context61.next) {
                    case 0:
                        _context61.next = 2;
                        return makeRequest({ name: "ping", args: {}, progress: progress });

                    case 2:
                        ret = _context61.sent;
                        return _context61.abrupt("return", ret);

                    case 4:
                    case "end":
                        return _context61.stop();
                }
            }
        }, _callee61, this);
    }));

    return function ping(_x146) {
        return _ref61.apply(this, arguments);
    };
}();

var setPushToken = function () {
    var _ref62 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee62(token, progress) {
        var args;
        return _regenerator2.default.wrap(function _callee62$(_context62) {
            while (1) {
                switch (_context62.prev = _context62.next) {
                    case 0:
                        args = {
                            token: token
                        };
                        _context62.next = 3;
                        return makeRequest({ name: "setPushToken", args: args, progress: progress });

                    case 3:
                        return _context62.abrupt("return", undefined);

                    case 4:
                    case "end":
                        return _context62.stop();
                }
            }
        }, _callee62, this);
    }));

    return function setPushToken(_x147, _x148) {
        return _ref62.apply(this, arguments);
    };
}();

var device = function () {
    var _ref63 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee63() {
        var parser, agent, me, device, deviceId;
        return _regenerator2.default.wrap(function _callee63$(_context63) {
            while (1) {
                switch (_context63.prev = _context63.next) {
                    case 0:
                        parser = new ua_parser_js_1.UAParser();

                        parser.setUA(navigator.userAgent);
                        agent = parser.getResult();
                        me = document.currentScript;
                        device = {
                            type: "web",
                            platform: {
                                browser: agent.browser.name,
                                browserVersion: agent.browser.version,
                                os: agent.os.name,
                                osVersion: agent.os.version
                            },
                            screen: {
                                width: screen.width,
                                height: screen.height
                            },
                            version: me ? me.src : "",
                            language: navigator.language
                        };
                        deviceId = getDeviceId();

                        if (deviceId) device.id = deviceId;
                        return _context63.abrupt("return", device);

                    case 8:
                    case "end":
                        return _context63.stop();
                }
            }
        }, _callee63, this);
    }));

    return function device() {
        return _ref63.apply(this, arguments);
    };
}();

var makeRequest = function () {
    var _ref64 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee64(_ref65) {
        var name = _ref65.name,
            args = _ref65.args,
            progress = _ref65.progress;
        var deviceData;
        return _regenerator2.default.wrap(function _callee64$(_context64) {
            while (1) {
                switch (_context64.prev = _context64.next) {
                    case 0:
                        _context64.next = 2;
                        return device();

                    case 2:
                        deviceData = _context64.sent;
                        return _context64.abrupt("return", new _promise2.default(function (resolve, reject) {
                            var req = new XMLHttpRequest();
                            req.open("POST", "" + (baseUrl.startsWith("http") || baseUrl.startsWith("localhost") ? "" : "https://") + baseUrl + "/" + name);
                            var body = {
                                id: randomBytesHex(8),
                                device: deviceData,
                                name: name,
                                args: args
                            };
                            function roughSizeOfObject(object) {
                                var objectList = [];
                                var stack = [object];
                                var bytes = 0;
                                while (stack.length) {
                                    var value = stack.pop();
                                    if (typeof value === "boolean") {
                                        bytes += 4;
                                    } else if (typeof value === "string") {
                                        bytes += value.length * 2;
                                    } else if (typeof value === "number") {
                                        bytes += 8;
                                    } else if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) === "object" && objectList.indexOf(value) === -1) {
                                        objectList.push(value);
                                        for (var i in value) {
                                            stack.push(value[i]);
                                        }
                                    }
                                }
                                return bytes;
                            }
                            req.upload.onprogress = function (event) {
                                if (event.lengthComputable && progress) {
                                    progress(Math.ceil(event.loaded / event.total * 100));
                                }
                            };
                            req.onreadystatechange = function () {
                                if (req.readyState !== 4) return;
                                try {
                                    var response = JSON.parse(req.responseText);
                                    try {
                                        setDeviceId(response.deviceId);
                                        if (response.ok) {
                                            resolve(response.result);
                                            listenersDict["success"].forEach(function (hook) {
                                                return hook(response.result, name, args);
                                            });
                                        } else {
                                            reject(response.error);
                                            listenersDict["fail"].forEach(function (hook) {
                                                return hook(response.error, name, args);
                                            });
                                        }
                                    } catch (e) {
                                        console.error(e);
                                        reject({ type: "Fatal", message: e.toString() });
                                        listenersDict["fatal"].forEach(function (hook) {
                                            return hook(e, name, args);
                                        });
                                    }
                                } catch (e) {
                                    console.error(e);
                                    reject({ type: "BadFormattedResponse", message: "Response couldn't be parsed as JSON (" + req.responseText + "):\n" + e.toString() });
                                    listenersDict["fatal"].forEach(function (hook) {
                                        return hook(e, name, args);
                                    });
                                }
                            };
                            req.send((0, _stringify2.default)(body));
                        }));

                    case 4:
                    case "end":
                        return _context64.stop();
                }
            }
        }, _callee64, this);
    }));

    return function makeRequest(_x149) {
        return _ref64.apply(this, arguments);
    };
}();
//# sourceMappingURL=api.js.map


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var ua_parser_js_1 = __webpack_require__(98);
var baseUrl = "localhost:8000";
var strings = null;
function setUrl(url) {
    baseUrl = url;
}
exports.setUrl = setUrl;
function setStrings(newStrings) {
    strings = newStrings;
}
exports.setStrings = setStrings;
var Department;
(function (Department) {
    Department["clothes"] = "clothes";
    Department["accessory"] = "accessory";
})(Department = exports.Department || (exports.Department = {}));
function translateDepartment(enumDepartment) {
    switch (enumDepartment) {
        case Department.clothes:
            {
                return strings ? strings["enum"]["Department"]["clothes"] || Department.clothes : Department.clothes;
            }
        case Department.accessory:
            {
                return strings ? strings["enum"]["Department"]["accessory"] || Department.accessory : Department.accessory;
            }
    }
    return "";
}
exports.translateDepartment = translateDepartment;
function allValuesDepartment() {
    return [Department.clothes, Department.accessory];
}
exports.allValuesDepartment = allValuesDepartment;
function allTranslatedValuesDepartment() {
    return [translateDepartment(Department.clothes), translateDepartment(Department.accessory)];
}
exports.allTranslatedValuesDepartment = allTranslatedValuesDepartment;
function allDisplayableValuesDepartment() {
    return allTranslatedValuesDepartment().sort();
}
exports.allDisplayableValuesDepartment = allDisplayableValuesDepartment;
function valueFromTranslationDepartment(translation) {
    var index = allTranslatedValuesDepartment().indexOf(translation);
    return allValuesDepartment()[index] || Department.clothes;
}
exports.valueFromTranslationDepartment = valueFromTranslationDepartment;
var Category;
(function (Category) {
    Category["rompers"] = "rompers";
    Category["conjunct"] = "conjunct";
    Category["body"] = "body";
    Category["top"] = "top";
    Category["blouse"] = "blouse";
    Category["pants"] = "pants";
    Category["shorts"] = "shorts";
    Category["longShorts"] = "longShorts";
    Category["skirt"] = "skirt";
    Category["dress"] = "dress";
    Category["overlap"] = "overlap";
    Category["overall"] = "overall";
    Category["suit"] = "suit";
    Category["purse"] = "purse";
    Category["shoes"] = "shoes";
    Category["winter"] = "winter";
    Category["accessory"] = "accessory";
    Category["other"] = "other";
})(Category = exports.Category || (exports.Category = {}));
function translateCategory(enumCategory) {
    switch (enumCategory) {
        case Category.rompers:
            {
                return strings ? strings["enum"]["Category"]["rompers"] || Category.rompers : Category.rompers;
            }
        case Category.conjunct:
            {
                return strings ? strings["enum"]["Category"]["conjunct"] || Category.conjunct : Category.conjunct;
            }
        case Category.body:
            {
                return strings ? strings["enum"]["Category"]["body"] || Category.body : Category.body;
            }
        case Category.top:
            {
                return strings ? strings["enum"]["Category"]["top"] || Category.top : Category.top;
            }
        case Category.blouse:
            {
                return strings ? strings["enum"]["Category"]["blouse"] || Category.blouse : Category.blouse;
            }
        case Category.pants:
            {
                return strings ? strings["enum"]["Category"]["pants"] || Category.pants : Category.pants;
            }
        case Category.shorts:
            {
                return strings ? strings["enum"]["Category"]["shorts"] || Category.shorts : Category.shorts;
            }
        case Category.longShorts:
            {
                return strings ? strings["enum"]["Category"]["longShorts"] || Category.longShorts : Category.longShorts;
            }
        case Category.skirt:
            {
                return strings ? strings["enum"]["Category"]["skirt"] || Category.skirt : Category.skirt;
            }
        case Category.dress:
            {
                return strings ? strings["enum"]["Category"]["dress"] || Category.dress : Category.dress;
            }
        case Category.overlap:
            {
                return strings ? strings["enum"]["Category"]["overlap"] || Category.overlap : Category.overlap;
            }
        case Category.overall:
            {
                return strings ? strings["enum"]["Category"]["overall"] || Category.overall : Category.overall;
            }
        case Category.suit:
            {
                return strings ? strings["enum"]["Category"]["suit"] || Category.suit : Category.suit;
            }
        case Category.purse:
            {
                return strings ? strings["enum"]["Category"]["purse"] || Category.purse : Category.purse;
            }
        case Category.shoes:
            {
                return strings ? strings["enum"]["Category"]["shoes"] || Category.shoes : Category.shoes;
            }
        case Category.winter:
            {
                return strings ? strings["enum"]["Category"]["winter"] || Category.winter : Category.winter;
            }
        case Category.accessory:
            {
                return strings ? strings["enum"]["Category"]["accessory"] || Category.accessory : Category.accessory;
            }
        case Category.other:
            {
                return strings ? strings["enum"]["Category"]["other"] || Category.other : Category.other;
            }
    }
    return "";
}
exports.translateCategory = translateCategory;
function allValuesCategory() {
    return [Category.rompers, Category.conjunct, Category.body, Category.top, Category.blouse, Category.pants, Category.shorts, Category.longShorts, Category.skirt, Category.dress, Category.overlap, Category.overall, Category.suit, Category.purse, Category.shoes, Category.winter, Category.accessory, Category.other];
}
exports.allValuesCategory = allValuesCategory;
function allTranslatedValuesCategory() {
    return [translateCategory(Category.rompers), translateCategory(Category.conjunct), translateCategory(Category.body), translateCategory(Category.top), translateCategory(Category.blouse), translateCategory(Category.pants), translateCategory(Category.shorts), translateCategory(Category.longShorts), translateCategory(Category.skirt), translateCategory(Category.dress), translateCategory(Category.overlap), translateCategory(Category.overall), translateCategory(Category.suit), translateCategory(Category.purse), translateCategory(Category.shoes), translateCategory(Category.winter), translateCategory(Category.accessory), translateCategory(Category.other)];
}
exports.allTranslatedValuesCategory = allTranslatedValuesCategory;
function allDisplayableValuesCategory() {
    return allTranslatedValuesCategory().sort();
}
exports.allDisplayableValuesCategory = allDisplayableValuesCategory;
function valueFromTranslationCategory(translation) {
    var index = allTranslatedValuesCategory().indexOf(translation);
    return allValuesCategory()[index] || Category.rompers;
}
exports.valueFromTranslationCategory = valueFromTranslationCategory;
var OldCategory;
(function (OldCategory) {
    OldCategory["blouse"] = "blouse";
    OldCategory["pants"] = "pants";
    OldCategory["shorts"] = "shorts";
    OldCategory["longShorts"] = "longShorts";
    OldCategory["skirt"] = "skirt";
    OldCategory["dress"] = "dress";
    OldCategory["overlap"] = "overlap";
    OldCategory["overall"] = "overall";
    OldCategory["blazer"] = "blazer";
    OldCategory["suit"] = "suit";
    OldCategory["purse"] = "purse";
    OldCategory["wallet"] = "wallet";
    OldCategory["shoes"] = "shoes";
    OldCategory["belt"] = "belt";
    OldCategory["bijou"] = "bijou";
    OldCategory["jewelery"] = "jewelery";
    OldCategory["scarf"] = "scarf";
    OldCategory["tiara"] = "tiara";
    OldCategory["hat"] = "hat";
    OldCategory["glasses"] = "glasses";
    OldCategory["watch"] = "watch";
    OldCategory["winter"] = "winter";
    OldCategory["accessory"] = "accessory";
    OldCategory["pregnant"] = "pregnant";
    OldCategory["other"] = "other";
})(OldCategory = exports.OldCategory || (exports.OldCategory = {}));
function translateOldCategory(enumOldCategory) {
    switch (enumOldCategory) {
        case OldCategory.blouse:
            {
                return strings ? strings["enum"]["OldCategory"]["blouse"] || OldCategory.blouse : OldCategory.blouse;
            }
        case OldCategory.pants:
            {
                return strings ? strings["enum"]["OldCategory"]["pants"] || OldCategory.pants : OldCategory.pants;
            }
        case OldCategory.shorts:
            {
                return strings ? strings["enum"]["OldCategory"]["shorts"] || OldCategory.shorts : OldCategory.shorts;
            }
        case OldCategory.longShorts:
            {
                return strings ? strings["enum"]["OldCategory"]["longShorts"] || OldCategory.longShorts : OldCategory.longShorts;
            }
        case OldCategory.skirt:
            {
                return strings ? strings["enum"]["OldCategory"]["skirt"] || OldCategory.skirt : OldCategory.skirt;
            }
        case OldCategory.dress:
            {
                return strings ? strings["enum"]["OldCategory"]["dress"] || OldCategory.dress : OldCategory.dress;
            }
        case OldCategory.overlap:
            {
                return strings ? strings["enum"]["OldCategory"]["overlap"] || OldCategory.overlap : OldCategory.overlap;
            }
        case OldCategory.overall:
            {
                return strings ? strings["enum"]["OldCategory"]["overall"] || OldCategory.overall : OldCategory.overall;
            }
        case OldCategory.blazer:
            {
                return strings ? strings["enum"]["OldCategory"]["blazer"] || OldCategory.blazer : OldCategory.blazer;
            }
        case OldCategory.suit:
            {
                return strings ? strings["enum"]["OldCategory"]["suit"] || OldCategory.suit : OldCategory.suit;
            }
        case OldCategory.purse:
            {
                return strings ? strings["enum"]["OldCategory"]["purse"] || OldCategory.purse : OldCategory.purse;
            }
        case OldCategory.wallet:
            {
                return strings ? strings["enum"]["OldCategory"]["wallet"] || OldCategory.wallet : OldCategory.wallet;
            }
        case OldCategory.shoes:
            {
                return strings ? strings["enum"]["OldCategory"]["shoes"] || OldCategory.shoes : OldCategory.shoes;
            }
        case OldCategory.belt:
            {
                return strings ? strings["enum"]["OldCategory"]["belt"] || OldCategory.belt : OldCategory.belt;
            }
        case OldCategory.bijou:
            {
                return strings ? strings["enum"]["OldCategory"]["bijou"] || OldCategory.bijou : OldCategory.bijou;
            }
        case OldCategory.jewelery:
            {
                return strings ? strings["enum"]["OldCategory"]["jewelery"] || OldCategory.jewelery : OldCategory.jewelery;
            }
        case OldCategory.scarf:
            {
                return strings ? strings["enum"]["OldCategory"]["scarf"] || OldCategory.scarf : OldCategory.scarf;
            }
        case OldCategory.tiara:
            {
                return strings ? strings["enum"]["OldCategory"]["tiara"] || OldCategory.tiara : OldCategory.tiara;
            }
        case OldCategory.hat:
            {
                return strings ? strings["enum"]["OldCategory"]["hat"] || OldCategory.hat : OldCategory.hat;
            }
        case OldCategory.glasses:
            {
                return strings ? strings["enum"]["OldCategory"]["glasses"] || OldCategory.glasses : OldCategory.glasses;
            }
        case OldCategory.watch:
            {
                return strings ? strings["enum"]["OldCategory"]["watch"] || OldCategory.watch : OldCategory.watch;
            }
        case OldCategory.winter:
            {
                return strings ? strings["enum"]["OldCategory"]["winter"] || OldCategory.winter : OldCategory.winter;
            }
        case OldCategory.accessory:
            {
                return strings ? strings["enum"]["OldCategory"]["accessory"] || OldCategory.accessory : OldCategory.accessory;
            }
        case OldCategory.pregnant:
            {
                return strings ? strings["enum"]["OldCategory"]["pregnant"] || OldCategory.pregnant : OldCategory.pregnant;
            }
        case OldCategory.other:
            {
                return strings ? strings["enum"]["OldCategory"]["other"] || OldCategory.other : OldCategory.other;
            }
    }
    return "";
}
exports.translateOldCategory = translateOldCategory;
function allValuesOldCategory() {
    return [OldCategory.blouse, OldCategory.pants, OldCategory.shorts, OldCategory.longShorts, OldCategory.skirt, OldCategory.dress, OldCategory.overlap, OldCategory.overall, OldCategory.blazer, OldCategory.suit, OldCategory.purse, OldCategory.wallet, OldCategory.shoes, OldCategory.belt, OldCategory.bijou, OldCategory.jewelery, OldCategory.scarf, OldCategory.tiara, OldCategory.hat, OldCategory.glasses, OldCategory.watch, OldCategory.winter, OldCategory.accessory, OldCategory.pregnant, OldCategory.other];
}
exports.allValuesOldCategory = allValuesOldCategory;
function allTranslatedValuesOldCategory() {
    return [translateOldCategory(OldCategory.blouse), translateOldCategory(OldCategory.pants), translateOldCategory(OldCategory.shorts), translateOldCategory(OldCategory.longShorts), translateOldCategory(OldCategory.skirt), translateOldCategory(OldCategory.dress), translateOldCategory(OldCategory.overlap), translateOldCategory(OldCategory.overall), translateOldCategory(OldCategory.blazer), translateOldCategory(OldCategory.suit), translateOldCategory(OldCategory.purse), translateOldCategory(OldCategory.wallet), translateOldCategory(OldCategory.shoes), translateOldCategory(OldCategory.belt), translateOldCategory(OldCategory.bijou), translateOldCategory(OldCategory.jewelery), translateOldCategory(OldCategory.scarf), translateOldCategory(OldCategory.tiara), translateOldCategory(OldCategory.hat), translateOldCategory(OldCategory.glasses), translateOldCategory(OldCategory.watch), translateOldCategory(OldCategory.winter), translateOldCategory(OldCategory.accessory), translateOldCategory(OldCategory.pregnant), translateOldCategory(OldCategory.other)];
}
exports.allTranslatedValuesOldCategory = allTranslatedValuesOldCategory;
function allDisplayableValuesOldCategory() {
    return allTranslatedValuesOldCategory().sort();
}
exports.allDisplayableValuesOldCategory = allDisplayableValuesOldCategory;
function valueFromTranslationOldCategory(translation) {
    var index = allTranslatedValuesOldCategory().indexOf(translation);
    return allValuesOldCategory()[index] || OldCategory.blouse;
}
exports.valueFromTranslationOldCategory = valueFromTranslationOldCategory;
var Ocasion;
(function (Ocasion) {
    Ocasion["formalParty"] = "formalParty";
    Ocasion["party"] = "party";
    Ocasion["casual"] = "casual";
    Ocasion["winter"] = "winter";
    Ocasion["costume"] = "costume";
    Ocasion["beach"] = "beach";
    Ocasion["work"] = "work";
    Ocasion["pregnant"] = "pregnant";
})(Ocasion = exports.Ocasion || (exports.Ocasion = {}));
function translateOcasion(enumOcasion) {
    switch (enumOcasion) {
        case Ocasion.formalParty:
            {
                return strings ? strings["enum"]["Ocasion"]["formalParty"] || Ocasion.formalParty : Ocasion.formalParty;
            }
        case Ocasion.party:
            {
                return strings ? strings["enum"]["Ocasion"]["party"] || Ocasion.party : Ocasion.party;
            }
        case Ocasion.casual:
            {
                return strings ? strings["enum"]["Ocasion"]["casual"] || Ocasion.casual : Ocasion.casual;
            }
        case Ocasion.winter:
            {
                return strings ? strings["enum"]["Ocasion"]["winter"] || Ocasion.winter : Ocasion.winter;
            }
        case Ocasion.costume:
            {
                return strings ? strings["enum"]["Ocasion"]["costume"] || Ocasion.costume : Ocasion.costume;
            }
        case Ocasion.beach:
            {
                return strings ? strings["enum"]["Ocasion"]["beach"] || Ocasion.beach : Ocasion.beach;
            }
        case Ocasion.work:
            {
                return strings ? strings["enum"]["Ocasion"]["work"] || Ocasion.work : Ocasion.work;
            }
        case Ocasion.pregnant:
            {
                return strings ? strings["enum"]["Ocasion"]["pregnant"] || Ocasion.pregnant : Ocasion.pregnant;
            }
    }
    return "";
}
exports.translateOcasion = translateOcasion;
function allValuesOcasion() {
    return [Ocasion.formalParty, Ocasion.party, Ocasion.casual, Ocasion.winter, Ocasion.costume, Ocasion.beach, Ocasion.work, Ocasion.pregnant];
}
exports.allValuesOcasion = allValuesOcasion;
function allTranslatedValuesOcasion() {
    return [translateOcasion(Ocasion.formalParty), translateOcasion(Ocasion.party), translateOcasion(Ocasion.casual), translateOcasion(Ocasion.winter), translateOcasion(Ocasion.costume), translateOcasion(Ocasion.beach), translateOcasion(Ocasion.work), translateOcasion(Ocasion.pregnant)];
}
exports.allTranslatedValuesOcasion = allTranslatedValuesOcasion;
function allDisplayableValuesOcasion() {
    return allTranslatedValuesOcasion().sort();
}
exports.allDisplayableValuesOcasion = allDisplayableValuesOcasion;
function valueFromTranslationOcasion(translation) {
    var index = allTranslatedValuesOcasion().indexOf(translation);
    return allValuesOcasion()[index] || Ocasion.formalParty;
}
exports.valueFromTranslationOcasion = valueFromTranslationOcasion;
var Color;
(function (Color) {
    Color["striped"] = "striped";
    Color["grid"] = "grid";
    Color["yellow"] = "yellow";
    Color["blue"] = "blue";
    Color["beige"] = "beige";
    Color["white"] = "white";
    Color["gray"] = "gray";
    Color["gold"] = "gold";
    Color["jeans"] = "jeans";
    Color["orange"] = "orange";
    Color["brown"] = "brown";
    Color["nude"] = "nude";
    Color["offWhite"] = "offWhite";
    Color["silver"] = "silver";
    Color["black"] = "black";
    Color["pink"] = "pink";
    Color["purple"] = "purple";
    Color["green"] = "green";
    Color["red"] = "red";
    Color["wine"] = "wine";
    Color["stamped"] = "stamped";
})(Color = exports.Color || (exports.Color = {}));
function translateColor(enumColor) {
    switch (enumColor) {
        case Color.striped:
            {
                return strings ? strings["enum"]["Color"]["striped"] || Color.striped : Color.striped;
            }
        case Color.grid:
            {
                return strings ? strings["enum"]["Color"]["grid"] || Color.grid : Color.grid;
            }
        case Color.yellow:
            {
                return strings ? strings["enum"]["Color"]["yellow"] || Color.yellow : Color.yellow;
            }
        case Color.blue:
            {
                return strings ? strings["enum"]["Color"]["blue"] || Color.blue : Color.blue;
            }
        case Color.beige:
            {
                return strings ? strings["enum"]["Color"]["beige"] || Color.beige : Color.beige;
            }
        case Color.white:
            {
                return strings ? strings["enum"]["Color"]["white"] || Color.white : Color.white;
            }
        case Color.gray:
            {
                return strings ? strings["enum"]["Color"]["gray"] || Color.gray : Color.gray;
            }
        case Color.gold:
            {
                return strings ? strings["enum"]["Color"]["gold"] || Color.gold : Color.gold;
            }
        case Color.jeans:
            {
                return strings ? strings["enum"]["Color"]["jeans"] || Color.jeans : Color.jeans;
            }
        case Color.orange:
            {
                return strings ? strings["enum"]["Color"]["orange"] || Color.orange : Color.orange;
            }
        case Color.brown:
            {
                return strings ? strings["enum"]["Color"]["brown"] || Color.brown : Color.brown;
            }
        case Color.nude:
            {
                return strings ? strings["enum"]["Color"]["nude"] || Color.nude : Color.nude;
            }
        case Color.offWhite:
            {
                return strings ? strings["enum"]["Color"]["offWhite"] || Color.offWhite : Color.offWhite;
            }
        case Color.silver:
            {
                return strings ? strings["enum"]["Color"]["silver"] || Color.silver : Color.silver;
            }
        case Color.black:
            {
                return strings ? strings["enum"]["Color"]["black"] || Color.black : Color.black;
            }
        case Color.pink:
            {
                return strings ? strings["enum"]["Color"]["pink"] || Color.pink : Color.pink;
            }
        case Color.purple:
            {
                return strings ? strings["enum"]["Color"]["purple"] || Color.purple : Color.purple;
            }
        case Color.green:
            {
                return strings ? strings["enum"]["Color"]["green"] || Color.green : Color.green;
            }
        case Color.red:
            {
                return strings ? strings["enum"]["Color"]["red"] || Color.red : Color.red;
            }
        case Color.wine:
            {
                return strings ? strings["enum"]["Color"]["wine"] || Color.wine : Color.wine;
            }
        case Color.stamped:
            {
                return strings ? strings["enum"]["Color"]["stamped"] || Color.stamped : Color.stamped;
            }
    }
    return "";
}
exports.translateColor = translateColor;
function allValuesColor() {
    return [Color.striped, Color.grid, Color.yellow, Color.blue, Color.beige, Color.white, Color.gray, Color.gold, Color.jeans, Color.orange, Color.brown, Color.nude, Color.offWhite, Color.silver, Color.black, Color.pink, Color.purple, Color.green, Color.red, Color.wine, Color.stamped];
}
exports.allValuesColor = allValuesColor;
function allTranslatedValuesColor() {
    return [translateColor(Color.striped), translateColor(Color.grid), translateColor(Color.yellow), translateColor(Color.blue), translateColor(Color.beige), translateColor(Color.white), translateColor(Color.gray), translateColor(Color.gold), translateColor(Color.jeans), translateColor(Color.orange), translateColor(Color.brown), translateColor(Color.nude), translateColor(Color.offWhite), translateColor(Color.silver), translateColor(Color.black), translateColor(Color.pink), translateColor(Color.purple), translateColor(Color.green), translateColor(Color.red), translateColor(Color.wine), translateColor(Color.stamped)];
}
exports.allTranslatedValuesColor = allTranslatedValuesColor;
function allDisplayableValuesColor() {
    return allTranslatedValuesColor().sort();
}
exports.allDisplayableValuesColor = allDisplayableValuesColor;
function valueFromTranslationColor(translation) {
    var index = allTranslatedValuesColor().indexOf(translation);
    return allValuesColor()[index] || Color.striped;
}
exports.valueFromTranslationColor = valueFromTranslationColor;
var Size;
(function (Size) {
    Size["sSingle"] = "sSingle";
    Size["sXS"] = "sXS";
    Size["sS"] = "sS";
    Size["sM"] = "sM";
    Size["sL"] = "sL";
    Size["sXL"] = "sXL";
    Size["sXXL"] = "sXXL";
    Size["s33"] = "s33";
    Size["s34"] = "s34";
    Size["s35"] = "s35";
    Size["s36"] = "s36";
    Size["s37"] = "s37";
    Size["s38"] = "s38";
    Size["s39"] = "s39";
    Size["s40"] = "s40";
    Size["s41"] = "s41";
    Size["s42"] = "s42";
    Size["s43"] = "s43";
    Size["s44"] = "s44";
    Size["s45"] = "s45";
    Size["s46"] = "s46";
    Size["s48"] = "s48";
    Size["s50"] = "s50";
    Size["s50Plus"] = "s50Plus";
})(Size = exports.Size || (exports.Size = {}));
function translateSize(enumSize) {
    switch (enumSize) {
        case Size.sSingle:
            {
                return strings ? strings["enum"]["Size"]["sSingle"] || Size.sSingle : Size.sSingle;
            }
        case Size.sXS:
            {
                return strings ? strings["enum"]["Size"]["sXS"] || Size.sXS : Size.sXS;
            }
        case Size.sS:
            {
                return strings ? strings["enum"]["Size"]["sS"] || Size.sS : Size.sS;
            }
        case Size.sM:
            {
                return strings ? strings["enum"]["Size"]["sM"] || Size.sM : Size.sM;
            }
        case Size.sL:
            {
                return strings ? strings["enum"]["Size"]["sL"] || Size.sL : Size.sL;
            }
        case Size.sXL:
            {
                return strings ? strings["enum"]["Size"]["sXL"] || Size.sXL : Size.sXL;
            }
        case Size.sXXL:
            {
                return strings ? strings["enum"]["Size"]["sXXL"] || Size.sXXL : Size.sXXL;
            }
        case Size.s33:
            {
                return strings ? strings["enum"]["Size"]["s33"] || Size.s33 : Size.s33;
            }
        case Size.s34:
            {
                return strings ? strings["enum"]["Size"]["s34"] || Size.s34 : Size.s34;
            }
        case Size.s35:
            {
                return strings ? strings["enum"]["Size"]["s35"] || Size.s35 : Size.s35;
            }
        case Size.s36:
            {
                return strings ? strings["enum"]["Size"]["s36"] || Size.s36 : Size.s36;
            }
        case Size.s37:
            {
                return strings ? strings["enum"]["Size"]["s37"] || Size.s37 : Size.s37;
            }
        case Size.s38:
            {
                return strings ? strings["enum"]["Size"]["s38"] || Size.s38 : Size.s38;
            }
        case Size.s39:
            {
                return strings ? strings["enum"]["Size"]["s39"] || Size.s39 : Size.s39;
            }
        case Size.s40:
            {
                return strings ? strings["enum"]["Size"]["s40"] || Size.s40 : Size.s40;
            }
        case Size.s41:
            {
                return strings ? strings["enum"]["Size"]["s41"] || Size.s41 : Size.s41;
            }
        case Size.s42:
            {
                return strings ? strings["enum"]["Size"]["s42"] || Size.s42 : Size.s42;
            }
        case Size.s43:
            {
                return strings ? strings["enum"]["Size"]["s43"] || Size.s43 : Size.s43;
            }
        case Size.s44:
            {
                return strings ? strings["enum"]["Size"]["s44"] || Size.s44 : Size.s44;
            }
        case Size.s45:
            {
                return strings ? strings["enum"]["Size"]["s45"] || Size.s45 : Size.s45;
            }
        case Size.s46:
            {
                return strings ? strings["enum"]["Size"]["s46"] || Size.s46 : Size.s46;
            }
        case Size.s48:
            {
                return strings ? strings["enum"]["Size"]["s48"] || Size.s48 : Size.s48;
            }
        case Size.s50:
            {
                return strings ? strings["enum"]["Size"]["s50"] || Size.s50 : Size.s50;
            }
        case Size.s50Plus:
            {
                return strings ? strings["enum"]["Size"]["s50Plus"] || Size.s50Plus : Size.s50Plus;
            }
    }
    return "";
}
exports.translateSize = translateSize;
function allValuesSize() {
    return [Size.sSingle, Size.sXS, Size.sS, Size.sM, Size.sL, Size.sXL, Size.sXXL, Size.s33, Size.s34, Size.s35, Size.s36, Size.s37, Size.s38, Size.s39, Size.s40, Size.s41, Size.s42, Size.s43, Size.s44, Size.s45, Size.s46, Size.s48, Size.s50, Size.s50Plus];
}
exports.allValuesSize = allValuesSize;
function allTranslatedValuesSize() {
    return [translateSize(Size.sSingle), translateSize(Size.sXS), translateSize(Size.sS), translateSize(Size.sM), translateSize(Size.sL), translateSize(Size.sXL), translateSize(Size.sXXL), translateSize(Size.s33), translateSize(Size.s34), translateSize(Size.s35), translateSize(Size.s36), translateSize(Size.s37), translateSize(Size.s38), translateSize(Size.s39), translateSize(Size.s40), translateSize(Size.s41), translateSize(Size.s42), translateSize(Size.s43), translateSize(Size.s44), translateSize(Size.s45), translateSize(Size.s46), translateSize(Size.s48), translateSize(Size.s50), translateSize(Size.s50Plus)];
}
exports.allTranslatedValuesSize = allTranslatedValuesSize;
function allDisplayableValuesSize() {
    return allTranslatedValuesSize().sort();
}
exports.allDisplayableValuesSize = allDisplayableValuesSize;
function valueFromTranslationSize(translation) {
    var index = allTranslatedValuesSize().indexOf(translation);
    return allValuesSize()[index] || Size.sSingle;
}
exports.valueFromTranslationSize = valueFromTranslationSize;
var LocStatus;
(function (LocStatus) {
    LocStatus["pendingApproval"] = "pendingApproval";
    LocStatus["approved"] = "approved";
    LocStatus["notApproved"] = "notApproved";
    LocStatus["canceled"] = "canceled";
    LocStatus["deliveredToRequester"] = "deliveredToRequester";
    LocStatus["receivedByRequester"] = "receivedByRequester";
    LocStatus["deliveredToOwner"] = "deliveredToOwner";
    LocStatus["receivedByOwner"] = "receivedByOwner";
})(LocStatus = exports.LocStatus || (exports.LocStatus = {}));
function translateLocStatus(enumLocStatus) {
    switch (enumLocStatus) {
        case LocStatus.pendingApproval:
            {
                return strings ? strings["enum"]["LocStatus"]["pendingApproval"] || LocStatus.pendingApproval : LocStatus.pendingApproval;
            }
        case LocStatus.approved:
            {
                return strings ? strings["enum"]["LocStatus"]["approved"] || LocStatus.approved : LocStatus.approved;
            }
        case LocStatus.notApproved:
            {
                return strings ? strings["enum"]["LocStatus"]["notApproved"] || LocStatus.notApproved : LocStatus.notApproved;
            }
        case LocStatus.canceled:
            {
                return strings ? strings["enum"]["LocStatus"]["canceled"] || LocStatus.canceled : LocStatus.canceled;
            }
        case LocStatus.deliveredToRequester:
            {
                return strings ? strings["enum"]["LocStatus"]["deliveredToRequester"] || LocStatus.deliveredToRequester : LocStatus.deliveredToRequester;
            }
        case LocStatus.receivedByRequester:
            {
                return strings ? strings["enum"]["LocStatus"]["receivedByRequester"] || LocStatus.receivedByRequester : LocStatus.receivedByRequester;
            }
        case LocStatus.deliveredToOwner:
            {
                return strings ? strings["enum"]["LocStatus"]["deliveredToOwner"] || LocStatus.deliveredToOwner : LocStatus.deliveredToOwner;
            }
        case LocStatus.receivedByOwner:
            {
                return strings ? strings["enum"]["LocStatus"]["receivedByOwner"] || LocStatus.receivedByOwner : LocStatus.receivedByOwner;
            }
    }
    return "";
}
exports.translateLocStatus = translateLocStatus;
function allValuesLocStatus() {
    return [LocStatus.pendingApproval, LocStatus.approved, LocStatus.notApproved, LocStatus.canceled, LocStatus.deliveredToRequester, LocStatus.receivedByRequester, LocStatus.deliveredToOwner, LocStatus.receivedByOwner];
}
exports.allValuesLocStatus = allValuesLocStatus;
function allTranslatedValuesLocStatus() {
    return [translateLocStatus(LocStatus.pendingApproval), translateLocStatus(LocStatus.approved), translateLocStatus(LocStatus.notApproved), translateLocStatus(LocStatus.canceled), translateLocStatus(LocStatus.deliveredToRequester), translateLocStatus(LocStatus.receivedByRequester), translateLocStatus(LocStatus.deliveredToOwner), translateLocStatus(LocStatus.receivedByOwner)];
}
exports.allTranslatedValuesLocStatus = allTranslatedValuesLocStatus;
function allDisplayableValuesLocStatus() {
    return allTranslatedValuesLocStatus().sort();
}
exports.allDisplayableValuesLocStatus = allDisplayableValuesLocStatus;
function valueFromTranslationLocStatus(translation) {
    var index = allTranslatedValuesLocStatus().indexOf(translation);
    return allValuesLocStatus()[index] || LocStatus.pendingApproval;
}
exports.valueFromTranslationLocStatus = valueFromTranslationLocStatus;
var LocRequestActions;
(function (LocRequestActions) {
    LocRequestActions["approve"] = "approve";
    LocRequestActions["disapprove"] = "disapprove";
    LocRequestActions["deliverToRequester"] = "deliverToRequester";
    LocRequestActions["receiveFromRequester"] = "receiveFromRequester";
    LocRequestActions["deliverToOwner"] = "deliverToOwner";
    LocRequestActions["receiveFromOwner"] = "receiveFromOwner";
    LocRequestActions["cancel"] = "cancel";
    LocRequestActions["cancelWithPrejudice"] = "cancelWithPrejudice";
})(LocRequestActions = exports.LocRequestActions || (exports.LocRequestActions = {}));
function translateLocRequestActions(enumLocRequestActions) {
    switch (enumLocRequestActions) {
        case LocRequestActions.approve:
            {
                return strings ? strings["enum"]["LocRequestActions"]["approve"] || LocRequestActions.approve : LocRequestActions.approve;
            }
        case LocRequestActions.disapprove:
            {
                return strings ? strings["enum"]["LocRequestActions"]["disapprove"] || LocRequestActions.disapprove : LocRequestActions.disapprove;
            }
        case LocRequestActions.deliverToRequester:
            {
                return strings ? strings["enum"]["LocRequestActions"]["deliverToRequester"] || LocRequestActions.deliverToRequester : LocRequestActions.deliverToRequester;
            }
        case LocRequestActions.receiveFromRequester:
            {
                return strings ? strings["enum"]["LocRequestActions"]["receiveFromRequester"] || LocRequestActions.receiveFromRequester : LocRequestActions.receiveFromRequester;
            }
        case LocRequestActions.deliverToOwner:
            {
                return strings ? strings["enum"]["LocRequestActions"]["deliverToOwner"] || LocRequestActions.deliverToOwner : LocRequestActions.deliverToOwner;
            }
        case LocRequestActions.receiveFromOwner:
            {
                return strings ? strings["enum"]["LocRequestActions"]["receiveFromOwner"] || LocRequestActions.receiveFromOwner : LocRequestActions.receiveFromOwner;
            }
        case LocRequestActions.cancel:
            {
                return strings ? strings["enum"]["LocRequestActions"]["cancel"] || LocRequestActions.cancel : LocRequestActions.cancel;
            }
        case LocRequestActions.cancelWithPrejudice:
            {
                return strings ? strings["enum"]["LocRequestActions"]["cancelWithPrejudice"] || LocRequestActions.cancelWithPrejudice : LocRequestActions.cancelWithPrejudice;
            }
    }
    return "";
}
exports.translateLocRequestActions = translateLocRequestActions;
function allValuesLocRequestActions() {
    return [LocRequestActions.approve, LocRequestActions.disapprove, LocRequestActions.deliverToRequester, LocRequestActions.receiveFromRequester, LocRequestActions.deliverToOwner, LocRequestActions.receiveFromOwner, LocRequestActions.cancel, LocRequestActions.cancelWithPrejudice];
}
exports.allValuesLocRequestActions = allValuesLocRequestActions;
function allTranslatedValuesLocRequestActions() {
    return [translateLocRequestActions(LocRequestActions.approve), translateLocRequestActions(LocRequestActions.disapprove), translateLocRequestActions(LocRequestActions.deliverToRequester), translateLocRequestActions(LocRequestActions.receiveFromRequester), translateLocRequestActions(LocRequestActions.deliverToOwner), translateLocRequestActions(LocRequestActions.receiveFromOwner), translateLocRequestActions(LocRequestActions.cancel), translateLocRequestActions(LocRequestActions.cancelWithPrejudice)];
}
exports.allTranslatedValuesLocRequestActions = allTranslatedValuesLocRequestActions;
function allDisplayableValuesLocRequestActions() {
    return allTranslatedValuesLocRequestActions().sort();
}
exports.allDisplayableValuesLocRequestActions = allDisplayableValuesLocRequestActions;
function valueFromTranslationLocRequestActions(translation) {
    var index = allTranslatedValuesLocRequestActions().indexOf(translation);
    return allValuesLocRequestActions()[index] || LocRequestActions.approve;
}
exports.valueFromTranslationLocRequestActions = valueFromTranslationLocRequestActions;
var PromotionType;
(function (PromotionType) {
    PromotionType["percentage"] = "percentage";
    PromotionType["value"] = "value";
})(PromotionType = exports.PromotionType || (exports.PromotionType = {}));
function translatePromotionType(enumPromotionType) {
    switch (enumPromotionType) {
        case PromotionType.percentage:
            {
                return strings ? strings["enum"]["PromotionType"]["percentage"] || PromotionType.percentage : PromotionType.percentage;
            }
        case PromotionType.value:
            {
                return strings ? strings["enum"]["PromotionType"]["value"] || PromotionType.value : PromotionType.value;
            }
    }
    return "";
}
exports.translatePromotionType = translatePromotionType;
function allValuesPromotionType() {
    return [PromotionType.percentage, PromotionType.value];
}
exports.allValuesPromotionType = allValuesPromotionType;
function allTranslatedValuesPromotionType() {
    return [translatePromotionType(PromotionType.percentage), translatePromotionType(PromotionType.value)];
}
exports.allTranslatedValuesPromotionType = allTranslatedValuesPromotionType;
function allDisplayableValuesPromotionType() {
    return allTranslatedValuesPromotionType().sort();
}
exports.allDisplayableValuesPromotionType = allDisplayableValuesPromotionType;
function valueFromTranslationPromotionType(translation) {
    var index = allTranslatedValuesPromotionType().indexOf(translation);
    return allValuesPromotionType()[index] || PromotionType.percentage;
}
exports.valueFromTranslationPromotionType = valueFromTranslationPromotionType;
var NotificationType;
(function (NotificationType) {
    NotificationType["chat"] = "chat";
    NotificationType["locRequest"] = "locRequest";
    NotificationType["card"] = "card";
    NotificationType["bank"] = "bank";
    NotificationType["display"] = "display";
    NotificationType["item"] = "item";
    NotificationType["locker"] = "locker";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
function translateNotificationType(enumNotificationType) {
    switch (enumNotificationType) {
        case NotificationType.chat:
            {
                return strings ? strings["enum"]["NotificationType"]["chat"] || NotificationType.chat : NotificationType.chat;
            }
        case NotificationType.locRequest:
            {
                return strings ? strings["enum"]["NotificationType"]["locRequest"] || NotificationType.locRequest : NotificationType.locRequest;
            }
        case NotificationType.card:
            {
                return strings ? strings["enum"]["NotificationType"]["card"] || NotificationType.card : NotificationType.card;
            }
        case NotificationType.bank:
            {
                return strings ? strings["enum"]["NotificationType"]["bank"] || NotificationType.bank : NotificationType.bank;
            }
        case NotificationType.display:
            {
                return strings ? strings["enum"]["NotificationType"]["display"] || NotificationType.display : NotificationType.display;
            }
        case NotificationType.item:
            {
                return strings ? strings["enum"]["NotificationType"]["item"] || NotificationType.item : NotificationType.item;
            }
        case NotificationType.locker:
            {
                return strings ? strings["enum"]["NotificationType"]["locker"] || NotificationType.locker : NotificationType.locker;
            }
    }
    return "";
}
exports.translateNotificationType = translateNotificationType;
function allValuesNotificationType() {
    return [NotificationType.chat, NotificationType.locRequest, NotificationType.card, NotificationType.bank, NotificationType.display, NotificationType.item, NotificationType.locker];
}
exports.allValuesNotificationType = allValuesNotificationType;
function allTranslatedValuesNotificationType() {
    return [translateNotificationType(NotificationType.chat), translateNotificationType(NotificationType.locRequest), translateNotificationType(NotificationType.card), translateNotificationType(NotificationType.bank), translateNotificationType(NotificationType.display), translateNotificationType(NotificationType.item), translateNotificationType(NotificationType.locker)];
}
exports.allTranslatedValuesNotificationType = allTranslatedValuesNotificationType;
function allDisplayableValuesNotificationType() {
    return allTranslatedValuesNotificationType().sort();
}
exports.allDisplayableValuesNotificationType = allDisplayableValuesNotificationType;
function valueFromTranslationNotificationType(translation) {
    var index = allTranslatedValuesNotificationType().indexOf(translation);
    return allValuesNotificationType()[index] || NotificationType.chat;
}
exports.valueFromTranslationNotificationType = valueFromTranslationNotificationType;
var Providers;
(function (Providers) {
    Providers["google"] = "google";
    Providers["facebook"] = "facebook";
})(Providers = exports.Providers || (exports.Providers = {}));
function translateProviders(enumProviders) {
    switch (enumProviders) {
        case Providers.google:
            {
                return strings ? strings["enum"]["Providers"]["google"] || Providers.google : Providers.google;
            }
        case Providers.facebook:
            {
                return strings ? strings["enum"]["Providers"]["facebook"] || Providers.facebook : Providers.facebook;
            }
    }
    return "";
}
exports.translateProviders = translateProviders;
function allValuesProviders() {
    return [Providers.google, Providers.facebook];
}
exports.allValuesProviders = allValuesProviders;
function allTranslatedValuesProviders() {
    return [translateProviders(Providers.google), translateProviders(Providers.facebook)];
}
exports.allTranslatedValuesProviders = allTranslatedValuesProviders;
function allDisplayableValuesProviders() {
    return allTranslatedValuesProviders().sort();
}
exports.allDisplayableValuesProviders = allDisplayableValuesProviders;
function valueFromTranslationProviders(translation) {
    var index = allTranslatedValuesProviders().indexOf(translation);
    return allValuesProviders()[index] || Providers.google;
}
exports.valueFromTranslationProviders = valueFromTranslationProviders;
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["contaCorrente"] = "contaCorrente";
    BankAccountType["contaPoupanca"] = "contaPoupanca";
    BankAccountType["contaCorrenteConjunta"] = "contaCorrenteConjunta";
    BankAccountType["contaPoupancaConjunta"] = "contaPoupancaConjunta";
})(BankAccountType = exports.BankAccountType || (exports.BankAccountType = {}));
function translateBankAccountType(enumBankAccountType) {
    switch (enumBankAccountType) {
        case BankAccountType.contaCorrente:
            {
                return strings ? strings["enum"]["BankAccountType"]["contaCorrente"] || BankAccountType.contaCorrente : BankAccountType.contaCorrente;
            }
        case BankAccountType.contaPoupanca:
            {
                return strings ? strings["enum"]["BankAccountType"]["contaPoupanca"] || BankAccountType.contaPoupanca : BankAccountType.contaPoupanca;
            }
        case BankAccountType.contaCorrenteConjunta:
            {
                return strings ? strings["enum"]["BankAccountType"]["contaCorrenteConjunta"] || BankAccountType.contaCorrenteConjunta : BankAccountType.contaCorrenteConjunta;
            }
        case BankAccountType.contaPoupancaConjunta:
            {
                return strings ? strings["enum"]["BankAccountType"]["contaPoupancaConjunta"] || BankAccountType.contaPoupancaConjunta : BankAccountType.contaPoupancaConjunta;
            }
    }
    return "";
}
exports.translateBankAccountType = translateBankAccountType;
function allValuesBankAccountType() {
    return [BankAccountType.contaCorrente, BankAccountType.contaPoupanca, BankAccountType.contaCorrenteConjunta, BankAccountType.contaPoupancaConjunta];
}
exports.allValuesBankAccountType = allValuesBankAccountType;
function allTranslatedValuesBankAccountType() {
    return [translateBankAccountType(BankAccountType.contaCorrente), translateBankAccountType(BankAccountType.contaPoupanca), translateBankAccountType(BankAccountType.contaCorrenteConjunta), translateBankAccountType(BankAccountType.contaPoupancaConjunta)];
}
exports.allTranslatedValuesBankAccountType = allTranslatedValuesBankAccountType;
function allDisplayableValuesBankAccountType() {
    return allTranslatedValuesBankAccountType().sort();
}
exports.allDisplayableValuesBankAccountType = allDisplayableValuesBankAccountType;
function valueFromTranslationBankAccountType(translation) {
    var index = allTranslatedValuesBankAccountType().indexOf(translation);
    return allValuesBankAccountType()[index] || BankAccountType.contaCorrente;
}
exports.valueFromTranslationBankAccountType = valueFromTranslationBankAccountType;
var NFeStatus;
(function (NFeStatus) {
    NFeStatus["Issued"] = "Issued";
    NFeStatus["Created"] = "Created";
    NFeStatus["Error"] = "Error";
    NFeStatus["None"] = "None";
})(NFeStatus = exports.NFeStatus || (exports.NFeStatus = {}));
function translateNFeStatus(enumNFeStatus) {
    switch (enumNFeStatus) {
        case NFeStatus.Issued:
            {
                return strings ? strings["enum"]["NFeStatus"]["Issued"] || NFeStatus.Issued : NFeStatus.Issued;
            }
        case NFeStatus.Created:
            {
                return strings ? strings["enum"]["NFeStatus"]["Created"] || NFeStatus.Created : NFeStatus.Created;
            }
        case NFeStatus.Error:
            {
                return strings ? strings["enum"]["NFeStatus"]["Error"] || NFeStatus.Error : NFeStatus.Error;
            }
        case NFeStatus.None:
            {
                return strings ? strings["enum"]["NFeStatus"]["None"] || NFeStatus.None : NFeStatus.None;
            }
    }
    return "";
}
exports.translateNFeStatus = translateNFeStatus;
function allValuesNFeStatus() {
    return [NFeStatus.Issued, NFeStatus.Created, NFeStatus.Error, NFeStatus.None];
}
exports.allValuesNFeStatus = allValuesNFeStatus;
function allTranslatedValuesNFeStatus() {
    return [translateNFeStatus(NFeStatus.Issued), translateNFeStatus(NFeStatus.Created), translateNFeStatus(NFeStatus.Error), translateNFeStatus(NFeStatus.None)];
}
exports.allTranslatedValuesNFeStatus = allTranslatedValuesNFeStatus;
function allDisplayableValuesNFeStatus() {
    return allTranslatedValuesNFeStatus().sort();
}
exports.allDisplayableValuesNFeStatus = allDisplayableValuesNFeStatus;
function valueFromTranslationNFeStatus(translation) {
    var index = allTranslatedValuesNFeStatus().indexOf(translation);
    return allValuesNFeStatus()[index] || NFeStatus.Issued;
}
exports.valueFromTranslationNFeStatus = valueFromTranslationNFeStatus;
var Gender;
(function (Gender) {
    Gender["female"] = "female";
    Gender["male"] = "male";
})(Gender = exports.Gender || (exports.Gender = {}));
function translateGender(enumGender) {
    switch (enumGender) {
        case Gender.female:
            {
                return strings ? strings["enum"]["Gender"]["female"] || Gender.female : Gender.female;
            }
        case Gender.male:
            {
                return strings ? strings["enum"]["Gender"]["male"] || Gender.male : Gender.male;
            }
    }
    return "";
}
exports.translateGender = translateGender;
function allValuesGender() {
    return [Gender.female, Gender.male];
}
exports.allValuesGender = allValuesGender;
function allTranslatedValuesGender() {
    return [translateGender(Gender.female), translateGender(Gender.male)];
}
exports.allTranslatedValuesGender = allTranslatedValuesGender;
function allDisplayableValuesGender() {
    return allTranslatedValuesGender().sort();
}
exports.allDisplayableValuesGender = allDisplayableValuesGender;
function valueFromTranslationGender(translation) {
    var index = allTranslatedValuesGender().indexOf(translation);
    return allValuesGender()[index] || Gender.female;
}
exports.valueFromTranslationGender = valueFromTranslationGender;
var MessageType;
(function (MessageType) {
    MessageType["text"] = "text";
    MessageType["image"] = "image";
    MessageType["statusChanged"] = "statusChanged";
    MessageType["itemSelected"] = "itemSelected";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
function translateMessageType(enumMessageType) {
    switch (enumMessageType) {
        case MessageType.text:
            {
                return strings ? strings["enum"]["MessageType"]["text"] || MessageType.text : MessageType.text;
            }
        case MessageType.image:
            {
                return strings ? strings["enum"]["MessageType"]["image"] || MessageType.image : MessageType.image;
            }
        case MessageType.statusChanged:
            {
                return strings ? strings["enum"]["MessageType"]["statusChanged"] || MessageType.statusChanged : MessageType.statusChanged;
            }
        case MessageType.itemSelected:
            {
                return strings ? strings["enum"]["MessageType"]["itemSelected"] || MessageType.itemSelected : MessageType.itemSelected;
            }
    }
    return "";
}
exports.translateMessageType = translateMessageType;
function allValuesMessageType() {
    return [MessageType.text, MessageType.image, MessageType.statusChanged, MessageType.itemSelected];
}
exports.allValuesMessageType = allValuesMessageType;
function allTranslatedValuesMessageType() {
    return [translateMessageType(MessageType.text), translateMessageType(MessageType.image), translateMessageType(MessageType.statusChanged), translateMessageType(MessageType.itemSelected)];
}
exports.allTranslatedValuesMessageType = allTranslatedValuesMessageType;
function allDisplayableValuesMessageType() {
    return allTranslatedValuesMessageType().sort();
}
exports.allDisplayableValuesMessageType = allDisplayableValuesMessageType;
function valueFromTranslationMessageType(translation) {
    var index = allTranslatedValuesMessageType().indexOf(translation);
    return allValuesMessageType()[index] || MessageType.text;
}
exports.valueFromTranslationMessageType = valueFromTranslationMessageType;
var TalkToLOCType;
(function (TalkToLOCType) {
    TalkToLOCType["creditCard"] = "creditCard";
    TalkToLOCType["locRequest"] = "locRequest";
    TalkToLOCType["app"] = "app";
    TalkToLOCType["others"] = "others";
})(TalkToLOCType = exports.TalkToLOCType || (exports.TalkToLOCType = {}));
function translateTalkToLOCType(enumTalkToLOCType) {
    switch (enumTalkToLOCType) {
        case TalkToLOCType.creditCard:
            {
                return strings ? strings["enum"]["TalkToLOCType"]["creditCard"] || TalkToLOCType.creditCard : TalkToLOCType.creditCard;
            }
        case TalkToLOCType.locRequest:
            {
                return strings ? strings["enum"]["TalkToLOCType"]["locRequest"] || TalkToLOCType.locRequest : TalkToLOCType.locRequest;
            }
        case TalkToLOCType.app:
            {
                return strings ? strings["enum"]["TalkToLOCType"]["app"] || TalkToLOCType.app : TalkToLOCType.app;
            }
        case TalkToLOCType.others:
            {
                return strings ? strings["enum"]["TalkToLOCType"]["others"] || TalkToLOCType.others : TalkToLOCType.others;
            }
    }
    return "";
}
exports.translateTalkToLOCType = translateTalkToLOCType;
function allValuesTalkToLOCType() {
    return [TalkToLOCType.creditCard, TalkToLOCType.locRequest, TalkToLOCType.app, TalkToLOCType.others];
}
exports.allValuesTalkToLOCType = allValuesTalkToLOCType;
function allTranslatedValuesTalkToLOCType() {
    return [translateTalkToLOCType(TalkToLOCType.creditCard), translateTalkToLOCType(TalkToLOCType.locRequest), translateTalkToLOCType(TalkToLOCType.app), translateTalkToLOCType(TalkToLOCType.others)];
}
exports.allTranslatedValuesTalkToLOCType = allTranslatedValuesTalkToLOCType;
function allDisplayableValuesTalkToLOCType() {
    return allTranslatedValuesTalkToLOCType().sort();
}
exports.allDisplayableValuesTalkToLOCType = allDisplayableValuesTalkToLOCType;
function valueFromTranslationTalkToLOCType(translation) {
    var index = allTranslatedValuesTalkToLOCType().indexOf(translation);
    return allValuesTalkToLOCType()[index] || TalkToLOCType.creditCard;
}
exports.valueFromTranslationTalkToLOCType = valueFromTranslationTalkToLOCType;
var MQTTType;
(function (MQTTType) {
    MQTTType["chat"] = "chat";
    MQTTType["reloadLocRequest"] = "reloadLocRequest";
})(MQTTType = exports.MQTTType || (exports.MQTTType = {}));
function translateMQTTType(enumMQTTType) {
    switch (enumMQTTType) {
        case MQTTType.chat:
            {
                return strings ? strings["enum"]["MQTTType"]["chat"] || MQTTType.chat : MQTTType.chat;
            }
        case MQTTType.reloadLocRequest:
            {
                return strings ? strings["enum"]["MQTTType"]["reloadLocRequest"] || MQTTType.reloadLocRequest : MQTTType.reloadLocRequest;
            }
    }
    return "";
}
exports.translateMQTTType = translateMQTTType;
function allValuesMQTTType() {
    return [MQTTType.chat, MQTTType.reloadLocRequest];
}
exports.allValuesMQTTType = allValuesMQTTType;
function allTranslatedValuesMQTTType() {
    return [translateMQTTType(MQTTType.chat), translateMQTTType(MQTTType.reloadLocRequest)];
}
exports.allTranslatedValuesMQTTType = allTranslatedValuesMQTTType;
function allDisplayableValuesMQTTType() {
    return allTranslatedValuesMQTTType().sort();
}
exports.allDisplayableValuesMQTTType = allDisplayableValuesMQTTType;
function valueFromTranslationMQTTType(translation) {
    var index = allTranslatedValuesMQTTType().indexOf(translation);
    return allValuesMQTTType()[index] || MQTTType.chat;
}
exports.valueFromTranslationMQTTType = valueFromTranslationMQTTType;
var OrderBy;
(function (OrderBy) {
    OrderBy["relevant"] = "relevant";
    OrderBy["popular"] = "popular";
    OrderBy["lowestPrice"] = "lowestPrice";
    OrderBy["highestPrice"] = "highestPrice";
})(OrderBy = exports.OrderBy || (exports.OrderBy = {}));
function translateOrderBy(enumOrderBy) {
    switch (enumOrderBy) {
        case OrderBy.relevant:
            {
                return strings ? strings["enum"]["OrderBy"]["relevant"] || OrderBy.relevant : OrderBy.relevant;
            }
        case OrderBy.popular:
            {
                return strings ? strings["enum"]["OrderBy"]["popular"] || OrderBy.popular : OrderBy.popular;
            }
        case OrderBy.lowestPrice:
            {
                return strings ? strings["enum"]["OrderBy"]["lowestPrice"] || OrderBy.lowestPrice : OrderBy.lowestPrice;
            }
        case OrderBy.highestPrice:
            {
                return strings ? strings["enum"]["OrderBy"]["highestPrice"] || OrderBy.highestPrice : OrderBy.highestPrice;
            }
    }
    return "";
}
exports.translateOrderBy = translateOrderBy;
function allValuesOrderBy() {
    return [OrderBy.relevant, OrderBy.popular, OrderBy.lowestPrice, OrderBy.highestPrice];
}
exports.allValuesOrderBy = allValuesOrderBy;
function allTranslatedValuesOrderBy() {
    return [translateOrderBy(OrderBy.relevant), translateOrderBy(OrderBy.popular), translateOrderBy(OrderBy.lowestPrice), translateOrderBy(OrderBy.highestPrice)];
}
exports.allTranslatedValuesOrderBy = allTranslatedValuesOrderBy;
function allDisplayableValuesOrderBy() {
    return allTranslatedValuesOrderBy().sort();
}
exports.allDisplayableValuesOrderBy = allDisplayableValuesOrderBy;
function valueFromTranslationOrderBy(translation) {
    var index = allTranslatedValuesOrderBy().indexOf(translation);
    return allValuesOrderBy()[index] || OrderBy.relevant;
}
exports.valueFromTranslationOrderBy = valueFromTranslationOrderBy;
var ErrorType;
(function (ErrorType) {
    ErrorType["PaymentRefused"] = "PaymentRefused";
    ErrorType["InternalError"] = "InternalError";
    ErrorType["TransferValueTooLow"] = "TransferValueTooLow";
    ErrorType["FailedToRefund"] = "FailedToRefund";
    ErrorType["InvalidAccountDv"] = "InvalidAccountDv";
    ErrorType["InvalidAgencyDv"] = "InvalidAgencyDv";
    ErrorType["InvalidAccountNumber"] = "InvalidAccountNumber";
    ErrorType["InvalidAgencyNumber"] = "InvalidAgencyNumber";
    ErrorType["InvalidBankCode"] = "InvalidBankCode";
    ErrorType["NotFound"] = "NotFound";
    ErrorType["NotLoggedIn"] = "NotLoggedIn";
    ErrorType["MissingParameter"] = "MissingParameter";
    ErrorType["AccessNotAllowed"] = "AccessNotAllowed";
    ErrorType["ValueTooLarge"] = "ValueTooLarge";
    ErrorType["ValueTooSmall"] = "ValueTooSmall";
    ErrorType["InvalidEmail"] = "InvalidEmail";
    ErrorType["DateUnavaiable"] = "DateUnavaiable";
    ErrorType["PeriodTooSmall"] = "PeriodTooSmall";
    ErrorType["CardWalletEmpty"] = "CardWalletEmpty";
    ErrorType["DeletedCard"] = "DeletedCard";
    ErrorType["UserDoesntExist"] = "UserDoesntExist";
    ErrorType["ShouldUseThirdParty"] = "ShouldUseThirdParty";
    ErrorType["WrongPassword"] = "WrongPassword";
    ErrorType["LoginError"] = "LoginError";
    ErrorType["ThirdPartyAuthError"] = "ThirdPartyAuthError";
    ErrorType["WrongCredentials"] = "WrongCredentials";
    ErrorType["EmailDoesntExist"] = "EmailDoesntExist";
    ErrorType["PasswordToSmall"] = "PasswordToSmall";
    ErrorType["InvalidDocumentNumber"] = "InvalidDocumentNumber";
    ErrorType["InvalidZipCode"] = "InvalidZipCode";
    ErrorType["AddresNotSet"] = "AddresNotSet";
    ErrorType["InvalidLocation"] = "InvalidLocation";
    ErrorType["ShippingDateNotAvaiable"] = "ShippingDateNotAvaiable";
    ErrorType["ShippingDistanceTooLarge"] = "ShippingDistanceTooLarge";
    ErrorType["ShippingCityNotAvaiable"] = "ShippingCityNotAvaiable";
    ErrorType["DeletedItem"] = "DeletedItem";
    ErrorType["AlreadyRegistered"] = "AlreadyRegistered";
    ErrorType["NameTooSmall"] = "NameTooSmall";
    ErrorType["NameTooLarge"] = "NameTooLarge";
    ErrorType["NickAlreadyInUse"] = "NickAlreadyInUse";
    ErrorType["InvalidNick"] = "InvalidNick";
    ErrorType["InvalidBirthday"] = "InvalidBirthday";
    ErrorType["InvalidPhoneNumber"] = "InvalidPhoneNumber";
    ErrorType["DocumentNumberUnavaiable"] = "DocumentNumberUnavaiable";
    ErrorType["InvalidAddress"] = "InvalidAddress";
    ErrorType["InvalidCardNumber"] = "InvalidCardNumber";
    ErrorType["InvalidCvv"] = "InvalidCvv";
    ErrorType["InvalidExpirationDate"] = "InvalidExpirationDate";
    ErrorType["InvalidCardHolderName"] = "InvalidCardHolderName";
    ErrorType["InvalidCard"] = "InvalidCard";
    ErrorType["CustomerIdDoesntExist"] = "CustomerIdDoesntExist";
    ErrorType["RecipientIdDoesntExist"] = "RecipientIdDoesntExist";
    ErrorType["PaymentNotApproved"] = "PaymentNotApproved";
    ErrorType["ActionNotAllowed"] = "ActionNotAllowed";
    ErrorType["UserDocumentsNotVerified"] = "UserDocumentsNotVerified";
    ErrorType["NoItemRefered"] = "NoItemRefered";
    ErrorType["MessageAlreadySent"] = "MessageAlreadySent";
    ErrorType["InvalidDistance"] = "InvalidDistance";
    ErrorType["InvalidRentPrice"] = "InvalidRentPrice";
    ErrorType["InvalidOriginalPrice"] = "InvalidOriginalPrice";
    ErrorType["AlreadyRated"] = "AlreadyRated";
    ErrorType["InvalidRate"] = "InvalidRate";
    ErrorType["InvalidPromotion"] = "InvalidPromotion";
    ErrorType["ExpiredPromotion"] = "ExpiredPromotion";
    ErrorType["SaturatedPromotion"] = "SaturatedPromotion";
    ErrorType["PromotionAlreadyUsed"] = "PromotionAlreadyUsed";
    ErrorType["Fatal"] = "Fatal";
    ErrorType["Connection"] = "Connection";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
function translateErrorType(enumErrorType) {
    switch (enumErrorType) {
        case ErrorType.PaymentRefused:
            {
                return strings ? strings["enum"]["ErrorType"]["PaymentRefused"] || ErrorType.PaymentRefused : ErrorType.PaymentRefused;
            }
        case ErrorType.InternalError:
            {
                return strings ? strings["enum"]["ErrorType"]["InternalError"] || ErrorType.InternalError : ErrorType.InternalError;
            }
        case ErrorType.TransferValueTooLow:
            {
                return strings ? strings["enum"]["ErrorType"]["TransferValueTooLow"] || ErrorType.TransferValueTooLow : ErrorType.TransferValueTooLow;
            }
        case ErrorType.FailedToRefund:
            {
                return strings ? strings["enum"]["ErrorType"]["FailedToRefund"] || ErrorType.FailedToRefund : ErrorType.FailedToRefund;
            }
        case ErrorType.InvalidAccountDv:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAccountDv"] || ErrorType.InvalidAccountDv : ErrorType.InvalidAccountDv;
            }
        case ErrorType.InvalidAgencyDv:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAgencyDv"] || ErrorType.InvalidAgencyDv : ErrorType.InvalidAgencyDv;
            }
        case ErrorType.InvalidAccountNumber:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAccountNumber"] || ErrorType.InvalidAccountNumber : ErrorType.InvalidAccountNumber;
            }
        case ErrorType.InvalidAgencyNumber:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAgencyNumber"] || ErrorType.InvalidAgencyNumber : ErrorType.InvalidAgencyNumber;
            }
        case ErrorType.InvalidBankCode:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidBankCode"] || ErrorType.InvalidBankCode : ErrorType.InvalidBankCode;
            }
        case ErrorType.NotFound:
            {
                return strings ? strings["enum"]["ErrorType"]["NotFound"] || ErrorType.NotFound : ErrorType.NotFound;
            }
        case ErrorType.NotLoggedIn:
            {
                return strings ? strings["enum"]["ErrorType"]["NotLoggedIn"] || ErrorType.NotLoggedIn : ErrorType.NotLoggedIn;
            }
        case ErrorType.MissingParameter:
            {
                return strings ? strings["enum"]["ErrorType"]["MissingParameter"] || ErrorType.MissingParameter : ErrorType.MissingParameter;
            }
        case ErrorType.AccessNotAllowed:
            {
                return strings ? strings["enum"]["ErrorType"]["AccessNotAllowed"] || ErrorType.AccessNotAllowed : ErrorType.AccessNotAllowed;
            }
        case ErrorType.ValueTooLarge:
            {
                return strings ? strings["enum"]["ErrorType"]["ValueTooLarge"] || ErrorType.ValueTooLarge : ErrorType.ValueTooLarge;
            }
        case ErrorType.ValueTooSmall:
            {
                return strings ? strings["enum"]["ErrorType"]["ValueTooSmall"] || ErrorType.ValueTooSmall : ErrorType.ValueTooSmall;
            }
        case ErrorType.InvalidEmail:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidEmail"] || ErrorType.InvalidEmail : ErrorType.InvalidEmail;
            }
        case ErrorType.DateUnavaiable:
            {
                return strings ? strings["enum"]["ErrorType"]["DateUnavaiable"] || ErrorType.DateUnavaiable : ErrorType.DateUnavaiable;
            }
        case ErrorType.PeriodTooSmall:
            {
                return strings ? strings["enum"]["ErrorType"]["PeriodTooSmall"] || ErrorType.PeriodTooSmall : ErrorType.PeriodTooSmall;
            }
        case ErrorType.CardWalletEmpty:
            {
                return strings ? strings["enum"]["ErrorType"]["CardWalletEmpty"] || ErrorType.CardWalletEmpty : ErrorType.CardWalletEmpty;
            }
        case ErrorType.DeletedCard:
            {
                return strings ? strings["enum"]["ErrorType"]["DeletedCard"] || ErrorType.DeletedCard : ErrorType.DeletedCard;
            }
        case ErrorType.UserDoesntExist:
            {
                return strings ? strings["enum"]["ErrorType"]["UserDoesntExist"] || ErrorType.UserDoesntExist : ErrorType.UserDoesntExist;
            }
        case ErrorType.ShouldUseThirdParty:
            {
                return strings ? strings["enum"]["ErrorType"]["ShouldUseThirdParty"] || ErrorType.ShouldUseThirdParty : ErrorType.ShouldUseThirdParty;
            }
        case ErrorType.WrongPassword:
            {
                return strings ? strings["enum"]["ErrorType"]["WrongPassword"] || ErrorType.WrongPassword : ErrorType.WrongPassword;
            }
        case ErrorType.LoginError:
            {
                return strings ? strings["enum"]["ErrorType"]["LoginError"] || ErrorType.LoginError : ErrorType.LoginError;
            }
        case ErrorType.ThirdPartyAuthError:
            {
                return strings ? strings["enum"]["ErrorType"]["ThirdPartyAuthError"] || ErrorType.ThirdPartyAuthError : ErrorType.ThirdPartyAuthError;
            }
        case ErrorType.WrongCredentials:
            {
                return strings ? strings["enum"]["ErrorType"]["WrongCredentials"] || ErrorType.WrongCredentials : ErrorType.WrongCredentials;
            }
        case ErrorType.EmailDoesntExist:
            {
                return strings ? strings["enum"]["ErrorType"]["EmailDoesntExist"] || ErrorType.EmailDoesntExist : ErrorType.EmailDoesntExist;
            }
        case ErrorType.PasswordToSmall:
            {
                return strings ? strings["enum"]["ErrorType"]["PasswordToSmall"] || ErrorType.PasswordToSmall : ErrorType.PasswordToSmall;
            }
        case ErrorType.InvalidDocumentNumber:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidDocumentNumber"] || ErrorType.InvalidDocumentNumber : ErrorType.InvalidDocumentNumber;
            }
        case ErrorType.InvalidZipCode:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidZipCode"] || ErrorType.InvalidZipCode : ErrorType.InvalidZipCode;
            }
        case ErrorType.AddresNotSet:
            {
                return strings ? strings["enum"]["ErrorType"]["AddresNotSet"] || ErrorType.AddresNotSet : ErrorType.AddresNotSet;
            }
        case ErrorType.InvalidLocation:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidLocation"] || ErrorType.InvalidLocation : ErrorType.InvalidLocation;
            }
        case ErrorType.ShippingDateNotAvaiable:
            {
                return strings ? strings["enum"]["ErrorType"]["ShippingDateNotAvaiable"] || ErrorType.ShippingDateNotAvaiable : ErrorType.ShippingDateNotAvaiable;
            }
        case ErrorType.ShippingDistanceTooLarge:
            {
                return strings ? strings["enum"]["ErrorType"]["ShippingDistanceTooLarge"] || ErrorType.ShippingDistanceTooLarge : ErrorType.ShippingDistanceTooLarge;
            }
        case ErrorType.ShippingCityNotAvaiable:
            {
                return strings ? strings["enum"]["ErrorType"]["ShippingCityNotAvaiable"] || ErrorType.ShippingCityNotAvaiable : ErrorType.ShippingCityNotAvaiable;
            }
        case ErrorType.DeletedItem:
            {
                return strings ? strings["enum"]["ErrorType"]["DeletedItem"] || ErrorType.DeletedItem : ErrorType.DeletedItem;
            }
        case ErrorType.AlreadyRegistered:
            {
                return strings ? strings["enum"]["ErrorType"]["AlreadyRegistered"] || ErrorType.AlreadyRegistered : ErrorType.AlreadyRegistered;
            }
        case ErrorType.NameTooSmall:
            {
                return strings ? strings["enum"]["ErrorType"]["NameTooSmall"] || ErrorType.NameTooSmall : ErrorType.NameTooSmall;
            }
        case ErrorType.NameTooLarge:
            {
                return strings ? strings["enum"]["ErrorType"]["NameTooLarge"] || ErrorType.NameTooLarge : ErrorType.NameTooLarge;
            }
        case ErrorType.NickAlreadyInUse:
            {
                return strings ? strings["enum"]["ErrorType"]["NickAlreadyInUse"] || ErrorType.NickAlreadyInUse : ErrorType.NickAlreadyInUse;
            }
        case ErrorType.InvalidNick:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidNick"] || ErrorType.InvalidNick : ErrorType.InvalidNick;
            }
        case ErrorType.InvalidBirthday:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidBirthday"] || ErrorType.InvalidBirthday : ErrorType.InvalidBirthday;
            }
        case ErrorType.InvalidPhoneNumber:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidPhoneNumber"] || ErrorType.InvalidPhoneNumber : ErrorType.InvalidPhoneNumber;
            }
        case ErrorType.DocumentNumberUnavaiable:
            {
                return strings ? strings["enum"]["ErrorType"]["DocumentNumberUnavaiable"] || ErrorType.DocumentNumberUnavaiable : ErrorType.DocumentNumberUnavaiable;
            }
        case ErrorType.InvalidAddress:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidAddress"] || ErrorType.InvalidAddress : ErrorType.InvalidAddress;
            }
        case ErrorType.InvalidCardNumber:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidCardNumber"] || ErrorType.InvalidCardNumber : ErrorType.InvalidCardNumber;
            }
        case ErrorType.InvalidCvv:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidCvv"] || ErrorType.InvalidCvv : ErrorType.InvalidCvv;
            }
        case ErrorType.InvalidExpirationDate:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidExpirationDate"] || ErrorType.InvalidExpirationDate : ErrorType.InvalidExpirationDate;
            }
        case ErrorType.InvalidCardHolderName:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidCardHolderName"] || ErrorType.InvalidCardHolderName : ErrorType.InvalidCardHolderName;
            }
        case ErrorType.InvalidCard:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidCard"] || ErrorType.InvalidCard : ErrorType.InvalidCard;
            }
        case ErrorType.CustomerIdDoesntExist:
            {
                return strings ? strings["enum"]["ErrorType"]["CustomerIdDoesntExist"] || ErrorType.CustomerIdDoesntExist : ErrorType.CustomerIdDoesntExist;
            }
        case ErrorType.RecipientIdDoesntExist:
            {
                return strings ? strings["enum"]["ErrorType"]["RecipientIdDoesntExist"] || ErrorType.RecipientIdDoesntExist : ErrorType.RecipientIdDoesntExist;
            }
        case ErrorType.PaymentNotApproved:
            {
                return strings ? strings["enum"]["ErrorType"]["PaymentNotApproved"] || ErrorType.PaymentNotApproved : ErrorType.PaymentNotApproved;
            }
        case ErrorType.ActionNotAllowed:
            {
                return strings ? strings["enum"]["ErrorType"]["ActionNotAllowed"] || ErrorType.ActionNotAllowed : ErrorType.ActionNotAllowed;
            }
        case ErrorType.UserDocumentsNotVerified:
            {
                return strings ? strings["enum"]["ErrorType"]["UserDocumentsNotVerified"] || ErrorType.UserDocumentsNotVerified : ErrorType.UserDocumentsNotVerified;
            }
        case ErrorType.NoItemRefered:
            {
                return strings ? strings["enum"]["ErrorType"]["NoItemRefered"] || ErrorType.NoItemRefered : ErrorType.NoItemRefered;
            }
        case ErrorType.MessageAlreadySent:
            {
                return strings ? strings["enum"]["ErrorType"]["MessageAlreadySent"] || ErrorType.MessageAlreadySent : ErrorType.MessageAlreadySent;
            }
        case ErrorType.InvalidDistance:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidDistance"] || ErrorType.InvalidDistance : ErrorType.InvalidDistance;
            }
        case ErrorType.InvalidRentPrice:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidRentPrice"] || ErrorType.InvalidRentPrice : ErrorType.InvalidRentPrice;
            }
        case ErrorType.InvalidOriginalPrice:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidOriginalPrice"] || ErrorType.InvalidOriginalPrice : ErrorType.InvalidOriginalPrice;
            }
        case ErrorType.AlreadyRated:
            {
                return strings ? strings["enum"]["ErrorType"]["AlreadyRated"] || ErrorType.AlreadyRated : ErrorType.AlreadyRated;
            }
        case ErrorType.InvalidRate:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidRate"] || ErrorType.InvalidRate : ErrorType.InvalidRate;
            }
        case ErrorType.InvalidPromotion:
            {
                return strings ? strings["enum"]["ErrorType"]["InvalidPromotion"] || ErrorType.InvalidPromotion : ErrorType.InvalidPromotion;
            }
        case ErrorType.ExpiredPromotion:
            {
                return strings ? strings["enum"]["ErrorType"]["ExpiredPromotion"] || ErrorType.ExpiredPromotion : ErrorType.ExpiredPromotion;
            }
        case ErrorType.SaturatedPromotion:
            {
                return strings ? strings["enum"]["ErrorType"]["SaturatedPromotion"] || ErrorType.SaturatedPromotion : ErrorType.SaturatedPromotion;
            }
        case ErrorType.PromotionAlreadyUsed:
            {
                return strings ? strings["enum"]["ErrorType"]["PromotionAlreadyUsed"] || ErrorType.PromotionAlreadyUsed : ErrorType.PromotionAlreadyUsed;
            }
        case ErrorType.Fatal:
            {
                return strings ? strings["enum"]["ErrorType"]["Fatal"] || ErrorType.Fatal : ErrorType.Fatal;
            }
        case ErrorType.Connection:
            {
                return strings ? strings["enum"]["ErrorType"]["Connection"] || ErrorType.Connection : ErrorType.Connection;
            }
    }
    return "";
}
exports.translateErrorType = translateErrorType;
function allValuesErrorType() {
    return [ErrorType.PaymentRefused, ErrorType.InternalError, ErrorType.TransferValueTooLow, ErrorType.FailedToRefund, ErrorType.InvalidAccountDv, ErrorType.InvalidAgencyDv, ErrorType.InvalidAccountNumber, ErrorType.InvalidAgencyNumber, ErrorType.InvalidBankCode, ErrorType.NotFound, ErrorType.NotLoggedIn, ErrorType.MissingParameter, ErrorType.AccessNotAllowed, ErrorType.ValueTooLarge, ErrorType.ValueTooSmall, ErrorType.InvalidEmail, ErrorType.DateUnavaiable, ErrorType.PeriodTooSmall, ErrorType.CardWalletEmpty, ErrorType.DeletedCard, ErrorType.UserDoesntExist, ErrorType.ShouldUseThirdParty, ErrorType.WrongPassword, ErrorType.LoginError, ErrorType.ThirdPartyAuthError, ErrorType.WrongCredentials, ErrorType.EmailDoesntExist, ErrorType.PasswordToSmall, ErrorType.InvalidDocumentNumber, ErrorType.InvalidZipCode, ErrorType.AddresNotSet, ErrorType.InvalidLocation, ErrorType.ShippingDateNotAvaiable, ErrorType.ShippingDistanceTooLarge, ErrorType.ShippingCityNotAvaiable, ErrorType.DeletedItem, ErrorType.AlreadyRegistered, ErrorType.NameTooSmall, ErrorType.NameTooLarge, ErrorType.NickAlreadyInUse, ErrorType.InvalidNick, ErrorType.InvalidBirthday, ErrorType.InvalidPhoneNumber, ErrorType.DocumentNumberUnavaiable, ErrorType.InvalidAddress, ErrorType.InvalidCardNumber, ErrorType.InvalidCvv, ErrorType.InvalidExpirationDate, ErrorType.InvalidCardHolderName, ErrorType.InvalidCard, ErrorType.CustomerIdDoesntExist, ErrorType.RecipientIdDoesntExist, ErrorType.PaymentNotApproved, ErrorType.ActionNotAllowed, ErrorType.UserDocumentsNotVerified, ErrorType.NoItemRefered, ErrorType.MessageAlreadySent, ErrorType.InvalidDistance, ErrorType.InvalidRentPrice, ErrorType.InvalidOriginalPrice, ErrorType.AlreadyRated, ErrorType.InvalidRate, ErrorType.InvalidPromotion, ErrorType.ExpiredPromotion, ErrorType.SaturatedPromotion, ErrorType.PromotionAlreadyUsed, ErrorType.Fatal, ErrorType.Connection];
}
exports.allValuesErrorType = allValuesErrorType;
function allTranslatedValuesErrorType() {
    return [translateErrorType(ErrorType.PaymentRefused), translateErrorType(ErrorType.InternalError), translateErrorType(ErrorType.TransferValueTooLow), translateErrorType(ErrorType.FailedToRefund), translateErrorType(ErrorType.InvalidAccountDv), translateErrorType(ErrorType.InvalidAgencyDv), translateErrorType(ErrorType.InvalidAccountNumber), translateErrorType(ErrorType.InvalidAgencyNumber), translateErrorType(ErrorType.InvalidBankCode), translateErrorType(ErrorType.NotFound), translateErrorType(ErrorType.NotLoggedIn), translateErrorType(ErrorType.MissingParameter), translateErrorType(ErrorType.AccessNotAllowed), translateErrorType(ErrorType.ValueTooLarge), translateErrorType(ErrorType.ValueTooSmall), translateErrorType(ErrorType.InvalidEmail), translateErrorType(ErrorType.DateUnavaiable), translateErrorType(ErrorType.PeriodTooSmall), translateErrorType(ErrorType.CardWalletEmpty), translateErrorType(ErrorType.DeletedCard), translateErrorType(ErrorType.UserDoesntExist), translateErrorType(ErrorType.ShouldUseThirdParty), translateErrorType(ErrorType.WrongPassword), translateErrorType(ErrorType.LoginError), translateErrorType(ErrorType.ThirdPartyAuthError), translateErrorType(ErrorType.WrongCredentials), translateErrorType(ErrorType.EmailDoesntExist), translateErrorType(ErrorType.PasswordToSmall), translateErrorType(ErrorType.InvalidDocumentNumber), translateErrorType(ErrorType.InvalidZipCode), translateErrorType(ErrorType.AddresNotSet), translateErrorType(ErrorType.InvalidLocation), translateErrorType(ErrorType.ShippingDateNotAvaiable), translateErrorType(ErrorType.ShippingDistanceTooLarge), translateErrorType(ErrorType.ShippingCityNotAvaiable), translateErrorType(ErrorType.DeletedItem), translateErrorType(ErrorType.AlreadyRegistered), translateErrorType(ErrorType.NameTooSmall), translateErrorType(ErrorType.NameTooLarge), translateErrorType(ErrorType.NickAlreadyInUse), translateErrorType(ErrorType.InvalidNick), translateErrorType(ErrorType.InvalidBirthday), translateErrorType(ErrorType.InvalidPhoneNumber), translateErrorType(ErrorType.DocumentNumberUnavaiable), translateErrorType(ErrorType.InvalidAddress), translateErrorType(ErrorType.InvalidCardNumber), translateErrorType(ErrorType.InvalidCvv), translateErrorType(ErrorType.InvalidExpirationDate), translateErrorType(ErrorType.InvalidCardHolderName), translateErrorType(ErrorType.InvalidCard), translateErrorType(ErrorType.CustomerIdDoesntExist), translateErrorType(ErrorType.RecipientIdDoesntExist), translateErrorType(ErrorType.PaymentNotApproved), translateErrorType(ErrorType.ActionNotAllowed), translateErrorType(ErrorType.UserDocumentsNotVerified), translateErrorType(ErrorType.NoItemRefered), translateErrorType(ErrorType.MessageAlreadySent), translateErrorType(ErrorType.InvalidDistance), translateErrorType(ErrorType.InvalidRentPrice), translateErrorType(ErrorType.InvalidOriginalPrice), translateErrorType(ErrorType.AlreadyRated), translateErrorType(ErrorType.InvalidRate), translateErrorType(ErrorType.InvalidPromotion), translateErrorType(ErrorType.ExpiredPromotion), translateErrorType(ErrorType.SaturatedPromotion), translateErrorType(ErrorType.PromotionAlreadyUsed), translateErrorType(ErrorType.Fatal), translateErrorType(ErrorType.Connection)];
}
exports.allTranslatedValuesErrorType = allTranslatedValuesErrorType;
function allDisplayableValuesErrorType() {
    return allTranslatedValuesErrorType().sort();
}
exports.allDisplayableValuesErrorType = allDisplayableValuesErrorType;
function valueFromTranslationErrorType(translation) {
    var index = allTranslatedValuesErrorType().indexOf(translation);
    return allValuesErrorType()[index] || ErrorType.PaymentRefused;
}
exports.valueFromTranslationErrorType = valueFromTranslationErrorType;

exports.getLocker = getLocker;

exports.getProfileStats = getProfileStats;

exports.uploadImage = uploadImage;

exports.uploadThumb = uploadThumb;

exports.getAddressFromCep = getAddressFromCep;

exports.getCpfValidate = getCpfValidate;

exports.getMyLocation = getMyLocation;

exports.registerUser = registerUser;

exports.login = login;

exports.loginThirdParty = loginThirdParty;

exports.linkWith = linkWith;

exports.setAvatar = setAvatar;

exports.setAddress = setAddress;

exports.addCard = addCard;

exports.removeCard = removeCard;

exports.setMainCard = setMainCard;

exports.setBankAccount = setBankAccount;

exports.setPersonalInfo = setPersonalInfo;

exports.changePassword = changePassword;

exports.sendResetPasswordLink = sendResetPasswordLink;

exports.resetPassword = resetPassword;

exports.logOut = logOut;

exports.transfer = transfer;

exports.getEmailAvaiable = getEmailAvaiable;

exports.getNickAvaiable = getNickAvaiable;

exports.getCards = getCards;

exports.getBalance = getBalance;

exports.getUserInfo = getUserInfo;

exports.getItems = getItems;

exports.getLiked = getLiked;

exports.getItem = getItem;

exports.addNewItem = addNewItem;

exports.editItem = editItem;

exports.deleteItem = deleteItem;

exports.setLike = setLike;

exports.requestItem = requestItem;

exports.performAction = performAction;

exports.getLocRequests = getLocRequests;

exports.getLocRequest = getLocRequest;

exports.getHistory = getHistory;

exports.getShippingPrice = getShippingPrice;

exports.getPendingLocRequests = getPendingLocRequests;

exports.getPromotion = getPromotion;

exports.sendMessage = sendMessage;

exports.sendImage = sendImage;

exports.setLastSeenMessage = setLastSeenMessage;

exports.getMessagesRooms = getMessagesRooms;

exports.getMessageRoom = getMessageRoom;

exports.getMessages = getMessages;

exports.rate = rate;

exports.getPendingRates = getPendingRates;

exports.getRating = getRating;

exports.getMyRating = getMyRating;

exports.shouldRequestNotificationPermission = shouldRequestNotificationPermission;

exports.getNotificationBadges = getNotificationBadges;

exports.taltToUs = taltToUs;

exports.getAutocomplete = getAutocomplete;

exports.getSearch = getSearch;

exports.getSearchUsers = getSearchUsers;

exports.getSearchItems = getSearchItems;

exports.ping = ping;

exports.setPushToken = setPushToken;
//////////////////////////////////////////////////////
var fallbackDeviceId = null;
function setDeviceId(deviceId) {
    fallbackDeviceId = deviceId;
    try {
        localStorage.setItem("deviceId", deviceId);
    } catch (e) {}
}
function getDeviceId() {
    try {
        return localStorage.getItem("deviceId") || fallbackDeviceId;
    } catch (e) {}
    return fallbackDeviceId;
}

function randomBytesHex(len) {
    var hex = "";
    for (var i = 0; i < 2 * len; ++i) {
        hex += "0123456789abcdef"[Math.floor(Math.random() * 16)];
    }
    return hex;
}
var listenersDict = {
    fail: [],
    fatal: [],
    success: []
};
function addEventListener(listenable, hook) {
    var listeners = listenersDict[listenable];
    listeners.push(hook);
}
exports.addEventListener = addEventListener;
function removeEventListener(listenable, hook) {
    var listeners = listenersDict[listenable];
    listenersDict[listenable] = listeners.filter(function (h) {
        return h !== hook;
    });
}
exports.removeEventListener = removeEventListener;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(54), __esModule: true };

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(2);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(56);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(69);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(57), __esModule: true };

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(32);
__webpack_require__(40);
module.exports = __webpack_require__(28).f('iterator');


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(20);
var defined = __webpack_require__(21);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(36);
var descriptor = __webpack_require__(17);
var setToStringTag = __webpack_require__(19);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(4)(IteratorPrototype, __webpack_require__(1)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(5);
var anObject = __webpack_require__(3);
var getKeys = __webpack_require__(24);

module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(13);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(9);
var toLength = __webpack_require__(38);
var toAbsoluteIndex = __webpack_require__(63);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(20);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(8);
var toObject = __webpack_require__(65);
var IE_PROTO = __webpack_require__(25)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(21);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(67);
var step = __webpack_require__(68);
var Iterators = __webpack_require__(12);
var toIObject = __webpack_require__(9);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(33)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(70), __esModule: true };

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71);
__webpack_require__(43);
__webpack_require__(77);
__webpack_require__(78);
module.exports = __webpack_require__(2).Symbol;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(0);
var has = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(7);
var $export = __webpack_require__(11);
var redefine = __webpack_require__(35);
var META = __webpack_require__(72).KEY;
var $fails = __webpack_require__(16);
var shared = __webpack_require__(26);
var setToStringTag = __webpack_require__(19);
var uid = __webpack_require__(18);
var wks = __webpack_require__(1);
var wksExt = __webpack_require__(28);
var wksDefine = __webpack_require__(29);
var enumKeys = __webpack_require__(73);
var isArray = __webpack_require__(74);
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(6);
var toIObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(23);
var createDesc = __webpack_require__(17);
var _create = __webpack_require__(36);
var gOPNExt = __webpack_require__(75);
var $GOPD = __webpack_require__(76);
var $DP = __webpack_require__(5);
var $keys = __webpack_require__(24);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(42).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(30).f = $propertyIsEnumerable;
  __webpack_require__(41).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(10)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(4)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(18)('meta');
var isObject = __webpack_require__(6);
var has = __webpack_require__(8);
var setDesc = __webpack_require__(5).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(16)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(24);
var gOPS = __webpack_require__(41);
var pIE = __webpack_require__(30);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(13);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(9);
var gOPN = __webpack_require__(42).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(30);
var createDesc = __webpack_require__(17);
var toIObject = __webpack_require__(9);
var toPrimitive = __webpack_require__(23);
var has = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(34);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('asyncIterator');


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(29)('observable');


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(43);
__webpack_require__(32);
__webpack_require__(40);
__webpack_require__(80);
__webpack_require__(92);
__webpack_require__(93);
module.exports = __webpack_require__(2).Promise;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(10);
var global = __webpack_require__(0);
var ctx = __webpack_require__(14);
var classof = __webpack_require__(45);
var $export = __webpack_require__(11);
var isObject = __webpack_require__(6);
var aFunction = __webpack_require__(15);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var speciesConstructor = __webpack_require__(46);
var task = __webpack_require__(47).set;
var microtask = __webpack_require__(87)();
var newPromiseCapabilityModule = __webpack_require__(31);
var perform = __webpack_require__(48);
var userAgent = __webpack_require__(88);
var promiseResolve = __webpack_require__(49);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(1)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(89)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(19)($Promise, PROMISE);
__webpack_require__(90)(PROMISE);
Wrapper = __webpack_require__(2)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(91)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(14);
var call = __webpack_require__(83);
var isArrayIter = __webpack_require__(84);
var anObject = __webpack_require__(3);
var toLength = __webpack_require__(38);
var getIterFn = __webpack_require__(85);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(3);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(12);
var ITERATOR = __webpack_require__(1)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(45);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(12);
module.exports = __webpack_require__(2).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var macrotask = __webpack_require__(47).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(13)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(0);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(4);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(0);
var core = __webpack_require__(2);
var dP = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(7);
var SPECIES = __webpack_require__(1)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(1)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(11);
var core = __webpack_require__(2);
var global = __webpack_require__(0);
var speciesConstructor = __webpack_require__(46);
var promiseResolve = __webpack_require__(49);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(11);
var newPromiseCapability = __webpack_require__(31);
var perform = __webpack_require__(48);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(95);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(96);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(44);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.19
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.19',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga)\/((\d+)?[\w\.]+)/i                              // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)\s/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [
            /(mz)-([\w-]{2,})/i                                                 // Meizu Phone
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(99)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(101);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(105)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js??ref--1-2!../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js??ref--1-2!../../node_modules/sass-loader/lib/loader.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(102);
exports = module.exports = __webpack_require__(103)(false);
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: Abel;\n  src: local(\"Abel\"), local(\"Abel-Regular\"), local(\"Abel Regular\"), url(" + escape(__webpack_require__(104)) + "); }\n\n@-webkit-keyframes shake {\n  0%, 100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0); }\n  20%, 60% {\n    -webkit-transform: translateX(-5px);\n            transform: translateX(-5px); }\n  40%, 80% {\n    -webkit-transform: translateX(5px);\n            transform: translateX(5px); } }\n\n@keyframes shake {\n  0%, 100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0); }\n  20%, 60% {\n    -webkit-transform: translateX(-5px);\n            transform: translateX(-5px); }\n  40%, 80% {\n    -webkit-transform: translateX(5px);\n            transform: translateX(5px); } }\n\n.shakeAnimation {\n  -webkit-animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n          animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  -webkit-perspective: 1000px;\n          perspective: 1000px; }\n\nbody {\n  width: 100vw;\n  height: 100vh;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: rgba(0, 0, 0, 0.1); }\n  body, body * {\n    font-family: Abel; }\n  body form {\n    background-color: white;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    border-radius: .1em;\n    overflow: hidden;\n    -webkit-box-align: stretch;\n        -ms-flex-align: stretch;\n            align-items: stretch;\n    padding: 0.6em 0.4em; }\n    body form > *:not(:last-child) {\n      margin-bottom: 0.5rem; }\n    body form h4 {\n      padding: 0 1em;\n      font-weight: normal; }\n    body form .image {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      padding: 1.1em 0;\n      margin-top: -0.6em;\n      margin-left: -0.4em;\n      margin-right: -0.4em;\n      margin-bottom: 1em; }\n      body form .image img {\n        height: 140px; }\n    body form .password_label {\n      margin-left: -0.5rem;\n      margin-right: -0.5rem;\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box; }\n      body form .password_label.invalid input {\n        border-color: #A63232; }\n      body form .password_label > * {\n        margin-left: 0.5rem;\n        margin-right: 0.5rem; }\n\n.flash {\n  padding: .2em .3em;\n  color: #A63232;\n  text-align: center; }\n\n.hidden {\n  display: none !important; }\n", ""]);

// exports


/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 103 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "75e8975966c040d18b299029193d3b1f.ttf";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(106);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 106 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.6c98a69.js